(function() {
  'use strict';

  angular
    .module('website', [
      'adaptiveTemplating',
      'afkl.lazyImage',
      'angular-google-analytics',
      'config',
      'duScroll',
      'me-lazyload',
      'ng-token-auth',
      'ngAnimate',
      'ngNotify',
      'ngResource',
      'ngStorage',
      'ui.bootstrap',
      'ui.router',
      'uiGmapgoogle-maps',
    ]);

})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('stopEvent', stopEvent);

  /* @ngInject */
  function stopEvent() {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attr) {
      element.on(attr.stopEvent, function (e) {
        e.stopPropagation();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .filter('phone', phone);

  /* @ngInject */
  function phone() {
    var filter = function(input) {
      var result = ('' + input)
      .replace(/[\s\uFEFF\xA0]+/g, '')
      .match(/(\+\d{3})(\d{4})(\d{4})/);

      if (result && result.length > 3) {
        return result[1] + ' ' + result[2] + ' ' + result[3];
      } else {
        return '';
      }
    };

    return filter;
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('onSlideChange', onSlideChange);

  /* @ngInject */
  function onSlideChange($parse) {
    // Usage:
    // for angular ui bootstrap carousel
    // Creates:
    //
    var directive = {
      link: link,
      require: 'carousel',
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, carouselController) {
      var fn = $parse(attrs.onSlideChange);
      var origSelect = carouselController.select;
      carouselController.select = function(nextSlide, direction, nextIndex) {
        if (nextSlide !== this.currentSlide) {
          nextIndex = this.getCurrentIndex();
          nextIndex += direction === 'next' ? 1 : -1;
          fn(scope, {
            nextSlide: nextSlide,
            direction: direction,
            nextIndex: nextIndex
          });
        }
        return origSelect.apply(this, arguments);
      };
    }
  }
})();
(function() {
  'use strict';
  angular.module("ngLocale", [], ["$provide", function($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": [
          "a. m.",
          "p. m."
        ],
        "DAY": [
          "domingo",
          "lunes",
          "martes",
          "mi\u00e9rcoles",
          "jueves",
          "viernes",
          "s\u00e1bado"
        ],
        "ERANAMES": [
          "antes de Cristo",
          "despu\u00e9s de Cristo"
        ],
        "ERAS": [
          "a. C.",
          "d. C."
        ],
        "FIRSTDAYOFWEEK": 0,
        "MONTH": [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre"
        ],
        "SHORTDAY": [
          "dom.",
          "lun.",
          "mar.",
          "mi\u00e9.",
          "jue.",
          "vie.",
          "s\u00e1b."
        ],
        "SHORTMONTH": [
          "ene.",
          "feb.",
          "mar.",
          "abr.",
          "may.",
          "jun.",
          "jul.",
          "ago.",
          "sept.",
          "oct.",
          "nov.",
          "dic."
        ],
        "WEEKENDRANGE": [
          5,
          6
        ],
        "fullDate": "EEEE, d 'de' MMMM 'de' y",
        "longDate": "d 'de' MMMM 'de' y",
        "medium": "dd-MM-y h:mm:ss a",
        "mediumDate": "dd-MM-y",
        "mediumTime": "h:mm:ss a",
        "short": "dd-MM-yy h:mm a",
        "shortDate": "dd-MM-yy",
        "shortTime": "h:mm a"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "$",
        "DECIMAL_SEP": ",",
        "GROUP_SEP": ".",
        "PATTERNS": [
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 3,
            "minFrac": 0,
            "minInt": 1,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
          },
          {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 2,
            "minInt": 1,
            "negPre": "\u00a4-",
            "negSuf": "",
            "posPre": "\u00a4",
            "posSuf": ""
          }
        ]
      },
      "id": "es-cl",
      "pluralCat": function(n) {  if (n === 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
    });
  }]);
})();
(function() {
  'use strict';

  angular
    .module('website')
    .directive('headerCart', headerCart);

  /* @ngInject */
  function headerCart() {
    // Usage:
    //  <header-cart/>
    // Creates:
    //  adds a header with a cart counter
    var directive = {
      bindToController: true,
      controller: Controller,
      controllerAs: 'cart',
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/header-cart/{mobile}{desktop}/header-cart.html'
    };
    return directive;

    function link(scope, element, attrs) {
      scope.backState = attrs.backState;
    }
  }

  /* @ngInject */
  function Controller (cart, $uibModal, $rootScope, $state) {
    this.href = $state.href;
    this.cartState = cartState;
    this.logoutModal = logoutModal;

    Object.defineProperty(this, 'count', {
      get: function() {
        return cart.count;
      }
    });

    function cartState() {
      var state = 'menu';
      if (cart.count) {
        state = 'cart.products';
      }
      return state;
    }

    var modalInstance;

    function logoutModal() {
      if (modalInstance) {
        modalInstance.close();
        modalInstance = null;
        return;
      }

      modalInstance = $uibModal.open({
        size: 'logout',
        controller: 'ProfileController as profile',
        templateUrl: 'app/profile/desktop/logout.html'
      });

      var onLogin = $rootScope.$on('auth:logout-success', function() {
        modalInstance.close();
        onLogin();
      });

      return modalInstance;
    }
    
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .directive('footerCart', footerCart);

  /* @ngInject */
  function footerCart() {
    // Usage:
    //  <footer-cart/>
    // Creates:
    //  adds a footer
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer-cart/{mobile}{desktop}/footer-cart.html'
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .service('customer', customer);

  /* @ngInject */
  function customer() {
    this.get = get;
    this.set = set;

    ////////////////

    var currentCustomer = null;

    function get() {
      return currentCustomer;
    }

    function set(newCustomer) {
      currentCustomer = newCustomer;
      return currentCustomer;
    }
  }
})();
angular.module("config", [])

.constant("env", {
	"BASE_URL": "https://niusushi.cl",
	"API_URL": "https://api.niusushi.cl/api/v1/",
	"NG_TOKEN_AUTH_URL": "https://api.niusushi.cl",
	"RESTAURANT_ID": "bac25cf7-9a62-4283-9156-243225f536ec"
})

;
(function() {
  'use strict';

  angular
    .module('website')
    .service('cart', cart);

  /* @ngInject */
  function cart(api, _, $localStorage, $q) {
    var service = this;
    this.add = add;
    this.chopsticks = {};
    this.chopsticks.calculate = chopsticksCalculate;
    this.chopsticks.get = chopsticksGet;
    this.chopsticks.set = chopsticksSet;
    this.count = 0;
    this.discount = discount;
    this.get = get;
    this.ginger = {};
    this.ginger.get = gingerGet;
    this.ginger.set = gingerSet;
    this.isDelivery = false;
    this.price = price;
    this.products = products;
    this.remove = remove;
    this.save = save;
    this.setDiscount = setDiscount;
    this.setSeleableProperty = setSeleableProperty;
    this.soySauce = {};
    this.soySauce.calculate = soySauceCalculate;
    this.soySauce.get = soySauceGet;
    this.soySauce.set = soySauceSet;
    this.total = total;
    this.totalDiscount = totalDiscount;
    this.wasabi = {};
    this.wasabi.get = wasabiGet;
    this.wasabi.set = wasabiSet;

    var items = {
      products: {},
      promotions: {}
    };
    activate();

    function activate() {
      $q.all([api.products.all(), api.promotions.all()])
      .then(function() {
        // load items from LS
        if ($localStorage.cartServiceItems) {
          items = $localStorage.cartServiceItems;
        }
        if (!(items.products || items.promotions)) {
          throw 'LS cart is not valid';
        }
        service.count = 0;
        _.each(items, function(seleableItems, type) {
          var setSeleablePropertyCurried = _.curry(setSeleableProperty)(_, type);
          // add 'seleable' property to every item
          _.each(seleableItems, function(itemList) {
            _.each(itemList, setSeleablePropertyCurried);
          });
          // count
          service.count += _.map(seleableItems, function(itemList, id) {
            if (type === 'products' && service.price(id, true, type) === 0) {
              return 0;
            } else {
              return service.get(id, null, type);
            }
          }).reduce(_.add, 0);
        });
        service.save();
      }).catch(function() {
        items = $localStorage.cartServiceItems = {
          products: {},
          promotions: {}
        };
        service.count = 0;
      });
    }

    function save() {
      // remove old entries
      var MS_PER_HOUR = 1000 * 60 * 60,
        now = Date.now();
      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          _.remove(itemList, function(item) {
            var updatedAt = item.updatedAt || item.addedAt;
            if ((now - updatedAt) / MS_PER_HOUR > 2) {
              if (type !== 'products' || service.price(id, true, type) !== 0) {
                service.count -= item.quantity;
              }
              return true;
            }
          });
        });
      });

      $localStorage.cartServiceItems = items;
    }

    function setSeleableProperty(item, type) {
      if (item.seleable) {
        return;
      }
      Object.defineProperty(item, 'seleable', {
        get: function() {
          return api[type].get(item.id);
        }
      });
    }

    function add(id, quantity, options, type) {
      quantity = quantity ? quantity : 1;
      options = options ? options : {};
      type = type ? type : 'products';

      var itemList = items[type][id] || [];
      var item, i;
      for (i = 0; i < itemList.length; i++) {
        if (_.eq(itemList[i].options, options)) {
          item = itemList[i];
          break;
        }
      }

      if (item) {
        item.quantity += quantity;
        item.updatedAt = Date.now();
      } else {
        item = {
          id: id,
          quantity: quantity,
          options: options,
          addedAt: Date.now(),
          updatedAt: Date.now()
        };
        setSeleableProperty(item, type);

        if (!items[type][id]) {
          items[type][id] = [];
        }
        items[type][id].push(item);
      }

      service.save();

      if (!(type === 'products' && service.price(id, true, type) === 0)) {
        service.count += quantity;
      }
      return service.get(id, options, type);
    }

    function get(id, options, type) {
      type = type ? type : 'products';

      var itemList = (items[type][id] || []);
      if (options) {
        var item = _.find(itemList, {options: options});
        return item ? item.quantity : 0;
      }
      
      return itemList.map(function(item) {
        return item.quantity;
      }).reduce(_.add, 0);
    }

    function remove(id, quantity, options, type) {
      quantity = quantity ? quantity : 1;
      options = options ? options : {};
      type = type ? type : 'products';

      var itemList = items[type][id] || [];
      var item, i;
      for (i = 0; i < itemList.length; i++) {
        if (_.eq(itemList[i].options, options)) {
          item = itemList[i];
          break;
        }
      }

      if (!item) {
        return;
      }

      quantity = Math.min(quantity, item.quantity);

      item.quantity -= quantity;
      item.updatedAt = Date.now;
      if (!(type === 'products' && service.price(id, true, type) === 0)) {
        service.count -= quantity;
      }

      if (item.quantity === 0) {
        itemList.splice(i, 1);
        if (itemList.length) {
          items[type][id] = itemList;
        } else {
          delete items[type][id];
        }
      }

      save();
    }

    var genericTotal = function(applyDiscount) {
      var prices = [],
        quantities = [];

      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          itemList.forEach(function(item) {
            prices.push(service.price(id, applyDiscount, type));
            quantities.push(item.quantity);
          });
        });
      });

      return prices.map(function(price, i) {
        return price * quantities[i];
      }).reduce(_.add, service.isDelivery ? 1500 : 0);
    };

    function total() {
      return genericTotal(false);
    }

    function totalDiscount() {
      return genericTotal(true);
    }

    var currentDiscount = 0.5;

    function discount() {
      return currentDiscount;
    }

    function setDiscount(newDiscount) {
      currentDiscount = newDiscount;
      return currentDiscount;
    }

    function soyByProduct(product, quantity) {
      var soyNumber = 0,
        firstCategory = _.get(product, 'modules.website.categories[0]');

      switch(firstCategory) {
        case 'Special Rolls':
        case 'Nikkei Rolls':
        case 'Tempura & Panko Rolls':
        case 'California Rolls':
        case 'Chirashis':
        case 'Veggie Rolls':
        case 'Sashimis & Ceviches':
        case 'Hosomaki & Nigiri':
          soyNumber = quantity * 0.5;
          break;
        case 'Salsas Extras':
        case 'Para Picar':
          if (product.servings) {
            soyNumber = quantity * 0.2;
          }
          break;
      }

      return soyNumber;
    }

    function soySauceCalculate() {
      var soyNumber = 0;
      _.each(items, function(seleableItems) {
        _.each(seleableItems, function(itemList) {
          _.each(itemList, function(item) {
            // is it a product?
            var seleable = item.seleable;
            if (seleable.type === 'products') {
              soyNumber += soyByProduct(seleable, item.quantity);
            } else
            // is it a promotions?
            if (seleable.type === 'promotions') {
              _.each(seleable.products, function(product) {
                soyNumber += soyByProduct(product, item.quantity);
              });
            }
          });
        });
      });
      
      return Math.max(1, Math.round(soyNumber));
    }

    function chopsticksByProduct(product, quantity) {
      var chopsticksNumber = 0,
        firstCategory = _.get(product, 'modules.website.categories[0]');

      switch(firstCategory) {
        case 'Special Rolls':
        case 'Nikkei Rolls':
        case 'Tempura & Panko Rolls':
        case 'California Rolls':
        case 'Chirashis':
        case 'Veggie Rolls':
        case 'Sashimis & Ceviches':
        case 'Hosomaki & Nigiri':
          chopsticksNumber = quantity * 0.66;
          break;
        case 'Postres & Bebidas':
          if (product.servings) {
            chopsticksNumber = quantity;
          }
          break;
        case 'Salsas Extras':
        case 'Para Picar':
          if (product.servings) {
            chopsticksNumber = quantity * 0.3;
          }
          break;
      }

      return chopsticksNumber;
    }


    function chopsticksCalculate() {
      var chopsticksNumber = 0;
      _.each(items, function(seleableItems) {
        _.each(seleableItems, function(itemList) {
          _.each(itemList, function(item) {
            // is it a product?
            var seleable = item.seleable;
            if (seleable.type === 'products') {
              chopsticksNumber += chopsticksByProduct(seleable, item.quantity);
            } else
            // is it a promotions?
            if (seleable.type === 'promotions') {
              _.each(seleable.products, function(product) {
                chopsticksNumber += chopsticksByProduct(product, item.quantity);
              });
            }
          });
        });
      });
      
      return Math.max(1, Math.round(chopsticksNumber));
    }

    function chopsticksGet() {
      var chopsticks = api.products.get({ name: 'Palitos' });
      return service.get(chopsticks.id);
    }

    function chopsticksSet(normal, special) {
      normal = normal ? normal : chopsticksCalculate();
      special = special ? special : 0;
      var newValue = normal + special;

      var chopsticks = api.products.get({ name: 'Palitos' }),
        oldValue = service.get(chopsticks.id);

      if (oldValue < newValue) {
        service.add(chopsticks.id, newValue - oldValue);
      } else
      if (newValue < oldValue) {
        service.remove(chopsticks.id, oldValue - newValue);
      }
      
      return newValue;
    }

    function gingerGet() {
      var ginger = api.products.get({ name: 'Gengibre' });
      return service.get(ginger.id) > 0;
    }

    function gingerSet(addGinger) {
      var ginger = api.products.get({ name: 'Gengibre' }),
        oldValue = service.get(ginger.id),
        newValue;

      if (addGinger && oldValue === 0) {
        newValue = service.add(ginger.id, 1);
      } else 
      if (!addGinger && oldValue === 1) {
        newValue = service.remove(ginger.id, 1);
      } else {
        newValue = oldValue;
      }

      return newValue > 0;
    }

    function wasabiGet() {
      var wasabi = api.products.get({ name: 'Wasabi' });
      return service.get(wasabi.id) > 0;
    }

    function wasabiSet(addWasabi) {
      var wasabi = api.products.get({ name: 'Wasabi' }),
        oldValue = service.get(wasabi.id),
        newValue;

      if (addWasabi && oldValue === 0) {
        newValue = service.add(wasabi.id, 1);
      } else 
      if (!addWasabi && oldValue === 1) {
        newValue = service.remove(wasabi.id, 1);
      } else {
        newValue = oldValue;
      }

      return newValue > 0;
    }


    function soySauceGet() {
      var soySauce = api.products.get({ name: 'Salsa De Soya' });
      return service.get(soySauce.id);
    }

    function soySauceSet(soySauceQuantity) {
      var newValue = soySauceQuantity ? soySauceQuantity : soySauceCalculate();

      var soySauce = api.products.get({ name: 'Salsa De Soya' });
      var oldValue = service.get(soySauce.id);

      if (oldValue < newValue) {
        service.add(soySauce.id, newValue - oldValue);
      } else
      if (newValue < oldValue) {
        service.remove(soySauce.id, oldValue - newValue);
      }
      
      return newValue;
    }

    function price(id, applyDiscount, type) {
      type = type ? type : 'products';
      var seleable = api[type].get(id);
      var p = seleable.normal_price;
      if (applyDiscount && seleable.discount) {
        p *= (1 - service.discount());
      }
      return p;
    }

    // TODO: rename to seleables()
    function products(includeAll) {
      var allProducts = [];
      _.each(items, function(seleableItems, type) {
        _.each(seleableItems, function(itemList, id) {
          var costZero = type === 'products' &&
            service.price(id, true, type) === 0;
          if (!includeAll && costZero) {
            return;
          }
          _.each(itemList, function(item) {
            allProducts.push(item);
          });
        });
      });

      return allProducts.sort(function(item1, item2) {
        return item1.addedAt > item2.addedAt;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .service('api', api);

  /* @ngInject */
  function api($resource, env, _) {
    //var service = this;
    this.addresses = {};
    this.addresses.all = addressesAll;
    this.addresses.save = addressesSave;
    this.comunes = {};
    this.comunes.all = comunesAll;
    this.prefs = {};
    this.prefs.all = prefsAll;
    this.prefs.get = prefsGet;
    this.prefs.set = prefsSet;
    this.products = {};
    this.products.all = productsAll;
    this.products.get = productsGet;
    this.products.like = productsLike;
    this.products.reset = productsReset;
    this.products.setPreference = setPrefsForProduct;
    this.promotions = {};
    this.promotions.all = promotionsAll;
    this.promotions.get = promotionsGet;
    this.promotions.setPreference = promotionsSetPreference;
    this.orders = {};
    this.orders.get = ordersGet;
    this.orders.save = ordersSave;
    this.orders.feedback = ordersFeedback;
    this.restaurants = {};
    this.restaurants.all = restaurantsAll;
    this.restaurants.get = restaurantsGet;
    this.restaurants.timesAverage = timesAverage;
    this.restaurants.externalPolygon = externalPolygon;

    ////////////////

    var Prefs = $resource(env.API_URL + 'preferences', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      set: {
        method: 'POST',
        isArray: false
      }
    });
    var prefs = {};
    var prefsPromise;
    function prefsAll(force) {
      if (force) {
        prefsPromise = null;
      }
      if (!prefsPromise) {
        prefsPromise = Prefs.query({}).$promise;
      }
      return prefsPromise.then(function(prefsObject) {
        _.extend(prefs, prefsObject);
        return prefsObject;
      });
    }
    function prefsGet(attr) {
      if (Object.keys(prefs).length === 0) {
        throw 'Must call "api.prefs.all()" before calling ' + 
          '"api.prefs.get(:attr)", with attr: "' + attr +'".';
      }
      return prefs[attr];
    }
    function prefsSet() {
      var postData = {},
        valid = true;
        switch (arguments.length) {
          case 1:
            postData = arguments[0];
            break;
          case 2:
            var attr = arguments[0],
              value = arguments[1];
              postData[attr] = value;
              break;
            default:
              valid = false;
        }
        if (valid) {
          return Prefs.set(postData).$promise;
        } else {
          throw 'Must call "api.prefs.set(attr:string, value)" or ' + 
            '"api.prefs.set(attrs:Object)".';
        }
    }


    var Product = $resource(env.API_URL + 'products/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'products?module=website',
        transformResponse: function(data) {
          return angular.fromJson(data).products;
        }
      },
      set: {
        method: 'POST',
        url: env.API_URL + 'products/:id',
      }
    });
    var products = {};
    var specialProducts = {
      'Salsa De Soya': null,
      'Palitos': null,
      'Palitos con ayuda': null,
      'Wasabi': null,
      'Gengibre': null
    };
    var productsPromise;
    function setPrefsForProduct(product, preference) {
      // force to reload products
      productsPromise = null;
      var postData = {
        preference: preference
      };
      return Product.set({id: product.id}, postData).$promise;
    }
    function productsAll(force) {
      if (force) {
        productsPromise = null;
      }
      if (!productsPromise) {
        productsPromise = Product.query({}).$promise;
      }
      return productsPromise
      .then(function(productsList) {
        if (force || _.isEmpty(products)) {
          productsList.forEach(function(p) {
            p.type = 'products';
            products[p.id] = p;

            if (p.name in specialProducts) {
              specialProducts[p.name] = p;
            }
          });
        }
        return productsList;
      });
    }
    function productsGet(product) {
      if (Object.keys(products).length === 0) {
        throw 'Must call "api.products.all()" before calling ' + 
          '"api.products.get(:id)", with id: "' + product +'".';
      } else
        if (_.isString(product)) {
          return products[product];
        } else
          if (_.isObject(product) && product.name) {
            return specialProducts[product.name];
          }
    }
    function productsLike(product) {
      return setPrefsForProduct(product, 1);
    }
    function productsReset(product) {
      return setPrefsForProduct(product, 0);
    }


    var Promotion = $resource(env.API_URL + 'promotions/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).promotions;
        }
      },
      set: {
        method: 'POST',
        url: env.API_URL + 'promotions/:id',
      }
    });
    var promotions = {};
    var promotionsPromise;
    function promotionsAll(force) {
      if (force || !promotionsPromise) {
        promotionsPromise = Promotion.query({}).$promise;
      }
      return promotionsPromise
      .then(function(promotionsList) {
        if (force || _.isEmpty(promotions)) {
          _.each(promotionsList, function(p) {
            p.type = 'promotions';
            promotions[p.id] = p;
          });
        }
        return promotionsList;
      });
    }
    function promotionsGet(promotionId) {
      if (Object.keys(promotions).length === 0) {
        throw 'Must call "api.promotions.all()" before calling ' + 
          '"api.promotions.get(:id)", with id: "' + promotionId +'".';
      }
      return promotions[promotionId];
    }
    function promotionsSetPreference(promotion, preference) {
      // force to reload promotions
      promotionsPromise = null;
      var postData = {
        preference: preference
      };
      return Promotion.set({id: promotion.id}, postData).$promise;
    }


    var Restaurants = $resource(env.API_URL + 'restaurants', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).restaurants;
        }
      },
      timesAverage: {
        method: 'GET',
        url: env.API_URL + 'restaurants/times_average'
      },
      externalPolygon: {
        method: 'GET',
        isArray: true,
        url: env.API_URL + 'restaurants/external_polygon'
      }
    });
    var restaurants = {};
    var restaurantsPromise;
    function restaurantsAll(force) {
      if (force || !restaurantsPromise) {
        restaurantsPromise = Restaurants.query({}).$promise;
      }
      return restaurantsPromise
      .then(function(restaurantsList) {
        if (_.isEmpty(restaurants)) {
          _.each(restaurantsList, function(r) {
            restaurants[r.id] = r;
          });
        }
        return restaurantsList;
      });
    }
    function restaurantsGet(id) {
      return restaurants[id];
    }
    function timesAverage() {
      return Restaurants.timesAverage().$promise;
    }
    function externalPolygon() {
      return Restaurants.externalPolygon().$promise;
    }


    var Addresses = $resource(env.API_URL + 'addresses/:id', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).addresses.map(function(a) {
            a.address = a.street_name + ' #' + a.street_number;
            if (a.specific_number) {
              a.address += ' ' + a.specific_number;
            }
            a.address +=  ', ' + a.comune_name;
            return a;
          });
        }
      },
      update: { method:'PUT' }
    });
    function addressesAll() {
      return Addresses.query({}).$promise;
    }
    function addressesSave(address) {
      var id = address.id;
      if (id) {
        return Addresses.update({id: id}, address).$promise;
      } else {
        var a = new Addresses(address);
        return a.$save();
      }
    }

    var Orders = $resource(env.API_URL + 'orders/:id', {}, {
      get: {
        method: 'GET',
        transformResponse: function(data) {
          return angular.fromJson(data).order;
        }
      },
      update: { method: 'PUT' },
      feedback: {
        method: 'POST',
        url: env.API_URL + 'orders/:id/feedback'
      }
    });
    function ordersGet(order) {
      return Orders.get({ id: order }).$promise;
    }
    function ordersSave(order) {
      var id = order.id;
      if (id) {
        return Orders.update({id: id}, order).$promise;
      } else {
        var o = new Orders(order);
        return o.$save();
      }
    }
    function ordersFeedback(order, feedback) {
      var formattedFeedback = {};
      _.each(feedback, function(value, key) {
        if (value === 'yes' || value === 'no') {
          value = value === 'yes';
        }
        formattedFeedback[_.snakeCase(key)] = value;
      });
      return Orders.feedback({ id: order.id }, formattedFeedback).$promise;
    }

    var Comunes = $resource(env.API_URL + 'comunes', {}, {
      query: {
        method: 'GET',
        isArray: true,
        transformResponse: function(data) {
          return angular.fromJson(data).comunes;
        }
      }
    });

    function comunesAll() {
      return Comunes.query({}).$promise;
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('SeleableController', SeleableController);

  /* @ngInject */
  function SeleableController(api, cart, customer, makeSelection, seleable, category,  _, $uibModalInstance, $timeout) {
    var vm = this;
    vm.addedUpselling = false;
    vm.addToCart = addToCart;
    vm.cancel = cancel;
    vm.carouselInterval = 6000;
    vm.category = category;
    vm.changeSeleable = changeSeleable;
    vm.currentIndex = 0;
    vm.customer = customer.get();
    vm.getUpselling = null;
    vm.images = [];
    vm.makeSelection = makeSelection;
    vm.onSelectionChange = onSelectionChange;
    vm.price = price;
    vm.product = null;
    vm.productSelections = {};
    vm.promotion = null;
    vm.promotionSelections = [];
    vm.toggleLike = toggleLike;
    vm.currentImage = {};

    activate();
    ////////////////

    function activate() {
      vm.images[0] = {
        src: seleable.image.medium,
        lazy: seleable.image.medium
      };
      vm.getUpselling = api.products.get.bind(api, seleable.upselling);
      vm.currentImage = vm.images[0];

      var products = seleable.products;
      if (products) {
        // it is a promotion
        vm.promotion = seleable;
        _.each(products, function(product) {
          product = api.products.get(product.id);
          if (product) {
            vm.images.push({
              src: product.image.medium,
              lazy: product.image.medium,
              text: product.name
            });
          }
        });
      } else {
        vm.product = seleable;
        vm.pref = vm.product.preference;
      }

      vm.pref = seleable.preference || 0;

      if (vm.makeSelection) {
        // try to add to cart, so the reminder appears
        addToCart();
      }
    }

    function setNextProduct(products) {
      vm.product = _.find(products, function(product, i) {
        if (!_.isEmpty(product.product_options) && !vm.promotionSelections[i]) {
          var multiple = false;
          var options = Object.keys(product.product_options);
          vm.promotionSelections[i] = {};
          options.forEach(function(option, index){
            if (product.product_options[option].length > 1){
              multiple = true;
            } else if (product.product_options[option].length == 1) {
              vm.promotionSelections[i][option] = product.product_options[option][0]
            }
          });
          if (multiple) {
            vm.currentIndex = i;
            return true;
          }
        }
        return false;
      });
      if(vm.product) { vm.pref = vm.product.preference; }
      vm.currentImage = vm.images[vm.currentIndex + 1];
    }

    function addToCart() {
      if (vm.promotion) {
        vm.makeSelection = true;

        if (!_.isEmpty(vm.productSelections)) {
          angular.extend(vm.promotionSelections[vm.currentIndex], vm.productSelections);
          vm.productSelections = {};
        }
        setNextProduct(vm.promotion.products);

        if (!vm.product) {
          // ready to add to the cart
          cart.add(seleable.id, 1, vm.promotionSelections, seleable.type);
          $uibModalInstance.close();
          return true;
        }
      }

      // if we are here, we got a product
      var productOptions = vm.product.product_options;
      if (productOptions) {
        vm.reminder = _.findKey(productOptions, function(options, name) {
          if (!vm.productSelections[name]) {
            return name;
          }
        });
      }

      if (vm.reminder) {
        vm.reminder = vm.reminder.toLowerCase();
        return false;
      }
      
      cart.add(seleable.id, 1, vm.productSelections, seleable.type);
      if (vm.addedUpselling) {
        cart.add(seleable.upselling, 1, seleable.upselling.type);
      }
      $uibModalInstance.close();
      return true;
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function changeSeleable(direction) {
      var seleablesList = vm.category.seleables;
      var index = _.findIndex(seleablesList, seleable);
      index += direction === 'next' ? 1 : -1;
      if (0 <= index && index < seleablesList.length) {
        seleable = seleablesList[index];
        activate();
      }
    }

    function toggleLike() {
      var setPreference = vm.product ? api.products.setPreference :
                                 api.promotions.setPreference;
      var all = vm.product ? api.products.all :
                                api.promotions.all;
      var product = vm.product || seleable;
      var newPref = vm.pref ? 0 : 1;
      var updateLike = setPreference(product, newPref);
      vm.pref = newPref;
      updateLike.then(function() {
        all(true);
      });
    }


    function price(seleable, applyDiscount) {
      return cart.price(seleable.id, applyDiscount, seleable.type);
    }

    function onSelectionChange() {
      if (!vm.makeSelection) {
        return;
      }


      $timeout(addToCart, 40);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('RestaurantsController', RestaurantsController);

  /* @ngInject */
  function RestaurantsController(api, ngNotify, _, $log, $rootScope) {
    var vm = this;
    vm.activate = activate;
    vm.mapOptions = {};
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapOptions.zoom = $rootScope.deviceType === 'mobile' ? 12 : 12;
    vm.restaurants = [];
    vm.selected = null;
    vm.onSlideChange = onSlideChange;
    vm.onMarkerClick = onMarkerClick;
    vm.polygons = [];

    activate();
    getPolygon();

    ////////////////

    function activate() {
      return api.restaurants.all()
      .then(function(restaurants) {
        _.each(restaurants, function(restaurant) {
          restaurant.icon = 'assets/images/titled-icon-nocache1.png';
        });
        vm.restaurants = restaurants;
        var i = $rootScope.deviceType === 'mobile' ? 4 : 4;
        vm.selected = restaurants[i];
        onSlideChange(0, 0, i);
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
      });
    }

    function getPolygon(){
      return api.restaurants.externalPolygon()
      .then(function(polygons){
        vm.polygons = polygons;
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
      });
    }

    function onMarkerClick(marker, eventName, restaurant) {
      onSlideChange(0, 0, _.findIndex(vm.restaurants, restaurant));
    }

    function onSlideChange(nextSlide, direction, nextIndex) {
      if (0 <= nextIndex && nextIndex < vm.restaurants.length) {
        vm.selected.icon = 'assets/images/titled-icon-nocache1.png';
        vm.selected = vm.restaurants[nextIndex];
        vm.selected.icon = 'assets/images/titled-icon-active-nocache1.png';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ProfileController', ProfileController);

  /* @ngInject */
  function ProfileController(api, customer, ngNotify, _, $auth, $state, $localStorage, $log, $rootScope, $window, $uibModal, $templateCache) {
    var vm = this;
    vm.addresses = [];
    vm.info = null;
    vm.genders = ['masculino', 'femenino'];
    vm.phones = null;
    vm.phoneRegex = /^[1-9](\s*\d){7}$/;
    vm.saveProfile = saveProfile;
    vm.signOut = signOut;
    vm.newAddressModal = newAddressModal;
    vm.deactivateAddress = deactivateAddress;

    activate();

    ////////////////

    function deactivateAddress(address) {
      var templateUrl = 'app/address/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressConfirmationModalController',
        controllerAs: 'confirmation',
        resolve: {
          address: function () {
            return address;
          }
        }
      };
      if (template){
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if(confirmed){
          address.active = false;
          return api.addresses.save(address)
          .then(function(data) {
            api.addresses.all()
            .then(function(addresses) {
              vm.addresses = addresses;
            });
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu dirección. Intenta más tarde.';
            ngNotify.set(msg, 'error');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function activate() {
      var auth = customer.get();
      // pass a Date object
      var date = auth.birthdate;
      if (date && _.isString(date)) {
        date = date.split('-');
        auth.birthdate = new Date();
        auth.birthdate.setYear(date[0]);
        auth.birthdate.setMonth(+date[1] - 1, date[2]);
      }
      vm.info = auth;
      var prefixRegex = /\+\s*5\s*6\s*\d\s*/;
      vm.phones = _(vm.info.phones).filter().map(function(phone) {
        return {
          prefix: phone.match(prefixRegex)[0],
          number: phone.replace(prefixRegex, '')
        };
      }).value();
      if (!vm.phones[1]) {
        vm.phones[1] = { prefix: '+562' };
      }
      api.addresses.all()
      .then(function(addresses) {
        vm.addresses = addresses;
      })
      .catch(onError);
    }

    function saveProfile(profile) {
      vm.info.phones = _(vm.phones).filter('number').map(function(phone) {
        return phone.prefix + phone.number;
      }).value();

      api.prefs.set(profile)
      .then(function() {
        ngNotify.set('¡Guardado!');
      })
      .catch(onError);
    }

    function signOut() {
      $auth.signOut()
      .then(function() {
        customer.set(null);
        $localStorage.$reset();
        $window.location.href = '/';
      })
      .catch(onError);
    }

    function onError(err) {
      $log.error(JSON.stringify(err));
      ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
    }


    function newAddressModal(isMobile){
      var templateUrl = 'app/address/desktop/address.modal.html';
      if(isMobile){
        templateUrl = 'app/address/mobile/address.modal.html';
      }
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressController',
        controllerAs: 'address'
      };
      if (template){
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (newAddress) {
        if(!newAddress){return false;}
        vm.addresses.push(newAddress);
        vm.selectedLocation = vm.addresses[vm.addresses.length-1];
      }, function (e) {
        console.error(e);
      });
    }


    $rootScope.$on('auth:logout-success', function() {
      customer.set(null);
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('OrderController', OrderController);

  /* @ngInject */
  function OrderController(api, auth, ngNotify, $auth, $localStorage, $log, $state, $stateParams) {
    var vm = this;
    vm.customer = auth;
    vm.hasNoName = true;
    vm.eta = null;
    vm.order = null;
    vm.restaurant = null;
    vm.setEmail = setEmail;
    vm.setOrderName = setOrderName;
    vm.storage = $localStorage;
    vm.updatePasswordForm = {};

    activate();

    ////////////////

    function activate() {
      vm.order = $stateParams.order;
      if (!vm.order) {
        return $state.go('main', {}, { location: 'replace' });
      }
      vm.hasNoName = !vm.order.name;
      vm.restaurant = api.restaurants.get(vm.order.restaurant_id);

      vm.eta = vm.order.remaining_minutes;
    }

    function setEmail() {
      var form = vm.updatePasswordForm;
      form.password_confirmation = form.password;
      $auth.updatePassword(form)
      .then(function() {
        delete $localStorage.isNewCustomer;
        ngNotify.set('Hemos guardado tu clave ;)');
      })
      .catch(function(resp) {
        vm.error = resp.data.errors.full_messages.join('. ') || resp.statusText;
        ngNotify.set(vm.error, 'error');
      });
    }

    function setOrderName() {
      api.orders.save(vm.order)
      .then(function() {
        vm.hasNoName = false;
      }, function(err) {
        $log.error(err);
        ngNotify.set('Error de conexión. Reintenta más tarde', 'error');
      })
      .then(function() {
        // loading the latest orders should update the name of the order
        api.prefs.all(true);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('MenuController', MenuController);

  /* @ngInject */
  function MenuController(_, api, cart, customer, ngNotify, $document, $filter, $location, $uibModal, $log, $q, $rootScope, $state, $timeout) {
    var vm = this;
    vm.addToCart = addToCart;
    vm.cart = cart;
    vm.categories = [];
    vm.categories[0] = new Category('Mis Favoritos');
    // vm.categories[ 1] = new Category('Mis Comprados');
    vm.categories[1] = new Category('Combinaciones NIU');
    vm.categories[2] = new Category('Para Picar');
    vm.categories[3] = new Category('Special Rolls');
    vm.categories[4] = new Category('Nikkei Rolls');
    vm.categories[5] = new Category('Tempura & Panko Rolls');
    vm.categories[6] = new Category('California Rolls');
    vm.categories[7] = new Category('Veggie Rolls');
    vm.categories[8] = new Category('Sashimis & Ceviches');
    vm.categories[9] = new Category('Chirashis');
    vm.categories[10] = new Category('Hosomaki & Nigiri');
    vm.categories[11] = new Category('Salsas Extras');
    vm.categories[12] = new Category('Postres & Bebidas');
    vm.customer = customer.get();
    vm.currentState = $state.current.name;
    vm.expandCategory = expandCategory;
    vm.href = $state.href;
    vm.kebabCase = _.kebabCase;
    vm.latestOrders = [];
    vm.price = price;
    vm.repeatOrder = repeatOrder;
    vm.selectedCategory = null;
    vm.viewSeleable = viewSeleable;
    vm.expandPastOrders = expandPastOrders;
    vm.expandMenu = expandMenu;
    vm.originUrl = $state.current.url;

    vm.myPastOrdesExpandend = (vm.originUrl == "/repetir-pedidos") ? true : false
    vm.menuExpandend = (vm.originUrl == "/carta") ? true : false;

    activate();
    ////////////////

    function Category(name) {
      this.name = name;
      this.isExpanded = false;
      this.seleables = [];
    }

    Category.prototype.moreThan = function CategoryMoreThan() {
      if (!this.seleables) {
        return;
      }
      var length = this.seleables.length,
        moreThan = Math.floor((length%10)/5)*5 + Math.floor(length/10)*10;

      moreThan = moreThan ? moreThan : length - 1;
      return moreThan;
    };

    function activate() {
      return $q.all({
        prefs: api.prefs.all(),
        products: api.products.all(),
        promotions: api.promotions.all()
      })
      .then(function(resolved) {
        var categoriesDict = {};
        _.each(vm.categories, function(category) {
          category.seleables = [];
          categoriesDict[category.name] = category;
        });

        // var favCategory = vm.categories[0],
        //   purchasedCategory = vm.categories[1],
        var favoritesAndPurchased = vm.categories[0],
          products = resolved.products;
        _.each(products, function(product) {
          // add to its categories
          _.each(product.modules.website.categories, function(categoryName) {
            var category = categoriesDict[categoryName];
            category.seleables.push(product);
          });
          if (product && product.normal_price === 0) {
            return;
          }
          // // add to favorites
          // if ('preference' in product && product.preference > 0) {
          //   favCategory.seleables.push(product);
          // }
          // // add to purchased
          // if ('counter' in product && product.counter) {
          //   purchasedCategory.seleables.push(product);
          // }
          if(('preference' in product && product.preference > 0) || ('counter' in product && product.counter)) {
            favoritesAndPurchased.seleables.push(product);
          }
        });
        // purchasedCategory.seleables = _(purchasedCategory.seleables)
        //   .sortBy('counter').reverse().slice(0, 21).value();
        vm.categories[1].seleables = resolved.promotions;
        vm.latestOrders.length = 0;
        Array.prototype.push.apply(vm.latestOrders,
        _.each(api.prefs.get('latest_orders'), function(o) {
          o.promised_time = new Date(Date.parse(o.promised_time));
          o.seleables = _.filter(o.seleables, function(seleable) {
            return vm.price(seleable) > 0;
          });
          o.isExpanded = false;
        }));
      })
      .catch(function(err) {
        $log.error(JSON.stringify(err));
        ngNotify.set('Error en la conexión. Intenta más tarde.', 'error');
      })
      .then(function() {
        var r = $location.path().match(/\/([a-z\-]+$)/);
        if (!r || !r[1]) {
          return;
        }
        var categoryName = r[1];
        if (!_.any(vm.categories, 'isExpanded', true)) {
          findAndSelectCategory(categoryName);
        }
      });
    }

    function defaultOptions(product) {
      var haveNoOptions = true; // have no options to choose

      var optionsNames = [],
        optionsTaken = product.options || {};
      _.each(product.product_options, function(opts, key) {
        if (opts.length > 1) {
          optionsNames.push(key);
        } else {
          optionsTaken[key] = opts[0];
        }
      });
      var optionsTakenNames = _.keys(optionsTaken);

      // check if options are already taken
      haveNoOptions = _.intersection(optionsNames, optionsTakenNames)
        .length === optionsNames.length;

      if (haveNoOptions) {
        return optionsTaken;
      }
    }

    function addToCart(seleable, category) {
      var options, quantity, type;
      // is it a product?
      if (seleable.type === 'products') {
        options = defaultOptions(seleable);

        if (options) {
          quantity = seleable.quantity || 1;
          type = seleable.type;
          cart.add(seleable.id, quantity, options, type);
          return $rootScope.$broadcast('cart:added');
        }
      } else
      // is it a promotion?
      if (seleable.type === 'promotions') {
        var haveNoOptions = true; // have no options to choose

        options = [];
        _.each(seleable.products, function(product, i) {
          var productOptions = defaultOptions(product);
          options[i] = productOptions;
          haveNoOptions = haveNoOptions && !!productOptions;
        });

        if (haveNoOptions) {
          quantity = seleable.quantity || 1;
          type = seleable.type;
          cart.add(seleable.id, quantity, options, type);
          return $rootScope.$broadcast('cart:added');
        }
      }
      
      // open modal asking to select options
      viewSeleable(seleable, category, true);
    }

    function repeatOrder(order) {
      _.each(order.seleables, function(seleable) {
        vm.addToCart(seleable);
      });
      $state.go('cart.products', {'orderName': order.name});
    }

    function expandCategory(category) {
      var id = _.kebabCase((category.promised_time || '') + category.name);
      
      // if(category.promised_time){
        // id = category.promised_time.getTime();
      // }
      
      if (vm.currentState.indexOf('menu') === 0) {
        $state.go('menu.category', { 'categoryName': id });
      }

      category.isExpanded = !category.isExpanded;
      if (category.isExpanded) {
        if (vm.selectedCategory) {
          vm.selectedCategory.isExpanded = false;
        }
        category.limit = category.seleables.length;
        vm.selectedCategory = category;

        $timeout(function() {
          var header = angular.element($document[0].getElementById(id));
          return $document.scrollToElement(header, 0, 500);
        }, 700);
      } else {
        vm.selectedCategory = null;
      }
    }

    function expandPastOrders(){
      if(vm.myPastOrdesExpandend){
        vm.myPastOrdesExpandend = false;
      } else {
        vm.myPastOrdesExpandend = true;
      }
    }

    function expandMenu(){
      if(vm.menuExpandend){
        vm.menuExpandend = false;
      } else {
        vm.menuExpandend = true;
      }
    }

    function price(seleable, applyDiscount) {
      return cart.price(seleable.id, applyDiscount, seleable.type);
    }

    function viewSeleable(seleable, category, makeSelection) {
      var modalInstance = $uibModal.open({
        animation: true,
        size: 'full',
        controller: 'SeleableController as seleable',
        templateUrl: 'app/seleable/{mobile}{desktop}/seleable.html',
        resolve: {
          makeSelection: function() {
            return makeSelection;
          },
          category: function() {
            return category;
          },
          seleable: function() {
            return seleable;
          }
        }
      });

      modalInstance.result.finally(function() {
        activate();
      });
      
      return modalInstance.result.then(function() {
        return $rootScope.$broadcast('cart:added');
      });
    }

    function findAndSelectCategory(categoryName) {
      var category = _.find(vm.categories, function(c) {
        return _.kebabCase(c.name) === categoryName;
      });
      if (category) {
        expandCategory(category);
        return category;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, api, customer) {
    var vm = this;
    vm.customer = customer.get();
    vm.customerChanged = customerChanged;
    vm.firstButton = {state: 'menu'};
    vm.href = $state.href;
    vm.isOpen = false;
    vm.isOpenChanged = isOpenChanged;
    vm.secondButton = {};
    vm.timesAverage = {};

    activate();
    getTimesAverage();

    function activate() {
      vm.ready = api.prefs.all().then(function() {
        vm.greeting = api.prefs.get('greeting');
      });

      customerChanged();
      isOpenChanged(true);
    }

    function getTimesAverage(){
      return api.restaurants.timesAverage()
      .then(function(times) {
        vm.timesAverage = times;
      });
    }

    function isOpenChanged(newIsOpen) {
      vm.isOpen = newIsOpen;
      var button = vm.firstButton;

      if (newIsOpen) {
        button.title = 'Nuevo Pedido';
        button.body = 'Ve a la carta y haz tu pedido NIU';
      } else {
        button.title = 'Realiza un Pedido Anticipado';
        button.body = 'Elige la hora y olvídate de cocinar';
      }
    }

    function customerChanged() {
      var button = vm.secondButton;

      if (vm.customer) {
        button.title = 'Repetir un Pedido';
        button.body = 'Repite un pedido completo o parte de ellos';
        button.state = 'latestOrders';
      } else {
        button.title = 'Estoy registrado';
        button.body = 'Customiza la carta, repite pedidos y más';
        button.state = 'login';
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FeedbackController', FeedbackController);

  /* @ngInject */
  function FeedbackController(api, ngNotify, _, $log, $state, $stateParams, $timeout) {
    var vm = this;
    vm.evaluationValues = _.range(1, 10 + 1);
    vm.feedbackForm = {};
    vm.scrollTo = scrollTo;
    vm.sendFeedback = sendFeedback;

    activate();

    ////////////////

    function activate() {
      return api.orders.get($stateParams.orderId)
      .then(function(order) {
        vm.order = order;
        if (order.feedback) {
          ngNotify.set('Ya diste el feedback de este pedido.', 'error');
          return $state.go('main', {}, { location: 'replace' });
        }
      })
      .catch(function(e) {
        $log.error(JSON.stringify(e));
        if (e.status === 404) {
          ngNotify.set('El pedido al que haces referencia no es válido. Verifica que el link sea correcto', 'error');
          return $state.go('main', {}, { location: 'replace' });
        }
      });
    }

    function sendFeedback() {
      var form = vm.feedbackForm;
      api.orders.feedback(vm.order, form)
      .then(function() {
        ngNotify.set('Gracias por tu feedback.');
        $state.go('main');
      })
      .catch(function(resp) {
        $log.error(JSON.stringify(resp));
        ngNotify.set('Hubo un problema en la conexión. Intenta más tarde', 'error');
      });
    }

    function scrollTo(id) {
      return $timeout(function() {
        var question = angular.element('#' + id);
        var parent = question.parent();
        return parent.scrollToElementAnimated(question, 0, 1500);
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FaqController', FaqController);

  /* @ngInject */
  function FaqController() {
    var vm = this;
    vm.questions = [];
    vm.questions[0] = { name: 'Servicio Delivery', questions: [] };
    vm.questions[1] = { name: 'Servicio en Local', questions: [] };
    vm.questions[2] = { name: 'Productos', questions: [] };

    activate();

    function activate() {
      vm.questions[0].questions.push(
        {
          q: '¿Hay un mínimo para pedir?',
          a: 'No hay pedido mínimo'
        },
        {
          q: '¿Se le da propina al motorista?',
          a: 'La propina es voluntaria, ya que el cargo por envío es en parte para el motorista'
        },
        {
          q: '¿Tienen costo de envío?',
          a: 'Si, el costo de envío es de $1.500. independiente de la distancia en relación al local o cantidad comprada'
        },
        {
          q: '¿Cuánto demora el despacho a domicilio?',
          a: 'El despacho a domicilio puede demorar entre 50 y 120 minutos dependiendo la demanda'
        },
        {
          q: '¿Cuánto demora el retiro en local?',
          a: 'El retiro puede demorar entre 30 y 60 minutos dependiendo la demanda'
        },
        {
          q: '¿Cuál es el rango de despacho?',
          a: 'Revisar mapa en página de locales para conocer plan general. Llamar a locales para conocer la disponibilidad en puntos específicos.'
        },
        {
          q: '¿Dónde puedo hacer mis sugerencias o comentarios?',
          a: 'Puedes escribirnos a niusushi@niusushi.cl o en www.facebook.com/niusushi'
        }
      );

      vm.questions[1].questions.push(
        {
          q: '¿Reciben tarjeta junaeb?',
          a: 'No, ya que al tener patente de alcoholes en nuestros locales, estamos inhabilitados por ley para hacerlo'
        }
      );

      vm.questions[2].questions.push(
        {
          q: '¿Cambian ingredientes de los roll?',
          a: 'Si, puedes cambiar los ingredientes que quieras. Debes solicitarlo al momento de hacer tu pedido. Algunos cambios están sujetos a costos asociados, pregunta al momento de solicitar tu cambio.'
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('CustomerSessionController', CustomerSessionController);

  /* @ngInject */
  function CustomerSessionController(api, customer, ngNotify, _, $auth, $localStorage, $log, $rootScope, $state, $stateParams, $timeout) {
    var vm = this;
    vm.error = '';
    vm.facebookAuth = facebookAuth;
    vm.isEmailSent = false;
    vm.isPasswordSaved = false;
    vm.isSendingForm = false;
    vm.login = login;
    vm.loginForm = {};
    vm.phoneRegex = /^[1-9](\s*\d){7}$/;
    vm.register = register;
    vm.registrationForm = { phone: { prefix: '+56 9 ', number: '' } };
    vm.resetForm = { email: $stateParams.email };
    vm.resetPassword = resetPassword;
    vm.togglePassword = togglePassword;
    vm.updatePassword = updatePassword;
    vm.updatePasswordForm = {};
    vm.fixCss = function(event, isFocused){
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
          if(isFocused){
            $('.login-regist-form').height(screen.height-80);
            $('.bienvenidos').height(screen.height-80);
            $('.login-regist-form').css({position: 'absolute'});
          } else {
            $('.login-regist-form').height($(window).height());
            $('.bienvenidos').height($(window).height());
            $('.login-regist-form').css({position: ''});
          }
        }
      if(navigator.userAgent.match('CriOS')){
        if(isFocused){
          $(event.target).parents().addClass('keyboard-fix');
        } else {
          $(event.target).parents().removeClass('keyboard-fix');
        }
      }
    };
    activate();

    ////////////////

    function activate() {
      $rootScope.$on('auth:login-success', loginSuccess);
      $rootScope.$on('auth:oauth-registration', oauthRegistration);
      $rootScope.$on('auth:password-reset-request-success', loginSuccess);

      $rootScope.$on('auth:password-reset-request-error', onError);
      $rootScope.$on('auth:registration-email-error', onError);
      $rootScope.$on('auth:login-error', onError);
    }

    function togglePassword(passEl) {
      passEl = passEl ? passEl : angular.element('input[name=password]');
      if (passEl.attr('type') === 'password') {
        passEl.attr('type','text');
        $timeout(function() {
          passEl.attr('type','password');
        }, 3000);
      } else {
        passEl.attr('type','password');
      }
    }

    function resetPassword(loginData) {
      vm.isSendingForm = true;

      $auth.requestPasswordReset(loginData)
      .then(function() {
        vm.isEmailSent = true;
      })
      .then(function() {
        vm.isSendingForm = false;
      });
    }

    function updatePassword(passwordData) {
      vm.isSendingForm = true;
      // allow writing password once
      if (!passwordData.password_confirmation) {
        passwordData.password_confirmation = passwordData.password;
      }

      $auth.updatePassword(passwordData)
      .then(function() {
        vm.isPasswordSaved = true;
      })
      .then(function() {
        vm.isSendingForm = false;
      })
      .catch(function(resp) {
        vm.error = resp.data.errors.full_messages.join('. ') || resp.statusText;
      });
    }

    function register() {
      var phone = vm.registrationForm.phone;
      vm.registrationForm.phones = phone.prefix + phone.number;

      if (!vm.registrationForm.password) {
        var password = vm.registrationForm.phones;
        vm.registrationForm.password = password;
      }
      vm.registrationForm.password_confirmation = vm.registrationForm.password;
      
      $auth.submitRegistration(vm.registrationForm)
      .then(function() {
        if ($rootScope.deviceType === 'mobile') {
          $localStorage.isNewCustomer = vm.registrationForm.email;
        }

        vm.login({
          email: vm.registrationForm.email,
          password: vm.registrationForm.password
        });
      });
    }

    function login(loginData) {
      $auth.submitLogin(loginData)
      .then(function(userData) {
        if (userData.orders_count > 0){
          var redirectTo = 'latestOrders',
            redirectParams = {};
        }
        else {
          var redirectTo = 'menu',
            redirectParams = {};
        }
        if ($stateParams.redirectTo) {
          redirectTo = $stateParams.redirectTo;
          redirectParams = $stateParams.redirectParams;
        }
        api.products.all(true);
        api.promotions.all(true);
        api.prefs.all(true);
        $state.go(redirectTo, redirectParams);
      });
    }

    function facebookAuth() {
      $auth.authenticate('facebook')
        .then(function() {
        $log.log('success!', arguments);
      }).catch(function() {
        $log.error('so bad :(', arguments);
      });
    }

    function loginSuccess(ev, loggedCustomer) {
      customer.set(loggedCustomer);
    }

    function oauthRegistration(ev, user) {
      $log.log('new user registered through oauth:', user);
    }

    function onError(ev, reason) {
      if (_.isArray(reason.errors)) {
        vm.error = reason.errors.join(', ');
      } else if (_.isObject(reason.errors)) {
        vm.error = reason.errors.full_messages.join(', ');
      }
      ngNotify.set(vm.error, 'error');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('CartController', CartController);

  /* @ngInject */
  function CartController(api, cart, ngNotify, _, $auth, $document, $log, $q, $scope, $state, $timeout, $uibModal, $templateCache, $stateParams) {
    var vm = this;
    vm.activate = activate;
    vm.addDelivery = addDelivery;
    vm.addOne = addOne;
    vm.calculateTotals = calculateTotals;
    vm.creditCards = [
      {name: 'Mastercard LANPASS', endsWith: '9876'},
      {name: 'Visa Movistar', endsWith: '1234'}
    ];
    vm.customer = null;
    vm.getCustomerAddresses = getCustomerAddresses;
    vm.newAddressModal = newAddressModal;
    vm.deactivateAddress = deactivateAddress;
    vm.getOpenRestaurants = getOpenRestaurants;
    vm.includesGinger = false;
    vm.includesWasabi = false;
    vm.isClosed = true;
    vm.inProgress = false;
    vm.items = [];
    vm.locations = [];
    vm.addressLocations = [];
    vm.restaurantLocations = [];
    vm.paymentWhen = 'later';
    vm.price = price;
    vm.productCount = productCount;
    vm.removeAll = removeAll;
    vm.removeOne = removeOne;
    vm.selectedLocation = null;
    vm.selectQuestion = selectQuestion;
    vm.sendOrder = sendOrder;
    vm.showOptions = showOptions;
    vm.totalChopsticks = 0;
    vm.totalSoySauce = 0;
    vm.updatedDiscount = updatedDiscount;
    vm.when = 'now';
    vm.newAddressModal = newAddressModal;
    vm.restaurantsAveragePickupTime = 0; //getOpenRestaurantsAverage;
    vm.customersAverageDeliveryTime = 0;
    
    Object.defineProperty(vm, 'count', {
      get: function() {
        return cart.count;
      }
    });

    activate(true);

    $scope.$on('path:changed', function(/*e, path*/) {
      vm.how = '';
      vm.selectedLocation = null;
      activate()
      .then(function() {
        validateState();
      //   vm.choseDelivery = ($stateParams.choseDelivery === 'true');
      //   if(vm.choseDelivery){
      //     vm.how = 'delivery';
      //     vm.getCustomerAddresses();
      //   }
      });
    });

    $scope.$on('cart:added', function() {
      vm.items = cart.products();
      vm.calculateTotals();
    });

    function validateState(env) {
      env = env ? env : {};
      var stateName = $state.current.name;
      var isInCartState = stateName.indexOf('cart') >= 0;
      if (!isInCartState) {
        return;
      }
      if (env.items) {
        if (env.items.length === 0) {
          return $state.go('menu', {}, { location: 'replace' });
        } else {
          return;
        }
      }
      if (vm.isClosed) {
        return $state.go('cart.products', {}, { location: 'replace' });
      }
    }
    
    function activate(force) {
      return $q.all([api.products.all(), api.promotions.all()])
      .then(function() {
        // TODO: use customer preferences
        vm.includesGinger = cart.ginger.set(true);
        vm.includesWasabi = cart.wasabi.set(true);
        vm.items = cart.products();
        validateState({ items: vm.items });
        vm.calculateTotals();
        return $auth.validateUser();
      })
      .catch(function(info) {
        if (info.reason !== 'unauthorized') {
          $log.error(info);
          ngNotify.set('Error de conexión. Reintenta más tarde', 'error');
        }
      })
      .then(function(customer) {
        vm.customer = customer;
        return vm.getOpenRestaurants();
      })
      .then(function() {
        if (!_.isEmpty($auth.user)) {
          getCustomersDeliveryTimeAverage().then(function(totalAvgTime) { 
            vm.customersAverageDeliveryTime = totalAvgTime;
          })
          vm.addDelivery(false);
        }
      })
      .then(function() {
        if (!_.isEmpty($auth.user)) {
          getOpenRestaurantsAverage().then(function(totalAvgTime) { 
            vm.restaurantsAveragePickupTime = totalAvgTime;
          });
        }
      });
    }

    function addOne(item) {
      cart.add(item.id, 1, item.options, item.seleable.type);
      vm.calculateTotals();
    }

    function remove(item, count) {
      var id = item.id,
        options = item.options;
      cart.remove(id, count, options, item.seleable.type);

      if (productCount(item, options) === 0) {
        vm.items = cart.products();
      }

      if (vm.items.length) {
        vm.calculateTotals();
      } else {
        $state.go('menu', {}, { location: 'replace' });
      }
    }

    function removeOne(item) {
      remove(item, 1);
    }

    function removeAll(item) {
      remove(item, productCount(item));
    }

    function productCount(item) {
      return cart.get(item.id, item.options, item.seleable.type);
    }

    function calculateTotals() {
      vm.total = cart.total();
      vm.totalDiscount = cart.totalDiscount();
      vm.totalChopsticks = cart.chopsticks.set();
      vm.totalSoySauce = cart.soySauce.set();
    }

    function getOpenRestaurants() {
      vm.addDelivery(false);
      vm.restaurantLocations.length = 0;
      
      return api.restaurants.all(true)
      .then(function(restaurants) {
        vm.restaurantLocations = _.filter(restaurants, {
          is_open: true,
          is_pickup: true
          //redundante, averiguar
        });
        vm.isClosed = vm.restaurantLocations.length === 0;
        return restaurants;
      });
    }

    function getOpenRestaurantsAverage(restaurants){
      return vm.getOpenRestaurants().then(function(rest) { 
        var openRest = _.filter(rest, {
          is_open: true,
          is_pickup: true
        });
        var n = 0;
        if(openRest.length == 0){ return 0; }
        var totalPickupTime = 0;
        _.each(openRest, function(restaurant) {
          totalPickupTime += restaurant.current_pickup_time;
          n++;
        });
        return Math.round(totalPickupTime / n);
      });
    }

    function getCustomerAddresses() {
      vm.addDelivery(true);
      vm.addressLocations.length = 0;

      return api.addresses.all().then(function(addresses) {
        vm.addressLocations = addresses;
        if (addresses.length === 1) {
          // vm.selectedLocation = addresses[0];
        }
        return addresses;
      });
    }
    
    function getCustomersDeliveryTimeAverage(){
      return vm.getCustomerAddresses().then(function(addresses) {
      var n = 0;
      if(addresses.length == 0){ return 0; }
      var totalPickupTime = 0;
      _.each(addresses, function(address) {
        if(address.delivery_restaurant_pickup_time > 0){
          totalPickupTime += address.delivery_restaurant_pickup_time;
          n++;
        }
      });
      return Math.round(totalPickupTime / n);
      });
    }

    function deactivateAddress(address) {
      var templateUrl = 'app/address/confirmation.modal.html';
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressConfirmationModalController',
        controllerAs: 'confirmation',
        resolve: {
          address: function () {
            return address;
          }
        }
      };
      if (template){
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);

      modalInstance.result.then(function (confirmed) {
        if(confirmed){
          address.active = false;
          return api.addresses.save(address)
          .then(function(data) {
            return getCustomerAddresses();
          })
          .catch(function() {
            var msg = 'Hubo un problema eliminando tu dirección. Intenta más tarde.';
            ngNotify.set(msg, 'error');
          });
        }
      }, function (e) {
        console.error(e);
      });
    }

    function updatedDiscount(discount) {
      discount = +discount;
      if (discount !== 40 && discount !== 50) {
        throw new Error('Descuento no válido: ' + discount);
      }
      cart.setDiscount(discount/100);
      vm.calculateTotals();
    }

    function addDelivery(isDelivery) {
      vm.selectedLocation = null;
      cart.isDelivery = isDelivery;
      vm.calculateTotals();
    }

    function sendOrder() {
      vm.inProgress = true;
      var order = {
        order_products: [],
        order_promotions: [],
        discount: cart.discount() * 100
      };
      // TODO: add:
      // - payment_type_id: null,
      
      _.each(cart.products(true), function(item) {
        var orderItem = {};
        orderItem.quantity = item.quantity;

        if (item.seleable.type === 'products') {
          orderItem.product_id = item.id;
          orderItem.product_options = item.options;

          order.order_products.push(orderItem);
        } else if (item.seleable.type === 'promotions') {
          orderItem.promotion_id = item.id;
          orderItem.order_products = [];
          var products = item.seleable.products;
          _.each(products, function(product, productIndex) {
            var orderProduct = {};
            orderProduct.product_id = product.id;
            orderProduct.product_options = item.options[productIndex];
            
            orderItem.order_products.push(orderProduct);
          });

          order.order_promotions.push(orderItem);
        }
      });

      order.customer = {
        id: vm.customer.id
      };

      if (cart.isDelivery) {
        order.order_type = 'Delivery';
        order.address_id = vm.selectedLocation.id;
        order.restaurant_id = null;
      } else {
        order.order_type = 'Retiro';
        order.restaurant_id = vm.selectedLocation.id;
        order.address_id = null;
      }

      api.orders.save(order)
      .then(function(info) {
        // clean the cart
        vm.items.forEach(removeAll);
        $state.go('order.success', { order: info });
      }, function(info) {
        $log.error(info);
        var message = _.get(info, 'data.message',
          'Hubo un error enviando tu pedido. Intenta nuevamente'
        );
        var msg = 'Hubo un error. Carga de nuevo la página e inténtalo nuevamente';
        ngNotify.set(msg, 'error');
      })
      .then(function() {
        vm.inProgress = false;
        // loading the latest orders, should includes the new one
        api.prefs.all(true);
      });
    }

    function price(item, applyDiscount) {
      return cart.price(item.id, applyDiscount, item.seleable.type);
    }

    function showOptions(item) {
      var options = item.options || {};
      if (_.isArray(options)) {
        var products = item.seleable.products;
        return _.map(products, function(product, productIndex) {
          var name = '-' + product.name,
            productOptions = _.extend({}, (options[productIndex] || {}), product.extras);
          if (!_.isEmpty(productOptions)) {
            name += ' (' + _.values(productOptions).join(', ') + ')';
          }
          return name;
        });
      } else {
        return _.map(_.extend({}, options, item.seleable.extras), function(value, key) {
          return key + ': ' + value;
        });
      }
    }

    function selectQuestion(name) {
      return $timeout(function() {
        var question = angular.element('#' + name);
        var parent = question.parent();
        return parent.scrollToElementAnimated(question, 0, 1500);
      });
    }
    function newAddressModal(isMobile){
      var templateUrl = 'app/address/desktop/address.modal.html';
      if(isMobile){
        templateUrl = 'app/address/mobile/address.modal.html';
      }
      var template = $templateCache.get(templateUrl);
      var modalConfig = {
        animation: true,
        controller: 'AddressController',
        controllerAs: 'address'
      };
      if (template){
        modalConfig.template = template;
      } else {
        modalConfig.templateUrl = templateUrl;
      }
      var modalInstance = $uibModal.open(modalConfig);
 
      modalInstance.result.then(function (newAddress) {
        if(!newAddress){return false;}
        vm.addressLocations.push(newAddress);
        vm.selectedLocation = vm.addressLocations[vm.addressLocations.length-1];
      }, function (e) {
        console.error(e);
      });
    }
 
  }
})();

(function() {
  'use strict';

  angular
  .module('website')
  .controller('AddressConfirmationModalController', AddressConfirmationModalController);

  /* @ngInject */
  function AddressConfirmationModalController($uibModalInstance, address) {
    var vm = this;
    vm.answer = answer;
    vm.address = address;

    function answer(answer){
      $uibModalInstance.close(answer);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('AddressController', AddressController);

  /* @ngInject */
  function AddressController(api, uiGmapGoogleMapApi, $state, $timeout, $log, $sce, $stateParams, ngNotify, _, $rootScope, $uibModalInstance, $templateCache, $uibModal) {
    var vm = this;
    vm.activate = activate;
    vm.backState = $stateParams.backState;
    vm.comment = '';
    vm.comunes = null;
    vm.geocode = null;
    vm.getLonLatFromAddress = getLonLatFromAddress;
    vm.lonLat = {};
    vm.lonLat.latitude = -33.4059632;
    vm.lonLat.longitude = -70.5608473;
    vm.mapLonLat = angular.copy(vm.lonLat);
    vm.mapOptions = {};
    vm.mapOptions.mapTypeControl = false;
    vm.mapOptions.scrollwheel = false;
    vm.mapOptions.streetViewControl = false;
    vm.mapOptions.draggable = true;
    vm.originalLonLat = {};
    vm.restoreLocation = restoreLocation;
    vm.saveAddress = saveAddress;
    vm.scrollTo = scrollTo;
    vm.specific_number = '';
    vm.step = 0;
    vm.street_name = '';
    vm.street_number = '';
    vm.close = close;
    vm.closeModal = closeModal;
    vm.selectOnMap = selectOnMap;
    vm.tooltip = $sce.trustAsHtml(
      '<h4>Acá se enviará tu pedido</h4>' +
      'Si lo necesitas, arrastra el mapa'
    );

    activate();

    ////////////////


    function activate() {
      uiGmapGoogleMapApi
      .then(function(maps) {
        vm.geocode = (new maps.Geocoder()).geocode;
        vm.GeocoderStatus = maps.GeocoderStatus;
      })
      .catch($log.error);
      return api.comunes.all()
      .then(function(comunes) {
        vm.comunes = comunes;
      });
    }

    function getLonLatFromAddress(keepState) {
      var address = vm.street_name + ' ' + vm.street_number +
        ', ' + vm.comune.name;
      // original regex in niusushi-backend/app/models/old_web.rb
      address = address.replace(/(^av(\s|\.|da|enida)|^calle)\s*/i, '');
      vm.geocode({address: address}, function(results, status) {
        $rootScope.$apply(function() {
          if (status !== vm.GeocoderStatus.OK) {
            $log.error('Geocode was not successful: ' + status);
          } else {
            var location = results[0].geometry.location;
            vm.originalLonLat.longitude = location.lng();
            vm.originalLonLat.latitude = location.lat();
            vm.restoreLocation();
          }
          if (!keepState) {
            $state.go('address.confirm');
          }
        });
      });
    }
    function close(){
      $uibModalInstance.close();
    }
    function saveAddress(isMobile) {
      var address = {
        comune_id: vm.comune.id,
        street_name: vm.street_name,
        street_number: vm.street_number,
        specific_number: vm.specific_number,
        comment: vm.comment,
        lonlat: [vm.lonLat.longitude, vm.lonLat.latitude]
      };
      if(isMobile){
        address.lonlat = [vm.mapLonLat.longitude, vm.mapLonLat.latitude];
      }
      return api.addresses.save(address)
      .then(function(data) {
        ngNotify.set('¡Dirección guardada!');
        if($uibModalInstance.opened){
          data = data.address;
          data.address = data.street_name + ' #' + data.street_number;
          if (data.specific_number) {
            data.address += ' ' + data.specific_number;
          }
          data.address +=  ', ' + vm.comune.name;

          $uibModalInstance.close(data);
        } else {
          $state.go(vm.backState);
        }
        return data;
      })
      .catch(function(data) {
        $log.error(data);
        var message = _.get(data, 'data.message',
          'Hubo un problema guardando tu dirección. Intenta más tarde'
        );
        ngNotify.set(message, 'error');
      });
    }

    function restoreLocation() {
      vm.lonLat.longitude = vm.originalLonLat.longitude;
      vm.lonLat.latitude = vm.originalLonLat.latitude;
      vm.mapLonLat.longitude = vm.originalLonLat.longitude;
      vm.mapLonLat.latitude = vm.originalLonLat.latitude;
    }

    function selectOnMap() {
      vm.step = 1;
    }

    function scrollTo(id) {
      return $timeout(function() {
        var question = angular.element('#' + id);
        var parent = question.parent();
        return parent.scrollToElementAnimated(question, 0, 1500);
      });
    }

    function close(){
      $state.go('cart.whenhowwhere', {'choseDelivery': 'true'}, {
        reload: true,
        inherit: false
      });
    }
    function closeModal(){
      $uibModalInstance.close();
    }
 

    $rootScope.$on('restore-location', vm.restoreLocation);

  }

  angular
    .module('website')
    .controller('NewAddressModalCtrl', function(){

  });  

})();

(function() {
  'use strict';

  angular
    .module('website')
    .run(runBlock);

  /** @ngInject */
  function runBlock(_, $auth, $controller, $injector, $location, $log, $uibModal, $uibModalStack, $rootScope, $state, $timeout, $urlRouter, Analytics, ngNotify) {

    $rootScope.deviceType = _.intersection(['mobile', 'desktop'],
      angular.element(':root').attr('class').split(' '))[0];

    $rootScope.$on('$stateChangeError', $log.error.bind($log));
    $rootScope.$on('auth:password-reset-confirm-success', function() {
      $state.go('newPassword');
    });

    var bypass;
    $rootScope.$on('$stateChangeStart', function(e, toState, toParams) {

      var state;

      if (bypass) {
        bypass = false;
        return;
      }

      // close all remaining open modals
      $uibModalStack.dismissAll();

      // verify if customer is authenticated
      state = toState;
      while (state && state.name !== '' && !state.auth) {
        state = $state.get('^', state);
      }
      if (state && state.auth) {
        e.preventDefault();

        var auth = state.auth;
        $auth.validateUser()
        .then(function() {
          // logged in
          if (!auth.required) {
            var state, params;
            if (toParams.redirectTo) {
              state = toParams.redirectTo;
              params = toParams.redirectParams;
            } else {
              state = auth.redirect;
              params = {};
            }
            $state.transitionTo(state, params, { location: 'replace' });
          } else
          if (!isAdaptive(toState, toParams, e)) {
            bypass = true;
            $state.go(toState, toParams);
          }
        })
        .catch(function() {
          // logged out
          if (auth.required) {
            var params = {
              redirectTo: toState.name,
              redirectParams: toParams
            };
            $state.transitionTo(auth.redirect, params);
          } else
          if (!isAdaptive(toState, toParams, e)) {
            bypass = true;
            $state.go(toState, toParams);
          }
        });
      } else {
        // manage adaptive case
        isAdaptive(toState, toParams, e);
      }
    });
    $rootScope.$on('$locationChangeSuccess', function() {
      $rootScope.$broadcast('hash:changed', $location.hash());
      $rootScope.$broadcast('path:changed', $location.path());
    });

    $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function() {
        var state = $state.current,
          title, description;
        do {
          title = state.title;
          description = state.description;
          state = $state.get('^', state);
        } while (!title && state.name !== '');
        $rootScope.$title = title;
        $rootScope.$description = description;
      });
    });

    ngNotify.config({
      theme: 'prime',
      position: 'top',
      duration: 4000,
      type: 'info',
      sticky: false,
      html: false
    });

    function isAdaptive(toState, toParams, e) {
      var deviceType = $rootScope.deviceType;

      if (!(toState.adaptive && toState.adaptive[deviceType])) {
        return false;
      }

      e.preventDefault();

      var content = toState.adaptive[deviceType];
      if (content.redirect) {
        var stateAndParams = content.redirect,
          state, params;
        state = stateAndParams.match(/[^\(\)]+/)[0];
        params = stateAndParams.match(/\(.+\)/);
        params = params ? eval(params[0]) : {};
        $state.transitionTo(state, params, { location: 'replace' });
      } else
      if (content.modal) {
        // open modals from everywhere
        // http://blog.dargiel.net/how-to-open-a-modal-from-any-state-using-ui-router/
        var modalInstance = $uibModal.open({
          size: _.kebabCase(toState.name),
          controller: function() {
            return $controller(toState.controller, {
              $stateParams: toParams
            });
          },
          controllerAs: toState.controllerAs,
          templateUrl: toState.templateUrl
        });
        if (content.onCreate) {
          $injector.invoke(content.onCreate, modalInstance);
        }
      }
      return true;
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('website')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    var authResolve = function($auth, customer, $log) {
      return $auth.validateUser()
      .then(customer.set)
      .catch(function(err) {
        if (err.reason === 'unauthorized') {
          return customer.set(null);
        } else {
          $log.error(err);
        }
      });
    };
    $stateProvider
      .state('main', {
        url: '/',
        title: 'NIU Sushi | Las Condes, Vitacura, La Dehesa, Providencia y Ñuñoa a domicilio',
        description: 'El mejor sushi de Santiago. Sushi delivery Providencia, Las Condes, Vitacura, Lo Barnechea y Ñuñoa.',
        templateUrl: 'app/main/{mobile}{desktop}/main.html',
        resolve: { auth: authResolve },
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('menu', {
        url: '/carta',
        title: 'Carta NIU Sushi | El mejor sushi de Santiago',
        description: 'La mejor calidad de sushi en Santiago. Sushi despacho Las Condes, Providencia, Vitacura, Lo Barnechea, Ñuñoa y Centro',
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        resolve: { auth: authResolve },
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      .state('menu.category', {
        url: '/:categoryName'
      })
      .state('restaurants', {
        url: '/locales',
        title: 'Locales NIU Sushi | Providencia, Las Condes, Lo Barnechea, Vitacura, Ñuñoa, La Florida',
        description: 'Los mejores locales de sushi de Santiago. Sushi domicilio Providencia, Vitacura, Lo Barnechea, Ñuñoa, Centro y Las Condes',
        templateUrl: 'app/restaurants/{mobile}{desktop}/restaurants.html',
        controller: 'RestaurantsController',
        controllerAs: 'restaurants'
      })
      .state('faq', {
        url: '/preguntas-frecuentes',
        title: 'FAQ NIU Sushi | Lo Barnechea, Vitacura, Ñuñoa, La Florida, Providencia, Las Condes',
        description: 'Los mejores locales de sushi de Santiago, Vitacura, Lo Barnechea, Ñuñoa, Centro, Las Condes y Providencia',
        templateUrl: 'app/faq/desktop/faq.html',
        adaptive: {
          mobile: { redirect: 'main' }
        },
        controller: 'FaqController',
        controllerAs: 'faq'
      })
      .state('tos', {
        url: '/terminos-y-condiciones',
        title: 'Términos y condiciones NIU Sushi',
        templateUrl: 'app/tos/tos.html'
      })
      .state('latestOrders', {
        auth: {
          required: true,
          redirect: 'login'
        },
        url: '/repetir-pedidos',
        title: 'Repite tus pedidos | NIU Sushi | Vitacura, Ñuñoa, La Florida, Providencia, Las Condes, Lo Barnechea',
        description: 'Pide sushi a tu casa en Lo Barnechea, Ñuñoa, Centro, Las Condes, Providencia, Vitacura y La Florida',        
        templateUrl: 'app/menu/{mobile}{desktop}/menu.html',
        resolve: { auth: authResolve },
        controller: 'MenuController',
        controllerAs: 'menu'
      })
      
      .state('signin', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true,
            /** @ngInject */
            onCreate: function($rootScope) {
              var modalInstance = this;

              var onLogin = $rootScope.$on('auth:login-success', function() {
                modalInstance.close();
                onLogin();
              });

              var onRegistration = $rootScope.$on('auth:registration-email-success', function() {
                modalInstance.close();
                onRegistration();
              });
            }
          }
        },
        url: '/registrarse?redirectTo',
        resolve: { auth: authResolve },
        params: {
          redirectParams: {}
        },
        templateUrl: 'app/customer-session/{mobile}{desktop}/registration.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('login', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true,
            /** @ngInject */
            onCreate: function($rootScope) {
              var modalInstance = this;
              var onLogin = $rootScope.$on('auth:login-success', function() {
                modalInstance.close();
                onLogin();
              });
            }
          }
        },
        url: '/login?redirectTo',
        params: {
          redirectParams: {}
        },
        templateUrl: 'app/customer-session/{mobile}{desktop}/login.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })
      .state('logout', {
        url: '/logout',
        /** @ngInject */
        onEnter: function($auth, $localStorage, $state, $timeout, customer, $window) {
          $auth.signOut()
          .finally(function() {
            customer.set(null);
            $localStorage.$reset();
            $window.location.href = '/';
          });
        }
      })
      .state('profile', {
        auth: {
          required: true,
          redirect: 'login'
        },
        url: '/perfil',
        title: 'Tu perfil NIU Sushi | Ñuñoa, La Florida, Providencia, Las Condes, Lo Barnechea, Vitacura',
        description: 'Ayudanos a conocerte para atenderte mejor. Ñuñoa, Centro, Las Condes, Providencia, Vitacura, La Florida y Lo Barnechea',
        resolve: { auth: authResolve },
        templateUrl: 'app/profile/{mobile}{desktop}/profile.html',
        controller: 'ProfileController',
        controllerAs: 'profile'
      })
      .state('resetPassword', {
        auth: {
          required: false,
          redirect: 'profile'
        },
        adaptive: {
          desktop: {
            modal: true
          }
        },
        url: '/restaurar-password',
        templateUrl: 'app/customer-session/{mobile}{desktop}/reset-password.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession',
        params: {
          email: null
        }
      })
      .state('newPassword', {
        auth: {
          required: true,
          redirect: 'login'
        },
        adaptive: {
          desktop: { modal: true }
        },
        url: '/nueva-password',
        templateUrl: 'app/customer-session/new-password.html',
        controller: 'CustomerSessionController',
        controllerAs: 'customerSession'
      })

      .state('address', {
        auth: {
          required: true,
          redirect: 'login'
        },
        abstract: true,
        url: '/direccion',
        template: '<ui-view/>',
        controller: 'AddressController',
        controllerAs: 'address',
        params: {
          backState: 'profile'
        }
      })
      .state('address.edit', {
        url: '/editar',
        templateUrl: 'app/address/{mobile}{desktop}/address.edit.html'
      })
      .state('address.confirm', {
        url: '/confirmar',
        templateUrl: 'app/address/address.confirm.html',
        adaptive: {
          desktop: { redirect: 'address.edit' }
        }
      })
      /*.state('address.new', {
        url: '/new',
        templateUrl: 'app/address/{mobile}{desktop}/new.html',
        adaptive: {
          desktop: { redirect: 'address.edit' }
        },
        params: {
          backState: 'cart.whenhowwhere'
        }
      })*/

      .state('cart', {
        abstract: true,
        url: '/carro',
        title: 'Carro NIU Sushi | La Florida, Santiago, Providencia, Las Condes, Lo Barnechea, Vitacura, Ñuñoa',
        description: 'Sushi para despacho en Santiago Centro, Las Condes, Providencia, Vitacura, La Florida, Lo Barnechea y Ñuñoa',
        template: '<ui-view/>',
        controller: 'CartController',
        controllerAs: 'cart',
        params: {
          choseDelivery: null
        }
      })
      .state('cart.products', {
        url: '/productos',
        title: 'Rolls NIU Sushi | Santiago, Providencia, Las Condes, Lo Barnechea, Vitacura, Ñuñoa, La Florida',
        description: 'El sushi más rico en Las Condes, Providencia, Vitacura, La Florida, Lo Barnechea, Ñuñoa y Santiago Centro',
        templateUrl: 'app/cart/cart.products.html',
        adaptive: {
          desktop: { redirect: 'cart.whenhowwhere' }
        }
      })
      .state('cart.whenhowwhere', {
        auth: {
          required: true,
          redirect: 'signin'
        },
        url: '/donde-como-y-cuando?choseDelivery',
        title: 'Donde quieres tu NIU Sushi | Providencia, Las Condes, Lo Barnechea, Vitacura, Ñuñoa, La Florida, Santiago',
        description: 'Te llevamos el sushi a tu casa en Providencia, Vitacura, La Florida, Lo Barnechea, Ñuñoa, Santiago Centro y Las Condes',
        templateUrl: 'app/cart/{mobile}{desktop}/cart.when-how-n-where.html'
      })

      .state('order', {
        auth: {
          required: true,
          redirect: 'login'
        },
        abstract: true,
        url: '/pedido',
        resolve: { auth: authResolve },
        template: '<ui-view/>',
        controller: 'OrderController',
        controllerAs: 'order',
        params: {
          order: null
        }
      })
      .state('order.success', {
        url: '/exito',
        templateUrl: 'app/order/{mobile}{desktop}/order.success.html'
      })
      .state('order.fail', {
        url: '/ups',
        templateUrl: 'app/order/order.fail.html'
      })
      .state('feedback', {
        url: '/feedback/:orderId',
        title: 'Feedback NIU Sushi | Las Condes, Lo Barnechea, Vitacura, Ñuñoa, La Florida, Santiago, Providencia',
        description: 'Ayudanos a mejorar el servicio de sushi en Vitacura, La Florida, Lo Barnechea, Ñuñoa, Santiago Centro, Las Condes y Providencia',
        templateUrl: 'app/feedback/{mobile}{desktop}/feedback.html',
        controller: 'FeedbackController',
        controllerAs: 'feedback'
      });

    $urlRouterProvider.otherwise('/carta');
  }

})();

/* global moment:false, StackTrace:false, rebound:false, _:false, viewportUnitsBuggyfill:false, viewportUnitsBuggyfillHacks:false */
(function() {
  'use strict';

  angular
    .module('website')
    .constant('_', _)
    .constant('rebound', rebound)
    .constant('StackTrace', StackTrace)
    .constant('viewportUnitsBuggyfill', viewportUnitsBuggyfill)
    .constant('viewportUnitsBuggyfillHacks', viewportUnitsBuggyfillHacks);

})();

(function() {
  'use strict';

  angular
  .module('website')
  .config(config);

  /** @ngInject */
  function config(adaptiveTemplatingProvider, AnalyticsProvider, env, StackTrace, uiGmapGoogleMapApiProvider, viewportUnitsBuggyfill, viewportUnitsBuggyfillHacks, $authProvider, $compileProvider, $locationProvider, $logProvider, $provide, $windowProvider) {
    var window = $windowProvider.$get();

    $locationProvider.html5Mode(true);

    // Enable log
    $logProvider.debugEnabled(true);
    var storageMethod = function(){
      try {
        // try to use localStorage
        window.localStorage.test = 2;
        return 'localStorage';
      } catch (e) {
        // there was an error so...
        alert('Parece ser que estás en modo privado o estás usando una versión antigua de tu navegador. El sitio podría no funcionar correctamente.');
        return 'cookies';
      }
    }

    // Set options third-party lib
    $authProvider.configure({
      apiUrl: env.NG_TOKEN_AUTH_URL,
      passwordResetSuccessUrl: window.location.origin + '/',
      storage: storageMethod(),
      authProviderPaths: {
        facebook: '/auth/facebook'
      }
    });

    $provide.decorator('$uibModalStack', function($delegate) {
      var open = $delegate.open,
        close = $delegate.close,
          dismiss = $delegate.dismiss;

          var onClosed = function() {
            try {
              var body = angular.element('body'),
                scroll = body.css('top').match(/\d+/)[0];

                // body.css({
                //   'position': 'static',
                //   'overflow': 'auto',
                //   'top': 'auto'
                // });

                window.scrollTo(0, scroll);
            }
            catch (e) {}
          };

          $delegate.open = function $uibModalOpen() {
            var body = angular.element('body'),
              scroll = window.scrollY;

              // body.css({
              //   'position': 'fixed',
              //   'overflow': 'hidden',
              //   'top': -scroll+'px',
              //   'left': '0',
              //   'right': '0',
              //   'margin': 'auto'
              // });

              return open.apply($delegate, arguments);
          };

          $delegate.close = function $uibModalClose() {
            onClosed();
            return close.apply($delegate, arguments);
          };
          $delegate.dismiss = function $uibModalDismiss() {
            onClosed();
            return dismiss.apply($delegate, arguments);
          };

          return $delegate;
    });

    $provide.decorator('$exceptionHandler', function($delegate) {
      return function(exception, cause) {
        $delegate(exception, cause);

        StackTrace.fromError(exception)
        .then(function(trace) {
          window.ga('send', 'exception', {
            exDescription: angular.toJson({
              msg: exception.toString(),
              url: window.location.href,
              cause: cause || '',
              trace: trace.slice(0, 6)
            }),
            exFatal: false
          });
        });
      };
    });

    // Loading Google Maps SDK
    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyDGna4m27F80zM-NJmdLqTmHA5Fyj4zgHA',
      v: '3',
      libraries: 'geometry,visualization'
    });

    // Disable spinner

    // Support geo: and tel: protocols
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|geo|tel):/);

    // Use viewport units fix
    viewportUnitsBuggyfill.init({
      force: /iPad|iPhone|iPod/.test(window.navigator.userAgent),
      hacks: viewportUnitsBuggyfillHacks,
      refreshDebounceWait: 250
    });

    // Setting Google Analytics to track pages and exceptions
    AnalyticsProvider
    .setAccount({
      tracker: 'UA-20324301-1',
      enhancedLinkAttribution: true,
      trackEvent: true
    })
    .setPageEvent('$stateChangeSuccess');

    // Set tests for adaptive templates
    var isMobile = function() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };

    adaptiveTemplatingProvider.addTest('mobile', isMobile());
    adaptiveTemplatingProvider.addTest('desktop', !isMobile());

    angular.element(':root').addClass(isMobile() ? 'mobile' : 'desktop');
  }

})();

angular.module("website").run(["$templateCache", function($templateCache) {$templateCache.put("app/address/address.confirm.html","<div class=\"container_site container_checkout\"><div class=\"container-fluid border_head header__app\"><div class=\"contianer\"><a class=\"col-xs-2 retroceder\" ui-sref=\"address.edit\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-10 frace_local\"><p>NIU SUHI</p></div></div></div><img id=\"marker\" height=\"67\" src=\"/assets/images/address_icon.png\" width=\"57\" tooltip-class=\"tooltip-special\" tooltip-html=\"address.tooltip\" tooltip-is-open=\"true\"><ui-gmap-google-map center=\"address.lonLat\" draggable=\"true\" options=\"address.mapOptions\" zoom=\"16\"><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map><button class=\"siguiente\" ng-click=\"address.saveAddress()\"><p>Confirmar dirección</p><i class=\"icon-arrow_ins_left\"></i></button></div>");
$templateCache.put("app/address/confirmation.modal.html","<div class=\"address-modal confirm_delete\"><div class=\"modal-header\"><button type=\"button\" class=\"close close-modal\" ng-click=\"confirmation.answer(false)\"><i class=\"icon-cruz\"></i></button><h1>Confirmar</h1></div><div class=\"modal-body container-fluid\"><p>¿Eliminar dirección \"{{confirmation.address.address}}\"?</p><div class=\"container_botones_select\"><input id=\"option_yes\" name=\"si\" type=\"radio\" ng-click=\"confirmation.answer(true)\"> <label for=\"option_yes\" ng-class=\"\'btn__select button-select-items btn-disabled\'\" class=\"col-xs-6\">Si</label> <input id=\"option_no\" name=\"no\" type=\"radio\" ng-click=\"confirmation.answer(false)\"> <label for=\"option_no\" ng-class=\"\'btn__select button-select-items btn-disabled\'\" class=\"col-xs-6\">No</label></div></div></div>");
$templateCache.put("app/cart/cart.products.html","<div class=\"container-fluid header_app\"><div class=\"contianer\"><div class=\"col-xs-3\"><a class=\"retroceder\" ui-sref=\"menu\"><i class=\"icon-arrow_ins_right\"></i></a></div><a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/desktop/logo_tr.png\" alt=\"\" width=\"70\" style=\"margin:0 auto; display:block;\"></a></div></div><div class=\"container_site container_checkout\"><div class=\"bienvenidos-cart\"><small><strong ng-show=\"cart.customer\">{{cart.customer.name.split(\' \')[0] + \', \'}}</strong>Confirma<br>tu pedido...</small><div class=\"container_campo_login\" ng-repeat=\"item in cart.items | orderBy:\'addedAt\'\"><div class=\"container_imgen\"><img class=\"seleable-img\" ng-src=\"{{item.seleable.image.medium}}\" alt=\"{{item.seleable.name}}\"><div class=\"seleable-shadow\"></div></div><div class=\"detalle_listado\"><p>{{item.seleable.name}}</p><span ng-repeat=\"option in cart.showOptions(item) track by $index\">{{option}}</span><div class=\"valores\"><span class=\"tarjado\" ng-show=\"item.seleable.discount\">{{cart.price(item, false) | currency:\"$ \":0}}</span> <span class=\"va-net\">{{cart.price(item, true) | currency:\"$ \":0}}</span></div><div class=\"suma_cantidad\"><span class=\"change change-remove\" ng-click=\"cart.removeOne(item)\"><i class=\"glyphicon glyphicon-minus\"></i></span> <input name=\"quantity\" class=\"quantity Eplus\" readonly=\"\" size=\"4\" value=\"{{cart.productCount(item)}}\"> <span class=\"change change-add\" ng-click=\"cart.addOne(item)\"><i class=\"glyphicon glyphicon-plus\"></i></span> <span class=\"change change-remove-all\" ng-click=\"cart.removeAll(item)\"><i class=\"glyphicon glyphicon-remove\"></i></span></div></div></div></div><div class=\"container__agregados btn-link\"><div class=\"mensajes_agregados\"><a href=\"javascript:;\"><p>Agregamos Gratis:</p><span><em ng-show=\"cart.totalChopsticks > 0\">{{cart.totalChopsticks}} Palitos</em> <em ng-show=\"cart.totalSoySauce > 0\">, {{cart.totalSoySauce}} Salsa de Soya</em> <em ng-show=\"cart.includesGinger\">, Gengibre</em> <em ng-show=\"cart.includesWasabi\">y Wasabi</em></span></a></div><div class=\"mensajes_agregados agregados_dos\" ng-if=\"false\"><a href=\"javascript:;\"><p>¿Bebidas, Postre, Otros...?</p><span></span> <i class=\"icon-arrow_ins_left\"></i></a></div><div class=\"mensajes_agregados-total\"><p class=\"Total\">Total a Pagar</p><div class=\"container_Valor_total line-height\"><span>{{cart.total | currency:\"$ \":0}}</span><p>{{cart.totalDiscount | currency:\"$ \":0}}</p></div></div></div><a class=\"siguiente\" ng-disabled=\"cart.isClosed\" ui-sref=\"cart.whenhowwhere\">Siguiente <span ng-if=\"cart.isClosed\">(cerrado)</span> <i class=\"icon-arrow_ins_left\"></i></a></div>");
$templateCache.put("app/customer-session/new-password.html","<header-cart></header-cart><div class=\"container_site color_fondo__body\"><form class=\"bienvenidos\" ng-show=\"!(customerSession.isPasswordSaved || customerSession.error)\" ng-submit=\"customerSession.updatePassword(customerSession.updatePasswordForm)\"><fieldset ng-disabled=\"customerSession.isSendingForm\"><p style=\"font-size:27px;\">Ingresa tu Nueva Clave</p><div class=\"container_campo_login\"><input class=\"input-text\" name=\"password\" ng-model=\"customerSession.updatePasswordForm.password\" placeholder=\"Nueva Clave\" required=\"\" type=\"password\"></div><button class=\"ingresar_btn\" type=\"submit\">Guardar contraseña <i class=\"icon-arrow_ins_left\"></i></button></fieldset></form><div class=\"welcome-checkout\" ng-if=\"customerSession.isPasswordSaved\"><div class=\"tick\"><i class=\"icon-check\"></i></div><div class=\"title-check\"><p>Excelente</p><span class=\"Message-Error\">Tu contraseña ya ha sido actualizada.<br>Explora <a ui-sref=\"menu\" ui-sref-opts=\"{location: \'replace\'}\">la carta</a>, o revisa <a ui-sref=\"profile\" ui-sref-opts=\"{location: \'replace\', reload: true}\">tu perfil</a>.</span></div></div><div class=\"welcome-checkout error-encuesta\" ng-if=\"customerSession.error\"><div class=\"tick\"><i class=\"icon-cerrar\"></i></div><div class=\"title-check\"><p>Ups!</p><span class=\"Message-Error\">{{customerSession.error}}<br><a ng-click=\"customerSession.error = null\">Inténtalo nuevamente.</a></span></div></div></div>");
$templateCache.put("app/order/order.fail.html","<p>Fracaso</p>");
$templateCache.put("app/tos/tos.html","<header-cart></header-cart><div class=\"container-contenido container_listado terms\" ng-class=\"{\'container\': deviceType == \'desktop\'}\"><div class=\"col-md-10 col-md-push-1\"><h2>POLÍTICA DE PRIVACIDAD</h2><p>Niu Sushi respeta la privacidad de cada individuo y valora la confidencialidad de sus clientes. Esta Política de Privacidad (en adelante, la \"Política de Privacidad\") establece las prácticas de Niu Sushi con respecto a la recopilación, uso, y divulgación de información que usted nos proporcione por medio del sitio web www.niusushi.cl (en adelante, el \"Sitio Web\"). Por favor lea toda la Política de Privacidad antes de utilizar este Sitio Web o de proporcionar información a través del mismo. Al utilizar este Sitio Web, y siempre que usted remita información por medio del mismo a Niu Sushi, usted acepta tácitamente los términos de esta Política de Privacidad.</p><h3>Recopilación de Datos Personales</h3><p>Niu Sushi respeta su derecho a la protección de sus datos personales, los cuales están amparados por las Leyes Chilenas. Niu Sushi solamente recopilará datos identificables personales sin los cuales se tornaría imposible brindar los servicios de Niu Sushi, tales como su nombre, dirección, teléfono, celular, email y fecha de nacimiento, cuando usted los proporcione de forma voluntaria a Niu Sushi. El Usuario que proporciona de la manera descrita sus datos personales, lo hace en forma expresa, libre y consentida y autoriza automáticamente a que Niu Sushi utilice esta información, conforme a lo que describe esta Política de Privacidad.</p><p>La información y/o datos que voluntariamente nos facilite a través del Sitio Web, podrán ser incorporados a la base de datos con la finalidad de realizar la gestión y el mantenimiento de nuestras relaciones con Ud., es decir, poder enviarle información sobre nuestros productos, promociones, descuentos, publicidad, etc. De ninguna manera Niu Sushi le solicitará para su base de datos, información personal que revele su origen racial y étnico, opiniones políticas, convicciones religiosas, filosóficas o morales, afiliación sindical e información referente a su salud o a su vida sexual (\"Datos Sensibles\").</p><p>La base de datos será guardada y almacenada y se encuentra debidamente registrada conforme la ley aplicable. Esta información no será transferida a terceros sin su consentimiento previo. Niu Sushi mantiene los datos de información personal identificable, proporcionada voluntariamente en una base de datos electrónica. A pesar de que Niu Sushi hace todos los esfuerzos razonables por proteger la información recopilada por medio del Sitio Web, por favor tome en cuenta que siempre existe un riesgo implícito al suministrar datos por medio del Internet. Niu Sushi no puede garantizar que nuestro Sitio Web sea 100% seguro contra la manipulación ilegal o la piratería. Cualquier información transmitida por medio de Internet puede estar en peligro; sin embargo, una vez que Niu Sushi recibe esta información y se añade a nuestra base de datos, recibe la misma protección que Niu Sushi extiende a su propia información confidencial. Se adoptarán las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales.</p><h3>Actualización de su Información</h3><p>Si desea conocer los datos de su persona que constan en la base de datos, actualizarlos o rectificar errores, o ejercer el derecho de retiro o bloqueo total o parcial de su nombre de nuestra base de datos, por favor comuníquese por correo a Chesterton 8677, Comuna de Las Condes, Santiago de Chile, o por correo electrónico a niusushi@niusushi.cl, con el asunto: DATOS PERSONALES.</p><h3>Actualización de la Política de Privacidad</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p><p>Todos los derechos reservados.</p><h2>TÉRMINOS Y CONDICIONES PARA EL USO DE ESTE SITIO WEB</h2><h3>Condiciones generales</h3><p>Comercial Javerim LTDA con domicilio en Chesterton 8677, comuna de Las Condes, Santiago, (en adelante, Niu Sushi) se complace en ofrecerle este sitio web: www.niusushi.cl adelante, el \"Sitio Web\"), su contenido y sus servicios. Por favor lea cuidadosamente estos términos y condiciones (en adelante los \"Términos y Condiciones\") relacionados con el uso de nuestro Sitio Web. Al usar nuestro Sitio Web, Usted acepta estos Términos y Condiciones, sin limitación ni condición alguna. Si no está de acuerdo con estos Términos y Condiciones, por favor no utilice nuestro Sitio Web. Cualquier persona física y/o jurídica puede navegar gratuitamente en el Sitio Web, y no es necesario ser Usuario para ello.</p><p>Niu Sushi se reserva el derecho de revisar estos Términos y Condiciones o cualquier parte de ellos en cualquier momento sin previo aviso, actualizando esta publicación. Usted deberá visitar periódicamente esta página para revisar los presentes Términos y Condiciones que se aplican al uso que usted haga de nuestro Sitio Web.</p><p>Niu Sushi se reserva el derecho de interrumpir, suspender o modificar en cualquier momento los servicios ofrecidos en el Sitio Web, ya sea en forma permanente o transitoria. No se requerirá la conformidad de los Usuarios, ni será necesario aviso previo alguno a dichos efectos. Asimismo, no garantiza el acceso o uso permanente al Sitio Web, ya que éste podría interrumpirse por cuestiones técnicas totalmente ajenas a Niu Sushi. No obstante, si la suspensión o interrupción mencionada no obedeciere a razones de fuerza mayor o caso fortuito, Niu Sushi se compromete a cumplir con las prestaciones que estuvieren pendientes al momento de la suspensión y/o interrupción.</p><p>Niu Sushi no garantiza que el Sitio Web se encuentre libre de virus, gusanos o cualquier otro elemento que pueda llegar a dañar o alterar el normal funcionamiento de una computadora. Es su responsabilidad y obligación exclusiva contar con las herramientas adecuadas para detectar, desinfectar y/o prevenir cualquier tipo de elementos y/o posibles daños de esta naturaleza.</p><p>Niu Sushi no se responsabiliza por cualquier daño y/o perjuicio que pueda producirse en los equipos informáticos de los Usuarios o de terceros como consecuencia de la navegación en el Sitio Web.</p><p>En virtud de la naturaleza de los productos ofrecidos en este Sitio Web, se recomienda conservar los productos enviados por Niu Sushi en refrigeración, y consumir en el mismo día de adquisición de los mismos.</p><h3>Registro de Usuarios:</h3><p>Para realizar compras en el Sitio Web, es necesario registrarse como Usuario del mismo. Se deberá completar el Formulario en forma completa y correcta, incluyendo todos los datos personales que se requieran. El registro ocurre al momento de hacer su primer pedido, luego puede acceder al servicio ingresando su nombre de usuario y contraseña. Los datos personales suministrados, serán tratados por Niu Sushi de manera totalmente confidencial. Sugerimos consultar nuestra \"Política de Privacidad\" publicada en el Sitio Web, previo a su registro como Usuario.</p><h3>Demoras y disponibilidad de los productos ofrecidos.</h3><p>La disponibilidad de todos los productos y/o servicios y/o promociones en el Sitio Web, está sujeta al stock diario de productos y/o servicios y/o promociones de Niu Sushi. Todos los precios suministrados en el SitioWeb incluyen el Impuesto al Valor Agregado. Toda compra se encuentra sujeta a dicha disponibilidad, con lo cual se confirmará la disponibilidad con el número de pedido confirmado.</p><p>La información sobre productos y precios publicados en la página está sujeta a cambios y pueden ser modificados y/o actualizados a exclusiva discreción de Niu Sushi.</p><h3>Información de los productos y del servicio. Validez de las promociones.</h3><p>La información sobre los productos, servicios y promociones que provee Niu Sushi es suministrada en forma gratuita al Usuario en forma cierta, clara, detallada y veraz a través de el Sitio Web. En el caso de que se realicen ofertas y/o promociones de productos, éstas tendrán validez para los pedidos realizados desde el comienzo de aquellas, hasta la finalización de la oferta. Los términos y condiciones de las ofertas y/o promociones serán comunicados en el Sitio Web, y estarán siempre sujetas a la disponibilidad y stock de la materia prima con la cual se elaboran nuestros productos.</p><h3>Delivery. Alcance y tiempo de entrega. Consulta sobre el estado del envío.</h3><p>Las entregas de los productos de Niu Sushi se realizarán en la dirección que el Usuario indique a tal efecto. La validez de la dirección indicada es de exclusiva responsabilidad de los Usuarios. Al realizar un pedido online, el Usuario recibirá en su correo electrónico una confirmación del mismo junto a un número de pedido, y tiempo aproximado de entrega. El tiempo de entrega depende del tiempo de elaboración del pedido, del tiempo de envío y del horario en que se efectuó el pedido. Dicho de tiempo de espera es aproximado. Niu Sushi efectúa todo lo que se encuentra a su alcance para cumplir con el plazo de entrega de los pedidos.</p><h3>Gastos de envío</h3><p>Le recordamos consultar los precios de costos de envío, los cuales serán incluidos de manera explicita en el carro de compras para pedidos con despacho a domicilio. Niu Sushi se reserva el derecho de cambiar estos precios sin previo aviso.</p><h3>Horarios de Atención al Público</h3><p>Se podrán realizar pedidos a través de la página web entre las 12:00 y las 23:00 horas en días hábiles en que los locales de Niu Sushi estén operando.</p><h3>Facturación</h3><p>Junto con la entrega del pedido, se le entregará la boleta correspondiente con la información clara y precisa del pedido.</p><h3>Cancelación del pedido</h3><p>Sin perjuicio de lo establecido en los presentes Términos y Condiciones, el Usuario podrá cancelar su pedido telefónicamente. Sugerimos contactarse en cuanto antes para la cancelación del mismo, ya que Niu Sushi trabaja con productos frescos, que requieren la elaboración en el momento del pedido.</p><h3>Registro de reclamos. Atención personalizada.</h3><p>Niu Sushi habilita un registro de reclamos donde quedarán asentadas las presentaciones de los Usuarios. Los reclamos podrán efectuarse enviando un correo electrónico a niusushi@niusushi.cl, identificando el número del pedido realizado, su nombre y apellido, objeto y razones del reclamo. Los reclamos efectuados a través de correo electrónico serán respondidos por Niu Sushi telefónicamente o vía correo electrónico, dentro de los 10 días hábiles siguientes. Niu Sushi se compromete además a atender su reclamo y efectuar las averiguaciones pertinentes del mismo, dándole la seriedad que a todo reclamo corresponde.</p><h3>Prohibiciones</h3><p>Se les prohíbe terminantemente a los Usuarios y/o quienes naveguen en el Sitio Web a: a) Consignar datos falsos en el Formulario y/o al momento de realizar un pedido, y/o en cualquier otro momento que le sea requerida cualquier tipo de información o datos personales; y b) Usar programas, software o aparatos automáticos o manuales para monitorear o copiar la información o cualquier contenido del Sitio Web sin previo consentimiento de Niu Sushi.</p><h3>Derechos reservados. Propiedad Intelectual</h3><p>Todos los derechos del presente Sitio Webestán reservados. El contenido del presente Sitio Web, incluyendo aunque no limitado al texto, logos, gráficos y todo el diseño en general, es de propiedad o uso exclusivo de su titular registrado y se encuentra protegido por la legislación nacional e internacional vigente sobre propiedad intelectual.</p><h3>Enlaces a Sitios de Terceros</h3><p>Como una cortesía, hemos proporcionado enlaces a ciertos sitios web de terceros. Al proporcionar estos enlaces, Niu Sushi no está endosando, adoptando, o accediendo al contenido de estos sitios enlazados o a los productos y servicios de estos terceros ajenos a Niu Sushi. Niu Sushi no revisa o controla de manera alguna el contenido de estos sitios de terceros y ese contenido no forma parte de nuestro Sitio Web. Niu Sushi niega expresamente cualquier responsabilidad por el contenido de cualquier sitio de terceros enlazado a nuestro Sitio Web o los productos y servicios de estos terceros. Niu Sushi no se responsabiliza, ni responderá de manera alguna por los daños y perjuicios, ya sean actuales o eventuales, materiales o morales, directos o indirectos, que sufrieren los usuarios y que se derivaran de la información contenida en tales sitios de terceros o de la relación que los usuarios pudieren entablar con tales terceros. Niu Sushi no garantiza el contenido o exactitud de los materiales de los sitios de terceros, o los productos y servicios de terceros. Niu Sushi le ruega que verifique la seguridad y autenticidad de los sitios de terceros a los que acceda a través de un enlace en nuestro Sitio.</p><h3>Ley Aplicable y Jurisdicción</h3><p>Estos Términos y Condiciones se rigen por y serán interpretados de acuerdo a las leyes Chilenas. Tendrán jurisdicción sobre cualquier acción relacionada con estos Términos y Condiciones únicamente los Tribunales Ordinarios de Justicia asiento en la ciudad de Santiago de Chile.</p><h3>Validez por Separado</h3><p>Si cualquiera de las cláusulas incluidas en estos Términos y Condiciones se considerase inválida o inaplicable por cualquier corte o jurisdicción competente, las otras cláusulas incluidas en estos Términos y Condiciones de Uso permanecerán vigentes y resultarán aplicables. Cualquier cláusula incluida en estos Términos y Condiciones que sea considerada inválida o inaplicable parcialmente o hasta cierto punto únicamente, permanecerá vigente y resultará aplicable hasta el grado en el que haya sido declarada inválida o inaplicable. Niu Sushi podrá reemplazar dicha cláusula inválida o inaplicable incluida en estos Términos y Condiciones con otra cláusula válida y aplicable que alcance, hasta el grado posible, los propósitos económicos, comerciales y otros propósitos de dicha cláusula inválida o inaplicable.</p><h3>Acuerdo Completo</h3><p>Estos Términos y Condiciones representan el acuerdo en su totalidad entre usted y Niu Sushi referente a la utilización del Sitio Web y temas relacionados al mismo y no serán modificados excepto por Niu Sushi, mediante su publicación en el Sitio Web. Niu Sushi se reserva el derecho de modificar los términos y condiciones de uso de este Sitio Web y tales cambios tendrán vigencia desde su publicación en el Sitio Web. Usted estará obligado a revisar periódicamente los Términos y Condiciones publicados para verificar cualquier modificación que pudieren haber sufrido, y la sola utilización del Sitio Web implicará la aceptación total e incondicional de estos Términos y Condiciones, sin necesidad de manifestación alguna de su parte.</p><h3>Actualización de Términos y Condiciones.</h3><p>Cualquier cambio a la Política de Privacidad del Sitio Web será anunciado en esta página.</p></div></div><footer-cart></footer-cart>");
$templateCache.put("app/address/desktop/address.edit.html","<div class=\"container-fluid header\"><div class=\"container\"><div class=\"col-md-4 logo\"><img ui-sref=\"main\" src=\"assets/images/desktop/logo_tr.png\" alt=\"NIU Sushi logo\" height=\"40\"></div></div></div><div class=\"container-fluid container-contenido\"><div class=\"container mis-pedidos\"><div class=\"row\"><div class=\"col-sm-12 col-md-10 col-md-push-1\"><div class=\"header-pedidos\"><p>Nueva dirección</p></div><div class=\"carousel__vertical\"><div class=\"carousel__inner\"><div class=\"item\" id=\"comune\"><h2 class=\"title--pedido\">Comuna</h2><div class=\"seccion__agregar__direccion\"><div class=\"select__niu\"><label><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.scrollTo(\'map\') && address.getLonLatFromAddress(true)) : address.scrollTo(\'details\')\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select></label></div></div></div><div class=\"item\" id=\"details\" ng-show=\"address.comune\"><h2 class=\"title--pedido\">Ingresa tu dirección</h2><div class=\"seccion__agregar__direccion\"><div class=\"row\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-change=\"address.street_number && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-change=\"address.street_name && address.scrollTo(\'map\') && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div></div><div class=\"row\"><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div><div class=\"item\" ng-if=\"address.comune\" id=\"map\"><h2 class=\"title--pedido\">Confirma la ubicación (arrastra el pin si es necesario)</h2><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"address.lonLat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon.png\'}\"></ui-gmap-marker><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map></div></div></div></div><div class=\"seccion__progreso\"><div class=\"total__cont\"><button class=\"btn btn--color\" ng-click=\"address.saveAddress()\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección <i class=\"icon-arrow_ins_left\"></i></button></div></div></div></div></div></div>");
$templateCache.put("app/address/desktop/address.modal.html","<div class=\"modal-header\"><button type=\"button\" class=\"close close-modal\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"address.closeModal()\"><i class=\"icon-cruz\"></i></button><h1>Nueva dirección</h1></div><div class=\"modal-body container-fluid modal-address\"><div class=\"row\"><div class=\"col-sm-12 col-md-12\"><div class=\"carousel__vertical\"><div class=\"carousel__inner\"><div class=\"item\" id=\"comune\"><h2 class=\"title--pedido\">Comuna</h2><div class=\"seccion__agregar__direccion\"><div class=\"select__niu\"><label><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.scrollTo(\'map\') && address.getLonLatFromAddress(true)) : address.scrollTo(\'details\')\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select></label></div></div></div><div class=\"item\" id=\"details\" ng-show=\"address.comune\"><h2 class=\"title--pedido\">Ingresa tu dirección</h2><div class=\"seccion__agregar__direccion\"><div class=\"row\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" maxlength=\"50\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-change=\"address.street_number && address.scrollTo(\'map\') && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" ng-maxlength=\"10\" max=\"999999999\" placeholder=\"N°\" required=\"\" type=\"number\" ng-change=\"address.street_name && address.scrollTo(\'map\') && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div></div><div class=\"row\"><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" maxlength=\"50\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div><div class=\"item\" ng-if=\"address.street_number\" id=\"map\"><h2 class=\"title--pedido\">Confirma la ubicación (arrastra el pin hasta que esté en la dirección deseada)</h2><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"address.lonLat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon.png\'}\"></ui-gmap-marker><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map></div></div></div></div><div class=\"seccion__progreso\"><div class=\"total__cont\"><button class=\"btn btn--color\" ng-click=\"address.saveAddress()\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div></div></div></div>");
$templateCache.put("app/address/mobile/address.edit.html","<div class=\"container_site padding_chek\"><div class=\"container-fluid border_head header__app\"><div class=\"contianer\"><a class=\"col-xs-2 retroceder\" ui-sref=\"{{address.backState}}\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-10 frace_local\"><p>NIU SUHI</p></div></div></div><div class=\"bienvenidos\"><small>Ingresa tu Dirección</small></div><div class=\"welcome-checkout ending-order login-data\"><div class=\"container_campo_login\"><select class=\"select2 select-direction\" required=\"\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select><input class=\"campo_login col-xs-8\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-model=\"address.street_name\"> <input class=\"campo_login col-xs-4\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-model=\"address.street_number\"> <input class=\"campo_login\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div><a class=\"siguiente\" ng-click=\"address.getLonLatFromAddress()\" ng-disabled=\"!(address.comune && address.street_name && address.street_number)\"><p>Guardar Dirección</p></a></div>");
$templateCache.put("app/address/mobile/address.modal.html","<div class=\"address-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close_modal\" ng-click=\"address.close()\"><i class=\"icon-cruz\"></i></button><h1>Ingresa tu Dirección</h1></div><div ng-if=\"address.step == 0\"><form><div class=\"modal-body modal-address container-fluid\"><div class=\"welcome-checkout ending-order login-data\"><div class=\"container_campo_login\"><p>Selecciona tu comuna</p><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.getLonLatFromAddress(true)) : \'\'\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\" class=\"select-direction\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select><div class=\"clearfix\"></div><p ng-show=\"address.comune\">Escribe tu dirección</p><div class=\"row\" ng-show=\"address.comune\" id=\"details\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" maxlength=\"50\" ng-change=\"address.street_number && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" placeholder=\"N°\" max=\"999999999\" ng-maxlength=\"10\" required=\"\" type=\"number\" ng-change=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" maxlength=\"50\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div></div><div class=\"modal-footer modal_footer_perdidos\"><button class=\"siguiente\" ng-click=\"address.selectOnMap()\" ng-disabled=\"!address.street_name || !address.street_number\">Siguiente</button></div></form></div><div ng-if=\"address.step == 1\"><div class=\"modal-body container-fluid container-contenido modal-address\"><p class=\"paddres\">Confirma la ubicación (arrastra el mapa hasta que el pin esté en la dirección deseada)</p><div id=\"map\"><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map><div class=\"marker\"></div></div></div></div><div class=\"modal-footer modal_footer_perdidos\"><button class=\"siguiente\" ng-click=\"address.saveAddress(true)\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div></div>");
$templateCache.put("app/address/mobile/map-modal.html","<div class=\"address-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close close_modal\" ng-click=\"address.close()\"><span aria-hidden=\"true\">&times;</span></button><h1>Ingresa tu Dirección</h1></div><div class=\"modal-body container-fluid container-contenido modal-address\"><div id=\"map\"><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" pan=\"true\" zoom=\"16\"><ui-gmap-marker coords=\"address.lonLat\" idkey=\"1\" options=\"{draggable: true, icon: \'/assets/images/address_icon.png\'}\"></ui-gmap-marker><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map></div></div><button class=\"siguiente\" ng-click=\"address.saveAddress()\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div>");
$templateCache.put("app/address/mobile/new.html","<div class=\"container_site no__margin color_fondo__body\"><div class=\"container-fluid header__app\"><div class=\"contianer\"><a class=\"col-xs-3 retroceder\" ng-click=\"address.close()\"><i class=\"icon-arrow_ins_right\"></i></a> <a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/logo-nocache1.png\" alt=\"\" width=\"70\" style=\"margin:0 auto; display:block;\"></a></div></div><div class=\"address-modal\"><h1>Ingresa tu Dirección</h1><div ng-if=\"address.step == 0\"><div class=\"welcome-checkout ending-order login-data\"><div class=\"container_campo_login\"><p>Selecciona tu comuna</p><select required=\"\" ng-change=\"!!(address.street_name && address.street_number) ? (address.getLonLatFromAddress(true)) : address.scrollTo(\'details\')\" ng-model=\"address.comune\" ng-options=\"comune as comune.name for comune in address.comunes\" class=\"select-direction\"><option value=\"\" disabled=\"\" selected=\"\">Selecciona tu comuna</option></select><div class=\"clearfix\"></div><p ng-show=\"address.comune\">Escribe tu dirección</p><div class=\"row\" ng-show=\"address.comune\" id=\"details\"><div class=\"col-md-8\"><input class=\"large\" name=\"street\" placeholder=\"Nombre de tu Calle\" required=\"\" type=\"text\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" ng-change=\"address.street_number && address.getLonLatFromAddress(true)\" ng-model=\"address.street_name\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 0 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"number\" placeholder=\"N°\" required=\"\" type=\"text\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" ng-change=\"address.street_name && address.getLonLatFromAddress(true)\" ng-model=\"address.street_number\" ng-model-options=\"{ updateOn: \'default change blur\', debounce: { default: 1000, change: 0, blur: 3000 } }\"></div><div class=\"col-md-4\"><input class=\"large\" name=\"specific-number\" ng-focus=\"address.fixCss($event, true)\" ng-blur=\"address.fixCss($event, false)\" placeholder=\"N° Depto, Oficina, etc. (Opcional)\" type=\"text\" ng-model=\"address.specific_number\"></div></div></div></div><button class=\"siguiente\" ng-click=\"address.selectOnMap()\" ng-disabled=\"!address.street_name || !address.street_number\">Siguiente</button></div><div ng-if=\"address.step == 1\"><div class=\"map-container login-data\"><p>Confirma la ubicación (arrastra el mapa hasta que el pin esté en la dirección deseada)</p><div id=\"map\"><div class=\"seccion__agregar__direccion\"><ui-gmap-google-map center=\"address.mapLonLat\" options=\"address.mapOptions\" draggable=\"true\" pan=\"true\" zoom=\"16\"><ui-gmap-map-control index=\"-1\" position=\"right-bottom\" template=\"app/address/restore/restore.html\"></ui-gmap-map-control></ui-gmap-google-map><div class=\"marker\"></div></div></div></div><button class=\"siguiente\" ng-click=\"address.saveAddress(true)\" ng-disabled=\"!address.street_name || !address.street_number\">Guardar dirección</button></div></div></div>");
$templateCache.put("app/address/restore/restore.html","<button class=\"btn btn-sm btn-success\" ng-click=\"$emit(\'restore-location\')\"><span class=\"glyphicon glyphicon-repeat\"></span><br>Restaurar<br>ubicación</button>");
$templateCache.put("app/cart/desktop/cart.when-how-n-where.html","<div class=\"container-fluid header header-desktop\"><div class=\"container\"><a ui-sref=\"menu\" class=\"col-md-4 col-xs-12 logo\"><img ui-sref=\"main\" src=\"assets/images/desktop/logo_tr.png\" alt=\"NIU Sushi logo\" height=\"40\"></a></div></div><div class=\"container-fluid container-contenido\"><div class=\"container mis-pedidos\"><div class=\"row\"><div class=\"col-md-7 col-md-offset-1 col-xs-8\"><div class=\"header-pedidos\"><p>Detalles del pedido</p></div><div class=\"body-pedidos\"><div class=\"carousel__vertical\" style=\"background-color: #252525;\"><div class=\"carousel__inner\"><div class=\"item\" ng-if=\"false\"><h2 class=\"title--pedido\">¿Cuando lo quieres disfrutar</h2><div class=\"seleccion__pedido\"><input id=\"when-now\" name=\"when\" type=\"radio\" value=\"now\" ng-change=\"cart.selectQuestion(\'how\')\" ng-model=\"cart.when\"> <label class=\"cont__pedido\" for=\"when-now\"><strong>Ahora</strong> ¡lo antes posible! <i class=\"icon-check\"></i></label> <input id=\"when-later\" name=\"when\" type=\"radio\" value=\"later\" ng-change=\"cart.selectQuestion(\'how\')\" ng-model=\"cart.when\"> <label class=\"cont__pedido\" for=\"when-later\"><strong>Mas tarde</strong> o incluso mañana <i class=\"icon-check\"></i></label></div></div><div class=\"item\" id=\"how\"><h2 class=\"title--pedido\">¿Cómo lo quieres?</h2><div class=\"seleccion__pedido\"><input id=\"how-pickup\" name=\"how\" type=\"radio\" value=\"pickup\" ng-change=\"cart.getOpenRestaurants() && cart.selectQuestion(\'where\')\" ng-model=\"cart.how\"> <label class=\"cont__pedido\" for=\"how-pickup\" style=\"margin-right:-1px;\"><div class=\"type-box\"><span>Retiro<br>en local</span> <small>&nbsp;</small></div><div class=\"time-icon pick\"><span ng-show=\"cart.restaurantsAveragePickupTime > 0\">{{cart.restaurantsAveragePickupTime}} <small>min</small></span></div></label> <input id=\"how-delivery\" name=\"how\" type=\"radio\" value=\"delivery\" ng-change=\"cart.getCustomerAddresses() && cart.selectQuestion(\'where\')\" ng-model=\"cart.how\"> <label class=\"cont__pedido\" for=\"how-delivery\"><div class=\"type-box\"><span>Despacho a<br>Domicilio</span> <small>+ $ 1.500 de envío</small></div><div class=\"time-icon\"><span ng-show=\"cart.customersAverageDeliveryTime > 0\">{{cart.customersAverageDeliveryTime}} <small>min</small></span></div></label></div></div><div class=\"item\" id=\"where\" ng-if=\"cart.how == \'pickup\'\"><h2 class=\"title--pedido\">¿Dónde lo quieres?</h2><div class=\"seleccion__pedido-ad no_radius\"><input id=\"where-{{$index}}\" name=\"where\" ng-change=\"cart.selectQuestion(\'cual\')\" ng-model=\"cart.selectedLocation\" ng-repeat-start=\"location in cart.restaurantLocations\" ng-value=\"location\" type=\"radio\"> <label class=\"cont__pedido address-cart\" for=\"where-{{$index}}\" ng-repeat-end=\"\"><div ng-if=\"cart.how == \'pickup\'\"><div class=\"type-box\"><span ng-show=\"location.name\">{{location.name}}</span> <small>{{location.address}}</small></div><div class=\"time-icon\" ng-show=\"location.name\"><span>{{location.current_pickup_time}} <small>min</small></span></div></div></label><div class=\"clearfix\"></div></div></div><div class=\"item\" id=\"where\" ng-if=\"cart.how == \'delivery\'\"><h2 class=\"title--pedido\">¿Dónde lo quieres?</h2><div class=\"seleccion__pedido-ad no_radius\"><input id=\"where-{{$index}}\" name=\"where\" ng-change=\"cart.selectQuestion(\'cual\')\" ng-model=\"cart.selectedLocation\" ng-repeat-start=\"location in cart.addressLocations\" ng-value=\"location\" type=\"radio\"> <label class=\"cont__pedido address-cart\" for=\"where-{{$index}}\" ng-repeat-end=\"\"><div ng-if=\"cart.how == \'delivery\'\" class=\"home\"><div class=\"type-box\"><span ng-show=\"location.address\">{{location.address.split(\',\')[0]}}</span> <small>{{location.address.split(\',\')[location.address.split(\',\').length - 1]}}</small></div><div class=\"time-icon\" ng-show=\"location.delivery_restaurant_pickup_time && location.delivery_restaurant_pickup_time > 0\"><span>{{location.delivery_restaurant_pickup_time}} <small>min</small></span></div><i ng-click=\"cart.deactivateAddress(location)\" class=\"icon-cerrar\"></i></div></label><div class=\"clearfix\"></div><a class=\"cont__pedido address-cart\" ng-if=\"cart.how == \'delivery\'\" href=\"javascript:void(0)\" ng-click=\"cart.newAddressModal()\">Agregar nueva dirección</a></div></div><div class=\"item\" id=\"payment-when\" ng-if=\"false\"><h2 class=\"title--pedido\">¿Cuándo lo quieres pagar</h2><div class=\"seleccion__pedido\"><input id=\"payment-when-now\" name=\"cuando\" type=\"radio\" value=\"now\" ng-change=\"cart.paymentDiscount = cart.updatedDiscount(50)\" ng-model=\"cart.paymentWhen\"> <label class=\"cont__pedido\" for=\"payment-when-now\"><strong>Ahora en Línea&nbsp;</strong>50% Dcto. todo medio de pago <i class=\"icon-check\"></i></label> <input id=\"payment-when-later\" name=\"cuando\" type=\"radio\" value=\"later\" ng-change=\"cart.selectedCC = null\" ng-model=\"cart.paymentWhen\"> <label class=\"cont__pedido\" for=\"payment-when-later\"><strong ng-show=\"cart.how == \'delivery\'\">Después en casa</strong> <strong ng-show=\"cart.how == \'pickup\'\">Después en el restaurant&nbsp;</strong> Hasta 50% Dcto. <i class=\"icon-check\"></i></label></div></div><div class=\"item\" id=\"cual\" ng-show=\"cart.selectedLocation\"><h2 class=\"title--pedido\">¿Cuál es tu medio de pago?</h2><div class=\"seleccion__pedido\"><input id=\"cual-efectivo\" name=\"cual\" type=\"radio\" value=\"50\" ng-change=\"cart.updatedDiscount(cart.paymentDiscount)\" ng-model=\"cart.paymentDiscount\"> <label class=\"cont__pedido\" for=\"cual-efectivo\" style=\"margin-right:-1px;\"><span><b>50% Dcto</b></span> <small>Efectivo, Tarjeta de Débito (RedCompra)</small></label> <input id=\"cual-tarjeta\" name=\"cual\" type=\"radio\" value=\"40\" ng-change=\"cart.updatedDiscount(cart.paymentDiscount)\" ng-model=\"cart.paymentDiscount\"> <label class=\"cont__pedido\" for=\"cual-tarjeta\"><span><b>40% Dcto</b></span> <small>Tarjeta de Crédito o Cheque Restaurant</small></label></div></div></div></div></div><div class=\"seccion__progreso\"><div class=\"total__cont\"><button class=\"btn btn--color next\" ng-click=\"cart.sendOrder()\" ng-disabled=\"cart.inProgress || cart.isClosed || !cart.selectedLocation || !(cart.selectedCC || cart.paymentDiscount) || (cart.selectedLocation.delivery_restaurant_pickup_time && cart.selectedLocation.delivery_restaurant_pickup_time < 0)\">¡Confirmar compra! <i class=\"icon-arrow_ins_left\"></i></button></div></div></div><div class=\"col-md-3 col-xs-4 tm\"><div class=\"header-pedidos\"><p>Mi Pedido</p><i class=\"icon-comprar shopping-cart\"><input type=\"text\" id=\"valorInput\" class=\"prodMas\" ng-value=\"cart.count\" disabled=\"\"></i></div><div class=\"body-pedidos\"><div class=\"row mi__pedido\" ng-repeat=\"item in cart.items | orderBy:\'addedAt\'\"><span class=\"col-md-1 col-sm-1 cantidad\">{{cart.productCount(item)}}x</span><div class=\"col-md-8 col-sm-8\"><p class=\"pedido\">{{item.seleable.name}}</p></div><div class=\"col-md-3 col-sm-3 text-right\"><p class=\"antes\" ng-show=\"item.seleable.discount\">{{cart.price(item, false) | currency:\"\":0}}</p><p class=\"ahora\">{{cart.price(item, true) | currency:\"\":0}}</p></div></div><div class=\"row mi__pedido extra-info\"><p>Agregamos Gratis:</p><span><em ng-show=\"cart.totalChopsticks > 0\">{{cart.totalChopsticks}} Palitos</em> <em ng-show=\"cart.totalSoySauce > 0\">{{cart.totalSoySauce}} Salsa de Soya</em> <em ng-show=\"cart.includesGinger\">Gengibre</em> <em ng-show=\"cart.includesWasabi\">Wasabi</em></span></div></div><div class=\"footer-pedidos\"><div class=\"total\"><p>Total a pagar</p><ul><li class=\"antes\"><em class=\"name\">Total normal</em> {{(cart.total - ((cart.how == \'delivery\') ? 1500 : 0)) | currency:\"$ \":0}}</li><li class=\"delivery\" ng-if=\"cart.how == \'delivery\'\"><em class=\"name\">Oferta</em> {{(cart.totalDiscount - 1500) | currency:\"$ \":0}}</li><li class=\"delivery\" ng-if=\"cart.how == \'delivery\'\"><em class=\"name\">Delivery</em> + $ 1.500</li><li class=\"ahora\">{{cart.totalDiscount | currency:\"$ \":0}}</li></ul></div></div><a ui-sref=\"menu\" class=\"modificar--pedido\">Modificar Pedido</a></div></div></div></div>");
$templateCache.put("app/cart/mobile/cart.when-how-n-where.html","<div class=\"container-fluid header_app\"><div class=\"contianer\"><div class=\"col-xs-3\" ui-sref=\"cart.products\"><a class=\"retroceder\"><i class=\"icon-arrow_ins_right\"></i></a></div><a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/desktop/logo_tr.png\" alt=\"\" width=\"70\" style=\"display:block;margin:0 auto;\"></a></div></div><div class=\"container_site container_checkout\"><div class=\"bienvenidos titulo\"><p>Detalles del pedido</p></div><div class=\"welcome-checkout\"><div class=\"container-button-radio\"><p>¿Cómo lo quieres?</p><input id=\"how-pickup\" name=\"how\" type=\"radio\" value=\"pickup\" ng-change=\"cart.getOpenRestaurants()\" ng-model=\"cart.how\" ng-click=\"gotoWhere\"> <label class=\"buttonselect\" for=\"how-pickup\"><div class=\"type-box\"><span>Retiro<br>en local</span></div><div class=\"time-icon pick\"><span ng-show=\"cart.restaurantsAveragePickupTime > 0\">{{cart.restaurantsAveragePickupTime}} <small>min</small></span></div><div class=\"clearfix\"></div><small>&nbsp;</small></label> <input id=\"how-delivery\" name=\"how\" type=\"radio\" value=\"delivery\" ng-change=\"cart.getCustomerAddresses()\" ng-model=\"cart.how\" ng-click=\"gootoWhere\"> <label class=\"buttonselect\" for=\"how-delivery\"><div class=\"type-box\"><span>Despacho a<br>Domicilio</span></div><div class=\"time-icon\"><span ng-show=\"cart.customersAverageDeliveryTime > 0\">{{cart.customersAverageDeliveryTime}} <small>min</small></span></div><div class=\"clearfix\"></div><small>+ $ 1.500 de envío</small></label></div><div class=\"container-button-radio\" id=\"where\" ng-if=\"cart.how == \'pickup\'\"><p>¿Dónde lo quieres?</p><input id=\"where-{{$index}}\" name=\"where\" ng-model=\"cart.selectedLocation\" ng-repeat-start=\"location in cart.restaurantLocations\" ng-value=\"location\" type=\"radio\"> <label class=\"buttonselect button-direction\" for=\"where-{{$index}}\" ng-repeat-end=\"\"><div ng-if=\"cart.how == \'pickup\'\"><div class=\"type-box\"><span ng-show=\"location.name\">{{location.name}}</span> <small>{{location.address}}</small></div><div class=\"time-icon\" ng-show=\"location.name\"><span>{{location.current_pickup_time}} <small>min</small></span></div></div></label></div><div class=\"container-button-radio\" id=\"where\" ng-if=\"cart.how == \'delivery\'\"><p>¿Dónde lo quieres?</p><input id=\"where-{{$index}}\" name=\"where\" ng-model=\"cart.selectedLocation\" ng-repeat-start=\"location in cart.addressLocations\" ng-value=\"location\" type=\"radio\"> <label class=\"buttonselect button-direction\" for=\"where-{{$index}}\" ng-repeat-end=\"\"><div ng-if=\"cart.how == \'delivery\'\" class=\"home\"><div class=\"type-box\"><span ng-show=\"location.address\">{{location.address.split(\',\')[0]}}</span> <small>{{location.address.split(\',\')[location.address.split(\',\').length - 1]}}</small></div><div class=\"time-icon\" ng-show=\"location.delivery_restaurant_pickup_time && location.delivery_restaurant_pickup_time > 0\"><span>{{location.delivery_restaurant_pickup_time}} <small>min</small></span></div><i ng-click=\"cart.deactivateAddress(location)\" class=\"icon-cerrar\"></i></div></label> <a class=\"buttonselect button-direction\" ng-if=\"cart.how == \'delivery\'\" href=\"javascript:void(0)\" ng-click=\"cart.newAddressModal(true)\"><p>Nueva dirección</p></a></div><div class=\"container-button-radio\" ng-if=\"cart.selectedLocation && (cart.how == \'pickup\' || cart.how == \'delivery\')\"><p>¿Cuál es tu medio de pago?</p><input id=\"cual-efectivo\" name=\"cual\" type=\"radio\" value=\"50\" ng-change=\"cart.updatedDiscount(cart.paymentDiscount)\" ng-model=\"cart.paymentDiscount\"> <label class=\"buttonselect height-btn\" for=\"cual-efectivo\"><small>Efectivo, Tarjeta de Débito(RedCompra)</small> <span><b>50% Dcto.</b></span></label> <input id=\"cual-tarjeta\" name=\"cual\" type=\"radio\" value=\"40\" ng-change=\"cart.updatedDiscount(cart.paymentDiscount)\" ng-model=\"cart.paymentDiscount\"> <label class=\"buttonselect height-btn\" for=\"cual-tarjeta\"><small>Tarjeta de Crédito o Cheque Restaurant</small> <span><b>40% Dcto.</b></span></label></div></div><div class=\"container__agregados btn-link\"><div class=\"mensajes_agregados-total\"><p class=\"Total\">Total a Pagar</p><div class=\"container_Valor_total line-height\"><span>{{cart.total | currency:\"$ \":0}}</span><p>{{cart.totalDiscount | currency:\"$ \":0}}</p></div></div></div><button class=\"siguiente\" ng-click=\"cart.sendOrder()\" ng-disabled=\"cart.inProgress || cart.isClosed || !cart.selectedLocation || !(cart.selectedCC || cart.paymentDiscount) || (cart.selectedLocation.delivery_restaurant_pickup_time && cart.selectedLocation.delivery_restaurant_pickup_time < 0)\"><p>¡Confirmar compra!</p><i class=\"icon-arrow_ins_left\"></i></button></div>");
$templateCache.put("app/components/footer-cart/footer-cart.html","<div class=\"container-fluid footer\"><div class=\"container\"><div class=\"col-sm-6 col-md-6 redes-footer\"><span>Comparte con tus amigos:</span><ul><li><a href=\"https://twitter.com/NIUsushi\" target=\"_blank\" class=\"twitter\"><img src=\"assets/images/desktop/twitter.png\" alt=\"twitter\"></a></li><li><a href=\"https://www.facebook.com/niusushi/\" target=\"_blank\" class=\"facebook\"><img src=\"assets/images/desktop/facebook.png\" alt=\"facebook\"></a></li></ul></div><div class=\"col-sm-6 col-md-6 redes-footer\"><span>Medios de pago:</span><br><br><img src=\"assets/images/desktop/medios-de-pago.png\" alt=\"redcompra\"></div></div></div><div class=\"container-fluid end-footer\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><p>Horario de atención: Lunes a sábado en locales de 12:00 a 17:00 y 18:00 a 24:00 hrs y online de 12:00 a 17:00 y 18:00 a 23:00 hrs.</p><span>&copy; NIU Sushi. Todos los derechos reservados.</span></div></div></div></div>");
$templateCache.put("app/customer-session/desktop/login.html","<div class=\"modal-body\"><h1>¡Bienvenid@!</h1><span>Ingresa y customiza tu carta<br>NIU Sushi</span><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><input type=\"email\" placeholder=\"Email\" ng-model=\"customerSession.loginForm.email\" required=\"\" name=\"email\"> <input type=\"password\" placeholder=\"Clave\" ng-model=\"customerSession.loginForm.password\" required=\"\" name=\"password\"> <a class=\"olvidar-clave\" ui-sref=\"resetPassword({email: customerSession.loginForm.email})\">¿Olvidaste tu clave?</a> <button type=\"submit\" class=\"boton_red\">Ingresar</button></form></div>");
$templateCache.put("app/customer-session/desktop/registration.html","<div class=\"container-i-am-registered\"><form name=\"loginForm\" ng-submit=\"customerSession.login(customerSession.loginForm)\" class=\"modal-header\"><h1>Estoy Registrado</h1><span>¡Quiero entrar de inmediato!</span><br><input type=\"email\" placeholder=\"Email\" ng-model=\"customerSession.loginForm.email\" name=\"email\"> <input type=\"password\" placeholder=\"Clave\" ng-model=\"customerSession.loginForm.password\" name=\"password\"> <a ui-sref=\"resetPassword({email: customerSession.loginForm.email})\" class=\"olvidar-clave-modal-style\">¿Olvidaste tu clave?</a> <button type=\"submit\" class=\"boton_red next\" ng-disabled=\"!loginForm.$valid\">Ingresar</button></form></div><div class=\"container-i-am-registered\" style=\"border: none;\"><form name=\"registrationForm\" ng-submit=\"customerSession.register()\" class=\"modal-header\"><h1>No Estoy Registrado</h1><span>¡Es mi primera compra!</span><br><input autocomplete=\"name\" type=\"text\" name=\"name\" ng-model=\"customerSession.registrationForm.name\" required=\"\" placeholder=\"Nombre y Apellido\"> <input autocomplete=\"off\" type=\"email\" name=\"email\" ng-model=\"customerSession.registrationForm.email\" required=\"\" placeholder=\"Email\"><div class=\"row\"><div class=\"col-xs-3\"><input disabled=\"\" ng-model=\"customerSession.registrationForm.phone.prefix\"></div><div class=\"col-xs-9\"><input autocomplete=\"tel\" name=\"phone\" placeholder=\"\'8765 4321\' (celular)\" type=\"tel\" ng-model=\"customerSession.registrationForm.phone.number\" ng-pattern=\"customerSession.phoneRegex\" required=\"\"></div></div><input autocomplete=\"password\" type=\"password\" name=\"password\" ng-model=\"customerSession.registrationForm.password\" required=\"\" placeholder=\"Clave\"> <button type=\"submit\" class=\"boton_red next\" ng-disabled=\"!registrationForm.$valid\">Guardar datos</button></form></div><div class=\"clear\"></div>");
$templateCache.put("app/customer-session/desktop/reset-password.html","<form class=\"col-md-12 container-olvide-mi-clave\" ng-show=\"!(customerSession.isEmailSent || customerSession.error)\" ng-submit=\"customerSession.resetPassword(customerSession.resetForm)\"><fieldset ng-disabled=\"customerSession.isSendingForm\"><img src=\"assets/images/desktop/triste.png\" alt=\":(\"><p>Olvidaste tu<br>Clave</p><input name=\"email\" ng-model=\"customerSession.resetForm.email\" placeholder=\"ejemplo@gmail.com\" required=\"\" type=\"email\"> <button class=\"boton_red\" type=\"submit\">Recuperar Clave</button><div class=\"clearfix\"></div><a class=\"olvidar-clave volver_login\" ui-sref=\"login\">Volver</a></fieldset></form><div class=\"welcome-checkout\" ng-if=\"customerSession.isEmailSent\"><div class=\"tick\"><i class=\"icon-check\"></i></div><div class=\"title-check\"><p>Bien</p><span class=\"Message-Error\">Se te ha enviado un email a \'{{customerSession.resetForm.email}}\' con instrucciones para restaurar tu contraseña. Te debiese llegar en los próximos minutos. Por mientras, <a ng-click=\"$close()\" ui-sref-opts=\"{location: \'replace\'}\">revisa qué quieres pedir</a>.</span></div></div><div class=\"welcome-checkout error-encuesta\" ng-if=\"customerSession.error\"><div class=\"tick\"><i class=\"icon-cerrar\"></i></div><div class=\"title-check\"><p>Ups!</p><span class=\"Message-Error\">{{customerSession.error}}<br><a ng-click=\"customerSession.error = null\">Inténtalo nuevamente.</a></span></div></div><div class=\"clearfix\"></div>");
$templateCache.put("app/customer-session/mobile/login.html","<div class=\"login-regist-form\"><header-cart></header-cart><div class=\"container_site color_fondo__body\"><div class=\"bienvenidos\"><p>¡Bienvenid@!</p><span>Ingresa y customiza tu carta<br>NIU Sushi</span><form ng-submit=\"customerSession.login(customerSession.loginForm)\"><div class=\"form-login\"><input type=\"email\" placeholder=\"Email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" ng-model=\"customerSession.loginForm.email\" required=\"\" name=\"email\" class=\"input-text\"> <i class=\"icon-cruz icon-X\"></i> <input type=\"password\" placeholder=\"Clave\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" ng-model=\"customerSession.loginForm.password\" required=\"\" name=\"password\" class=\"campo_login\"> <a ng-click=\"customerSession.togglePassword()\" class=\"icon-ojo icon_password eye-on\"></a> <img src=\"assets/images/eye.png\" width=\"29\" alt=\"\" class=\"icon_password eye-off off-view\"></div><a ui-sref=\"resetPassword({email: customerSession.loginForm.email})\" class=\"REpass\">¿Olvidaste tu clave?</a> <button type=\"submit\" class=\"ingresar_btn\">Ingresar <i class=\"icon-arrow_ins_left\"></i></button></form></div></div></div>");
$templateCache.put("app/customer-session/mobile/registration.html","<div class=\"login-regist-form\"><div class=\"container_site no__margin color_fondo__body\"><div class=\"container-fluid header__app\"><div class=\"contianer\"><a class=\"col-xs-3 retroceder\" ui-sref=\"cart.products\"><i class=\"icon-arrow_ins_right\"></i></a> <a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/desktop/logo_tr.png\" alt=\"\" width=\"70\" style=\"margin:0 auto; display:block;\"></a></div></div><div class=\"bienvenidos-reg\"><p>Ingresa tus Datos</p><form name=\"form\" ng-submit=\"customerSession.register()\"><div class=\"form-user-connecting\"><input class=\"col-xs-12\" type=\"text\" name=\"name\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" ng-model=\"customerSession.registrationForm.name\" required=\"required\" placeholder=\"Nombre y Apellido\"> <input class=\"col-xs-12\" type=\"email\" name=\"email\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" ng-model=\"customerSession.registrationForm.email\" required=\"required\" placeholder=\"Email\"> <input class=\"col-xs-3\" disabled=\"\" ng-model=\"customerSession.registrationForm.phone.prefix\"> <input class=\"col-xs-9\" name=\"phones\" placeholder=\"\'8765 4321\' (celular)\" required=\"required\" type=\"tel\" ng-focus=\"customerSession.fixCss($event, true)\" ng-blur=\"customerSession.fixCss($event, false)\" ng-model=\"customerSession.registrationForm.phone.number\" ng-pattern=\"customerSession.phoneRegex\"><div class=\"clearfix\"></div></div><a ui-sref=\"login({ redirectTo: \'cart.whenhowwhere\' })\" class=\"REpass\">Ya estoy registrado</a> <button class=\"siguiente\" type=\"submit\" ng-disabled=\"!(form.$valid)\">Guardar Datos</button></form></div></div></div>");
$templateCache.put("app/customer-session/mobile/reset-password.html","<header-cart></header-cart><div class=\"container_site color_fondo__body\"><form class=\"bienvenidos\" ng-show=\"!(customerSession.isEmailSent || customerSession.error)\" ng-submit=\"customerSession.resetPassword(customerSession.resetForm)\"><fieldset ng-disabled=\"customerSession.isSendingForm\"><p class=\"Mal_icon\">:(</p><p>Olvidaste tu Clave</p><div class=\"container_campo_login\"><input class=\"input-text\" name=\"email\" ng-model=\"customerSession.resetForm.email\" placeholder=\"ejemplo@gmail.com\" required=\"\" type=\"email\"></div><button class=\"ingresar_btn\" type=\"submit\">Recuperar Clave <i class=\"icon-arrow_ins_left\"></i></button></fieldset></form><div class=\"welcome-checkout-bien\" ng-if=\"customerSession.isEmailSent\"><div class=\"tick\"><i class=\"icon-check\"></i></div><div class=\"title-check\"><p>Bien</p><span class=\"Message-Error\">Se te ha enviado un email a \'{{customerSession.resetForm.email}}\' con instrucciones para restaurar tu contraseña. Te debiese llegar en los próximos minutos. Por mientras, <a ui-sref=\"menu\" ui-sref-opts=\"{location: \'replace\'}\">revisa qué quieres pedir</a></span></div></div><div class=\"welcome-checkout error-encuesta\" ng-if=\"customerSession.error\"><div class=\"tick\"><i class=\"icon-cerrar\"></i></div><div class=\"title-check\"><p>Ups!</p><span class=\"Message-Error\">{{customerSession.error}}<br><a ng-click=\"customerSession.error = null\">Inténtalo nuevamente.</a></span></div></div></div>");
$templateCache.put("app/faq/desktop/faq.html","<header-cart></header-cart><div class=\"container container-contenido\"><div class=\"col-md-10 col-md-push-1\"><h2 class=\"title--page\" ng-repeat-start=\"(g, group) in faq.questions\">{{group.name}}</h2><div class=\"panel-group collapse--niu vAccordion--default\" role=\"tablist\" aria-multiselectable=\"false\" ng-repeat=\"(id, question) in group.questions\" ng-repeat-end=\"\"><div class=\"panel panel-default is-pane\" ng-class=\"{\'is-expanded\': question.isExpanded}\"><div class=\"panel-heading is-pane-header\" role=\"tab\" id=\"{{\'question-\'+g+\'-\'+id}}\" ng-click=\"question.isExpanded = !question.isExpanded\"><a role=\"button\" aria-expanded=\"{{question.isExpanded}}\"><h5 class=\"panel-title\">{{question.q}}</h5></a></div><div id=\"collapse1\" class=\"panel-collapse is-pane-content\" role=\"tabpanel\" aria-labelledby=\"{{\'question-\'+g+\'-\'+id}}\" ng-class=\"{\'collapse\': !question.isExpanded}\"><div class=\"panel-body\"><p>{{question.a}}</p></div></div></div></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/feedback/desktop/feedback.html","<div class=\"container-fluid header header-desktop\"><div class=\"container\"><div class=\"col-md-4 logo\"><img ui-sref=\"main\" src=\"assets/images/desktop/logo_tr.png\" alt=\"NIU Sushi logo\" height=\"40\"></div></div></div><div class=\"container-fluid container-contenido\"><div class=\"container mis-pedidos\"><div class=\"row\"><form name=\"form\" class=\"col-md-8 col-md-offset-2\" ng-submit=\"feedback.sendFeedback()\"><div class=\"header-pedidos\"><p>Encuesta</p></div><div class=\"carousel__vertical\" style=\"background-color: #252525;\"><div class=\"carousel__inner\"><div class=\"item\" id=\"withinPromisedTime\"><h2 class=\"title--pedido\">¿Recibiste tu pedido en el tiempo prometido?</h2><div class=\"seleccion__pedido\"><input id=\"withinPromisedTime-yes\" name=\"withinPromisedTime\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"cont__pedido\" for=\"withinPromisedTime-yes\">Si</label> <input id=\"withinPromisedTime-no\" name=\"withinPromisedTime\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.scrollTo(\'receivedAllProducts\')\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"cont__pedido\" for=\"withinPromisedTime-no\">No</label></div></div><div class=\"item\" id=\"receivedAllProducts\"><h2 class=\"title--pedido\">¿Recibiste todos los productos correctamente?</h2><div class=\"seleccion__pedido\"><input id=\"receivedAllProducts-yes\" name=\"receivedAllProducts\" required=\"\" type=\"radio\" value=\"yes\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"cont__pedido\" for=\"receivedAllProducts-yes\">Si</label> <input id=\"receivedAllProducts-no\" name=\"receivedAllProducts\" type=\"radio\" required=\"\" value=\"no\" ng-change=\"feedback.scrollTo(\'recommendToFriend\')\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"cont__pedido\" for=\"receivedAllProducts-no\">No</label></div></div><div class=\"item\" id=\"recommendToFriend\"><h2 class=\"title--pedido\">¿Qué tan probable es que nos recomiendes a un amigo?</h2><div class=\"seleccion__pedido\"><div class=\"row\"><div class=\"col-md-1\"></div><input id=\"recommendToFriend-{{evaluation}}\" type=\"radio\" required=\"\" name=\"recommendToFriend\" ng-change=\"feedback.scrollTo(\'comment\')\" ng-repeat-start=\"evaluation in feedback.evaluationValues\" ng-model=\"feedback.feedbackForm.recommendToFriend\" ng-value=\"evaluation\"> <label class=\"calificacion col-md-1\" for=\"recommendToFriend-{{evaluation}}\" ng-repeat-end=\"\">{{evaluation}}</label></div><div class=\"row\"><p class=\"col-md-2 col-md-push-1\">1 = Nada probable</p><p class=\"col-md-2 col-md-push-7\">10 = Muy probable</p></div></div></div><div class=\"item\" id=\"comment\"><h2 class=\"title--pedido\">Ingresa tu dirección</h2><div class=\"seleccion__pedido\"><p>Cuéntanos la razón principal porque nos calificas con esta nota</p><textarea name=\"comment\" cols=\"30\" rows=\"10\" placeholder=\"Comentario Opcional:\" class=\"text-question\" ng-model=\"feedback.feedbackForm.comment\"></textarea></div></div></div></div><div class=\"seccion__progreso\"><div class=\"total__cont\"><button class=\"btn btn--color\" type=\"submit\" ng-disabled=\"!form.$valid\">Enviar encuesta <i class=\"icon-arrow_ins_left\"></i></button></div></div></form></div></div></div>");
$templateCache.put("app/feedback/mobile/feedback.html","<div class=\"save-addres\"><div class=\"container-fluid header__app\"><div class=\"contianer\"><a class=\"col-xs-3 retroceder\" ui-sref=\"cart.products\"><i class=\"icon-arrow_ins_right\"></i></a> <a class=\"col-xs-6\" ui-sref=\"main\"><img src=\"assets/images/desktop/logo_tr.png\" alt=\"\" width=\"70\" style=\"margin:0 auto; display:block;\"></a></div></div><div class=\"bienvenidos titulo\"><p>Encuesta</p></div><form name=\"form\" ng-submit=\"feedback.sendFeedback()\"><div class=\"welcome-checkout login-data\"><div class=\"container-button-radio\"><p>¿Recibiste tu pedido en el tiempo prometido?</p><input id=\"withinPromisedTime-yes\" name=\"withinPromisedTime\" required=\"\" type=\"radio\" value=\"yes\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"buttonselect\" for=\"withinPromisedTime-yes\"><span>Si</span></label> <input id=\"withinPromisedTime-no\" name=\"withinPromisedTime\" type=\"radio\" required=\"\" value=\"no\" ng-model=\"feedback.feedbackForm.withinPromisedTime\"> <label class=\"buttonselect\" for=\"withinPromisedTime-no\"><span>No</span></label></div><div class=\"container-button-radio\" style=\"margin:0;\"><p>¿Recibiste todos los productos correctamente?</p><input id=\"receivedAllProducts-yes\" name=\"receivedAllProducts\" type=\"radio\" required=\"\" value=\"yes\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"buttonselect\" for=\"receivedAllProducts-yes\"><span>Si</span></label> <input id=\"receivedAllProducts-no\" name=\"receivedAllProducts\" type=\"radio\" required=\"\" value=\"no\" ng-model=\"feedback.feedbackForm.receivedAllProducts\"> <label class=\"buttonselect\" for=\"receivedAllProducts-no\"><span>No</span></label></div><div class=\"container-button-radio\" style=\"margin:0;\"><p>¿Qué tan probable es que nos recomiendes a un amigo?</p><input id=\"recommendToFriend-{{evaluation}}\" type=\"radio\" required=\"\" name=\"recommendToFriend\" ng-repeat-start=\"evaluation in feedback.evaluationValues\" ng-model=\"feedback.feedbackForm.recommendToFriend\" ng-value=\"evaluation\"> <label class=\"calificacion\" for=\"recommendToFriend-{{evaluation}}\" ng-repeat-end=\"\">{{evaluation}}</label></div><div class=\"example-bton\"><p><span>Ej:</span>1 = Nada probable</p><p><span>&nbsp;</span>10 = Muy probable</p></div><div class=\"container-button-radio\" style=\"margin:0;\"><p>Cuéntanos la razón principal porque nos calificas con esta nota</p><textarea name=\"comment\" cols=\"30\" rows=\"10\" placeholder=\"Comentario Opcional:\" class=\"text-question\" ng-model=\"feedback.feedbackForm.comment\"></textarea></div></div><button class=\"siguiente\" type=\"submit\" ng-disabled=\"!form.$valid\"><p>Enviar encuesta</p></button></form></div>");
$templateCache.put("app/main/desktop/main.html","<header-cart></header-cart><div class=\"container container-contenido\"><div class=\"row\"><div class=\"hidden-sm hidden-xs col-md-2\"><div class=\"titulo-side\"><h1>Encuentra tus Roll</h1><div class=\"acordeones\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\"><div class=\"container-panel\" ng-controller=\"MenuController as menu\"><div class=\"panel-heading\" role=\"tab\" id=\"headingThree\"><h4 class=\"panel-title\"><a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseThree\" aria-expanded=\"true\" aria-controls=\"collapseThree\">Categorías</a></h4></div><div id=\"collapseThree\" class=\"panel-collapse collapse in\" role=\"tabpanel\" aria-labelledby=\"headingThree\"><p ng-repeat=\"category in menu.categories\" ng-if=\"category.seleables.length > 0\"><a class=\"category-links\" ui-sref=\"menu.category({categoryName: menu.kebabCase(category.name)})\" ng-click=\"menu.expandCategory(category)\"><i class=\"icon-corazon\" ng-if=\"$index == 0\"></i>{{category.name}}</a></p></div></div></div></div></div><div class=\"col-sm-12 col-md-10\"><div class=\"big-img-box\"><div ng-if=\"!main.timesAverage.error\" class=\"main-time\"><div class=\"pickup\"><i class=\"icon-tend\"></i><p>Retiro en local <span>{{main.timesAverage.pickup_avg}} min <small>aprox</small></span></p></div><div class=\"delivery\"><i class=\"icon-house\"></i><p>Despacho a Domicilio <span>{{main.timesAverage.delivery_avg}} min <small>aprox</small></span></p></div></div><div class=\"main-greeting\"><span><span ng-show=\"main.customer\">{{main.customer.name.split(\' \')[0] + \', \'}}</span>{{main.greeting.title}}</span><p>{{main.greeting.msg}}</p></div></div><div class=\"row\"><a class=\"col-sm-3 col-md-3 col-lg-3 col-xs-3 main-category\" ui-sref=\"menu.category({categoryName: \'combinaciones-niu\'})\"><img class=\"img-responsive\" src=\"assets/images/niu_para_2.jpg\"><h2>Combinaciones NIU</h2><p>¿No sabes qué sushi pedir? ¡Nosotros te ayudamos!</p></a> <a class=\"col-sm-3 col-md-3 col-lg-3 col-xs-3 main-category\" ui-sref=\"menu.category({categoryName: \'special-rolls\'})\"><img class=\"img-responsive\" src=\"assets/images/special-rolls(2).jpg\"><h2>Special Rolls</h2><p>Rolls de sabores únicos</p></a> <a class=\"col-sm-3 col-md-3 col-lg-3 col-xs-3 main-category\" ui-sref=\"menu.category({categoryName: \'nikkei-rolls\'})\"><img class=\"img-responsive\" src=\"assets/images/nikkei-rolls(2).jpg\"><h2>Nikkei Rolls</h2><p>Fusión Japonesa - Peruana</p></a> <a class=\"col-sm-3 col-md-3 col-lg-3 col-xs-3 main-category\" ui-sref=\"menu.category({categoryName: \'tempura-panko-rolls\'})\"><img class=\"img-responsive\" src=\"assets/images/tempura-rolls(2).jpg\"><h2>Tempura Rolls</h2><p>Envueltos en masa tempura o panko</p></a></div></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/main/mobile/main.html","<header-cart></header-cart><div class=\"container_site\"><div class=\"container-fluid banner\"><img src=\"assets/images/dcto-nocache1.svg\" class=\"header-dscto\"><div ng-if=\"!main.timesAverage.error\" class=\"main-time\"><div class=\"pickup\"><i class=\"icon-tend\"></i><p>Retiro <span>{{main.timesAverage.pickup_avg}} min <small>aprox</small></span></p></div><div class=\"delivery\"><i class=\"icon-house\"></i><p>Despacho <span>{{main.timesAverage.delivery_avg}} min <small>aprox</small></span></p></div></div></div><div class=\"container-fluid mensaje__ingreso\"><div class=\"triangle-up\"></div><div class=\"icono__ingreso\"><i ng-class=\"main.greeting.icon\"></i></div><div class=\"texto__ingreso\"><span><span ng-show=\"main.customer\">{{main.customer.name.split(\' \')[0] + \', \'}}</span>{{main.greeting.title}}</span><p>{{main.greeting.msg}}</p></div></div><div class=\"container__agregados\"><div class=\"mensajes_agregados_home\"><a ui-sref=\"{{main.firstButton.state}}\" id=\"menu-btn\"><p>{{main.firstButton.title}}</p><span>{{main.firstButton.body}}</span> <i class=\"icon-arrow_ins_left\"></i></a></div><div class=\"mensajes_agregados_home\"><a ui-sref=\"{{main.secondButton.state}}\" id=\"login-btn\"><p>{{main.secondButton.title}}</p><span>{{main.secondButton.body}}</span> <i class=\"icon-arrow_ins_left\"></i></a></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/menu/desktop/menu.html","<header-cart></header-cart><div class=\"container container-contenido\" ng-controller=\"CartController as cart\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-2 sidebar\"><div class=\"titulo tituloSidebar\"><h1>Encuentra tus Roll</h1><div class=\"acordeones\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\"><div class=\"container-panel\"><div class=\"panel-heading\" role=\"tab\" id=\"headingThree\"><div class=\"panel-title\"><a role=\"button\" data-toggle=\"collapse\" data-parent=\"#accordion\" href=\"#collapseThree\" aria-expanded=\"true\" aria-controls=\"collapseThree\">Categorías</a></div></div><div id=\"collapseThree\" class=\"panel-collapse collapse in\" role=\"tabpanel\" aria-labelledby=\"headingThree\"><p class=\"me\" ng-repeat=\"category in menu.categories\" ng-if=\"category.seleables.length > 0\"><a class=\"category-links\" ui-sref=\"menu.category({categoryName: menu.kebabCase(category.name)})\" ng-click=\"menu.expandCategory(category)\"><i class=\"icon-corazon\" ng-if=\"$index == 0\"></i> {{category.name}}</a></p></div></div></div></div></div><div class=\"col-sm-12 col-md-7 col-md-offset-2 col-xs-12 container-acordeonsushi\"><div class=\"acordeon\"><div ng-cloak=\"\" class=\"u-wideWrapper u-paddingHm u-paddingTl\"><div class=\"Grid Grid--gutters md-Grid--2col\"><div class=\"Grid-cell u-marginBl\" ng-init=\"categories = (menu.currentState.indexOf(\'menu\') != -1) ? menu.categories : menu.latestOrders\"><div class=\"vAccordion--default is-accordion\"><div ng-repeat=\"category in categories\" class=\"items is-pane\" ng-class=\"{\'is-expanded\': category.isExpanded}\" ng-if=\"category.seleables.length > 0\"><div id=\"{{menu.kebabCase((category.promised_time || \'\') + category.name)}}\" aria-controls=\"{{menu.kebabCase(category.name)}}-content\" class=\"container-acordeon is-pane-header\" ng-click=\"menu.expandCategory(category)\"><h5>{{category.promised_time | date:\'EEE d/M\'}} {{ category.name }}</h5><i class=\"icon-corazon\" ng-if=\"category.name == \'Mis Favoritos\'\"></i></div><div id=\"{{menu.kebabCase(category.name)}}-content\" aria-labelledby=\"{{menu.kebabCase(category.name)}}\" class=\"container-element is-pane-content\"><div class=\"container-elementosCatalogo\"><div class=\"container-items item\" ng-repeat=\"seleable in category.seleables\" ng-if=\"category.isExpanded\"><div class=\"img-producto\" ng-click=\"menu.viewSeleable(seleable, category)\"><i ng-show=\"seleable.favorite\" class=\"icon-estrello star-icon\" title=\"Producto destacado\"></i><div ng-show=\"seleable.highlighted_text\" class=\"highlight\" title=\"Destacado\"><p>{{seleable.highlighted_text}}</p></div><i ng-if=\"seleable.preference\" class=\"icon-corazon heart\"></i> <img ng-src=\"{{seleable.image.medium}}\" alt=\"{{seleable.name}}\"> <i ng-show=\"seleable.extras\" class=\"icon-salsa salsa\" title=\"Incluye salsa\"></i></div><div class=\"name-item\"><p><em ng-show=\"seleable.quantity\">{{seleable.quantity}}x&nbsp;</em>{{seleable.name}}</p></div><div class=\"valores\"><span ng-show=\"seleable.discount\">{{menu.price(seleable, false) | currency:\"\":0}}</span> <small>{{menu.price(seleable, true) | currency:\"\":0}}</small></div><a class=\"agregar-mas\" ng-class=\"{\'added\': !!menu.cart.get(seleable.id, null, seleable.type)}\" ng-click=\"menu.addToCart(seleable, category)\"><i class=\"icon-comprar\"><small>+</small> <small>{{menu.cart.get(seleable.id, null, seleable.type)}}</small></i><div class=\"tooltip-agregar\"><p>Agregar</p></div></a></div><div class=\"container-items showme-more\" ng-click=\"menu.repeatOrder(category)\" ng-show=\"category.promised_time\"><div class=\"img-producto\"><img src=\"assets/images/repetir_pedido.png\" alt=\"agregar el pedido completo\"></div><div class=\"name-item\"><p>Repetir pedido completo</p></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-md-3 col-sm-4 col-xs-4 mis-pedidos mis-pedidos-lg\" ng-class=\"{\'pedidos-hide\': !cart.isVisible}\"><div class=\"header-pedidos\"><p>Mi Pedido</p><i class=\"icon-comprar shopping-cart\"><input type=\"text\" class=\"prodMas\" ng-value=\"cart.count\" disabled=\"\"></i></div><div class=\"pedido-items agregado\" data-item=\"{{$index}}\" ng-repeat=\"item in cart.items | orderBy:\'addedAt\'\"><p>{{item.seleable.name}}</p><span ng-repeat=\"option in cart.showOptions(item) track by $index\">{{option}}</span><div class=\"controles\"><button class=\"menosProducto\" ng-click=\"cart.removeOne(item)\"><i class=\"glyphicon glyphicon-minus\"></i></button> <input type=\"text\" id=\"inputSumador\" ng-value=\"cart.productCount(item)\" name=\"quantity\" disabled=\"\"> <button class=\"masProducto\" ng-click=\"cart.addOne(item)\"><i class=\"glyphicon glyphicon-plus\"></i></button> <button class=\"cerrar\" ng-click=\"cart.removeAll(item)\"><i class=\"glyphicon glyphicon-remove\"></i></button></div><div class=\"valores\"><span class=\"antes\" ng-show=\"item.seleable.discount\">{{cart.price(item, false) | currency:\"\":0}}</span> <small class=\"ahora\">{{cart.price(item, true) | currency:\"\":0}}</small></div><div class=\"producto-small\"><img ng-src=\"{{item.seleable.image.medium}}\" alt=\"{{item.seleable.name}}\"></div></div><div class=\"pedido-items sin_pedidos\" ng-hide=\"cart.count\"><div class=\"container_sin_pedido\"><img src=\"assets/images/desktop/sinproductos.png\" alt=\"carro vacio\"><p>Comienza a armar tu pedido</p></div></div><div class=\"container_pedidos\" ng-show=\"cart.count\"><div class=\"total\"><div class=\"total-text\"><p>Total a pagar</p></div><div class=\"total-valor\"><div class=\"valores\"><span class=\"antesTotal\">{{cart.total | currency:\"\":0}}</span> <small class=\"ahoraTotal\">{{cart.totalDiscount | currency:\"\":0}}</small></div></div></div><button class=\"pedidos-send next\" ng-disabled=\"cart.isClosed\" ui-sref=\"cart.whenhowwhere\">Ir al Checkout&nbsp;<span ng-if=\"cart.isClosed\">(cerrado)</span></button></div></div><div class=\"container-carro-de-compras visible-sm-block\" ng-click=\"cart.isVisible = !cart.isVisible\" ng-class=\"{\'compras-hide\': !cart.isVisible}\"><i class=\"icon-comprar shopping-cart\"><input type=\"text\" class=\"prodMas\" ng-value=\"cart.count\" disabled=\"\"></i><p>Mi Pedido</p><i class=\"icon-arrow_ins_left icono-right-arrow\"></i></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/menu/mobile/menu.html","<header-cart></header-cart><div class=\"container_site\"><div ng-show=\"menu.latestOrders.length > 0\" ng-click=\"menu.expandPastOrders()\"><div class=\"section-header menu_acordeon\"><h2>Mis pedidos anteriores</h2><i class=\"icon-arrow_down\" ng-class=\"{\'giro\': menu.myPastOrdesExpandend}\"></i></div></div><div id=\"pedidos_anteriores\" ng-show=\"menu.myPastOrdesExpandend\"><div id=\"{{menu.kebabCase((order.promised_time || \'\') + order.name)}}\" class=\"container_colapsable category\" ng-class=\"{\'category-expanded\': order.isExpanded}\" ng-repeat=\"order in menu.latestOrders | limitTo:20\"><div class=\"title_acordeon\" ng-click=\"menu.expandCategory(order)\"><p class=\"title_calapsable title_acordeon_color ellipsis\">{{order.promised_time | date:\'EEE d/M\'}} {{order.name}}</p><i class=\"icon-arrow_down\" ng-class=\"{\'giro\': order.isExpanded}\"></i></div><div class=\"container_sushi\" ng-if=\"order.isExpanded\"><div ng-repeat-start=\"seleable in order.seleables\" class=\"col-xs-6\"><div class=\"producto_items\" ng-click=\"menu.viewSeleable(seleable)\"><i ng-show=\"seleable.favorite\" class=\"icon-estrello star\"></i> <i ng-show=\"seleable.extras\" class=\"icon-salsa salsa\"></i> <i ng-if=\"seleable.preference\" class=\"icon-corazon heart\"></i><div class=\"item\" afkl-lazy-image=\"{{seleable.image.medium}}\" afkl-lazy-image-options=\"{offset: 600, className: \'seleable-img\', alt: \'{{seleable.name}}\'}\"></div><div class=\"seleable-shadow\"></div></div><div class=\"container_detalle\" ng-click=\"menu.viewSeleable(seleable)\"><div class=\"title_producto\"><em>{{seleable.quantity}}x&nbsp;</em><strong>{{seleable.name}}</strong> <span ng-show=\"seleable.discount\">{{menu.price(seleable, false) | currency:\"$ \":0}}</span><p>{{menu.price(seleable, true) | currency:\"$ \":0}}</p></div></div><button class=\"add-to-cart boton_sumar\" type=\"button\" ng-click=\"menu.addToCart(seleable)\"><div class=\"sumar\"><div class=\"container__icon\" ng-class=\"{\'added\': !!menu.cart.get(seleable.id, null, seleable.type)}\"><div class=\"comparar\"><i class=\"icon-comprar\"></i> <span class=\"cantidad\">+</span> <span class=\"cantidad\">{{menu.cart.get(seleable.id, null, seleable.type)}}</span></div></div><span class=\"agregar\">{{!menu.cart.get(seleable.id, null, seleable.type) ? \'Agregar\' : \'Agregado\'}}</span></div></button></div><div class=\"clearfix\" ng-if=\"$index % 2 == 1\" ng-repeat-end=\"\"></div><div class=\"col-xs-6\" ng-click=\"menu.repeatOrder(order)\"><div class=\"producto_items\"><img src=\"assets/images/repetir_pedido.png\" alt=\"agregar el pedido completo\" class=\"seleable-img\"></div><div class=\"detalle_agregar\"><span>Repetir pedido completo</span></div></div></div></div></div><div><div class=\"section-header menu_acordeon\" ng-click=\"menu.expandMenu()\"><h2>Toda la carta</h2><i class=\"icon-arrow_down\" ng-class=\"{\'giro\': menu.menuExpandend}\"></i></div></div><div id=\"pedidos_anteriores\" ng-show=\"menu.menuExpandend\"><div id=\"{{menu.kebabCase(category.name)}}\" class=\"container_colapsable category\" ng-if=\"category.seleables.length > 0\" ng-class=\"{\'category-expanded\': category.isExpanded}\" ng-repeat=\"category in menu.categories\"><div class=\"title_acordeon\" ng-click=\"menu.expandCategory(category)\"><p class=\"title_calapsable title_acordeon_color\"><i ng-if=\"$index == 0\" class=\"icon-corazon heart\"></i>{{category.name}}</p><i class=\"icon-arrow_down\" ng-class=\"{\'giro\': category.isExpanded}\"></i></div><div class=\"container_sushi\" ng-if=\"category.isExpanded\"><div ng-repeat-start=\"seleable in category.seleables | limitTo: category.limit\" class=\"col-xs-6\"><div class=\"producto_items\" ng-click=\"menu.viewSeleable(seleable, category)\"><i ng-show=\"seleable.favorite\" class=\"icon-estrello star\"></i><div ng-show=\"seleable.highlighted_text\" class=\"highlight\" title=\"Destacado\"><p>{{seleable.highlighted_text}}</p></div><i ng-show=\"seleable.extras\" class=\"icon-salsa salsa\"></i> <i ng-if=\"seleable.preference\" class=\"icon-corazon heart\"></i><div class=\"item\" afkl-lazy-image=\"{{seleable.image.medium}}\" afkl-lazy-image-options=\"{offset: 600, className: \'seleable-img\', alt: \'{{seleable.name}}\'}\"></div><div class=\"seleable-shadow\"></div></div><div class=\"container_detalle\" ng-click=\"menu.viewSeleable(seleable, category)\"><div class=\"title_producto\"><strong>{{seleable.name}}</strong> <span ng-show=\"seleable.discount\">{{menu.price(seleable, false) | currency:\"$ \":0}}</span><p>{{menu.price(seleable, true) | currency:\"$ \":0}}</p></div></div><button class=\"add-to-cart boton_sumar\" type=\"button\" ng-click=\"menu.addToCart(seleable, category)\"><div class=\"sumar\"><div class=\"container__icon\" ng-class=\"{\'added\': !!menu.cart.get(seleable.id, null, seleable.type)}\"><div class=\"comparar\"><i class=\"icon-comprar\"></i> <span class=\"cantidad\">+</span> <span class=\"cantidad\">{{menu.cart.get(seleable.id, null, seleable.type)}}</span></div></div><span class=\"agregar\">{{!menu.cart.get(seleable.id, null, seleable.type) ? \'Agregar\' : \'Agregado\'}}</span></div></button></div><div class=\"clearfix\" ng-if=\"$index % 2 == 1\" ng-repeat-end=\"\"></div><div class=\"col-xs-6\" ng-show=\"category.limit < category.seleables.length\" ng-click=\"category.limit = category.seleables.length\"><div class=\"producto_items\"><img src=\"assets/images/ver_mas.png\" alt=\"ver más productos\" class=\"seleable-img\"></div><div class=\"detalle_agregar\"><span>Ver más {{category.name}}</span> <strong>¡Más de {{category.moreThan()}} productos!</strong></div></div></div></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/order/desktop/order.success.html","<header-cart></header-cart><div class=\"container container-contenido\"><div class=\"col-md-10 col-md-push-1\"><div class=\"container-title\"><i class=\"icon-check\"></i><p>¡{{order.customer.name.split(\' \')[0]}}, tu pedido fue recibido con éxito!</p></div><div class=\"alert-page success\"><i class=\"icon-email\"></i><p>{{order.customer.name}}</p><span>Te enviamos confirmación a tu email, y en unos {{order.eta}} min estará en tu mesa.</span> <span style=\"display: block;\">En caso que tengamos alguna duda te contactaremos, por lo que por favor ten tu teléfono a mano.</span> <span style=\"display: block;\">Recuerda que la propina es voluntaria.</span></div><div class=\"description-local\"><ul><li><i class=\"icon-maps\"></i><p><strong>Local <span>{{order.restaurant.name}}</span></strong></p></li><li><i class=\"icon-telefono\"></i><p>Cualquier duda o consulta llamanos al <span>{{order.restaurant.phones[0] | phone}}</span></p></li></ul></div><div class=\"title-login-success\" ng-show=\"order.storage.isNewCustomer\"><span>Mientras esperas regístrate y</span><p>recordaremos tus preferencias</p></div><div class=\"container-login-no-user\" ng-show=\"order.storage.isNewCustomer\"><form class=\"container__conemail displayDelay\" ng-submit=\"order.setEmail()\"><p>{{order.customer.email}}</p><input type=\"email\" ng-model=\"order.customer.email\" disabled=\"\" hidden=\"\"> <input name=\"password\" placeholder=\"Clave\" type=\"password\" ng-model=\"order.updatePasswordForm.password\"> <button type=\"submit\">Registrarme</button></form></div><form class=\"container__Nombre--pedido\" ng-show=\"!order.storage.isNewCustomer && order.hasNoName\" ng-submit=\"order.setOrderName()\"><span>Ponle nombre a este pedido para reconocerlo más fácilmente a futuro</span> <input type=\"text\" placeholder=\"Nombre del pedido\" ng-model=\"order.order.name\"> <button type=\"submit\">Guardar Nombre del Pedido</button></form><div class=\"container__Nombre--pedido\" ng-show=\"!order.storage.isNewCustomer && !order.hasNoName\"><span><p>Tu pedido ha quedado nombrado exitosamente.</p><a ui-sref=\"main\">Puedes seguir explorando la web</a></span></div></div></div>");
$templateCache.put("app/order/mobile/order.success.html","<div class=\"container_site container_checkout back-BG\"><div class=\"welcome-checkout check-conteiner\"><div class=\"container-button-radio\"><div class=\"alert-green\"><i class=\"icon-email\"></i><div class=\"container-text-alert\"><p>{{order.customer.name}}</p><span>Te enviamos confirmación a tu email, y en unos {{order.eta}} min estará listo.</span></div><div class=\"triangulo_inf\"></div></div></div><div class=\"tick\"><i class=\"icon-check\"></i></div><div class=\"title-check\"><p>¡{{order.customer.name}}, tu pedido fue recibido con éxito!</p></div><div class=\"number_exito\"><p class=\"Local\"><strong>Local {{order.restaurant.name}}</strong></p><p>Cualquier duda o consulta, llámanos al</p><a href=\"tel:{{order.restaurant.phones[0]}}\">{{order.restaurant.phones[0]}}</a><p>Recuerda que la propina es voluntaria.</p></div></div><div ng-show=\"order.storage.isNewCustomer\"><div class=\"Menss-white\"><p>Mientras esperas registrate y recordaremos tus preferencias y obtendrás <strong>beneficios especiales NIU</strong></p></div><div class=\"connect connect-email\" ng-if=\"false\"><img src=\"/assets/images/registrarme.png\" alt=\"\"></div><div class=\"login-my-data connect-email\" ng-if=\"false\"><div class=\"line\"></div><p class=\"text-email connect-email\">ó</p></div><div class=\"cont-Sending\" ng-if=\"false\"><a class=\"Sending\">Registrarme con email</a></div><form class=\"form-login-email\" ng-submit=\"order.setEmail()\"><input type=\"email\" ng-model=\"order.customer.email\" disabled=\"\"> <input class=\"campo_login\" name=\"password\" placeholder=\"Clave\" type=\"password\" ng-model=\"order.updatePasswordForm.password\"> <button type=\"submit\" class=\"SendIng\">Registrarme</button></form></div><div ng-show=\"!order.storage.isNewCustomer && order.hasNoName\"><div class=\"Menss-white\"><p>Ponle nombre a este pedido para reconocerlo más facilmente a futuro</p></div><form class=\"form-login-email\" ng-submit=\"order.setOrderName()\"><div style=\"padding:10px;\"><input placeholder=\"Nombre del pedido\" type=\"text\" ng-model=\"order.order.name\"></div><button type=\"submit\" class=\"SendIng\">Guardar nombre</button></form></div><div ng-show=\"!order.storage.isNewCustomer && !order.hasNoName\"><div class=\"Menss-white\"><p>Tu pedido ha quedado nombrado exitosamente.</p><a ui-sref=\"main\">Puedes seguir explorando la app</a></div></div></div>");
$templateCache.put("app/profile/desktop/logout.html","<div class=\"container-login user-login\"><div class=\"modal-header\"><div class=\"container-perfil\"><div class=\"name-user\"><p>¡Bienvenido, {{profile.info.name}}!</p></div><a ui-sref=\"profile\"><i class=\"icon-persona\"></i><p>Mi Perfil</p></a> <a ng-click=\"profile.signOut()\" class=\"exit\"><img src=\"assets/images/desktop/cerrar.png\" alt=\"cerrar\"><p>Salir</p></a></div></div></div>");
$templateCache.put("app/profile/desktop/profile.html","<header-cart></header-cart><div class=\"container-fluid container-contenido\"><div class=\"header-perfil row\"><div class=\"col-md-5 col-md-offset-1\"><div class=\"icono__palillos\"><img src=\"assets/images/desktop/palillos.png\" alt=\"\" width=\"35\"></div><div class=\"perfil-user\"><p>Tu Perfil, <span>{{profile.info.name}} :)</span></p></div></div><div class=\"col-md-4 col-md-offset-1\"><div class=\"User__regalos\"><a ui-sref=\"newPassword\"><p>Cambiar Clave de Acceso</p></a> <a ng-click=\"profile.signOut()\"><p>Cerrar sesión</p></a></div></div></div><div class=\"container containerDetalle\"><form name=\"form\" ng-submit=\"profile.saveProfile(profile.info)\"><div class=\"promociones__enlaces\" ng-if=\"false\"><p>Completa Tu Perfil y gana 1 despacho GRATIS (Valor Ref 1 5.000)</p></div><div class=\"User__regalos\" ng-if=\"false\"><a href=\"javascript:;\"><p>¡Felicitaciones!</p><span>ya tienes 2 Regalos NIU!</span> <i class=\"icon-arrow_ins_left\"></i></a></div><div class=\"container__conectarmeConFacebook\" ng-if=\"false\"><p>Conectate con Facebook, hazlo más rápido y fácil</p><a href=\"javascript:;\" class=\"facebook__boton btn__facebook\"><img src=\"assets/images/desktop/facebook.png\" alt=\"\"> <span>Contactame</span> <i class=\"icon-arrow_ins_left\"></i></a></div><div class=\"row\"><div class=\"col-md-5\"><div class=\"container__itemsForm\"><span>Mi Nombre <small>*</small></span> <input name=\"name\" required=\"\" type=\"text\" ng-model=\"profile.info.name\"></div><div class=\"container__itemsForm radios__generos\"><span>Mi Género</span> <input id=\"gender-{{gender}}\" name=\"gender\" type=\"radio\" ng-model=\"profile.info.gender\" ng-repeat-start=\"gender in profile.genders\" ng-value=\"gender\"> <label for=\"gender-{{gender}}\" ng-class=\"\'col-xs-\'+12/profile.genders.length\" ng-repeat-end=\"\">{{gender}}</label></div><div class=\"container__itemsForm\"><span>Mi Cumpleaños <small>*</small></span> <input type=\"text\" ng-focus=\"profile.info.birthdateFocus = true\" ng-model=\"profile.info.birthdate\" uib-datepicker-popup=\"dd-MMMM-yyyy\" show-button-bar=\"false\" is-open=\"profile.info.birthdateFocus\"></div><div class=\"container__itemsForm\"><span>Mi Email <small>*</small></span> <input name=\"email\" required=\"\" type=\"email\" ng-model=\"profile.info.email\"></div><div class=\"container__itemsForm\"><span>Mi Celular <small>*</small></span><div class=\"row\"><div class=\"col-sm-3\"><input disabled=\"\" ng-model=\"profile.phones[0].prefix\"></div><div class=\"col-sm-9\"><input name=\"phones-0\" placeholder=\"Por ej \'8765 4321\'\" required=\"\" title=\"Ingresa un número de 8 dígitos\" type=\"tel\" ng-model=\"profile.phones[0].number\" ng-pattern=\"profile.phoneRegex\"></div></div></div><button class=\"next\" type=\"submit\" ng-disabled=\"!form.$valid\">Guardar Perfil</button></div><div class=\"col-md-7\"><div class=\"container__itemsForm DireccionForm\"><span>Mis Direcciones</span> <input id=\"address-{{$index}}\" name=\"address\" type=\"radio\" ng-model=\"profile.selectedAddress\" ng-repeat-start=\"address in profile.addresses\" ng-value=\"address\"> <label class=\"container__formulario--input profile-ad\" for=\"address-{{$index}}\" ng-repeat-end=\"\"><span ng-show=\"address.address\">{{address.address.split(\',\')[0]}}</span> <small>{{address.address.split(\',\')[address.address.split(\',\').length - 1]}}</small> <i ng-click=\"profile.deactivateAddress(address)\" class=\"icon-cerrar\"></i></label> <a class=\"container__formulario--input profile-ad\" ng-click=\"profile.newAddressModal(false)\">Nueva dirección</a></div></div></div><div class=\"User__regalos QuieresRegalos\" ng-if=\"false\"><a href=\"javascript:;\"><p>¿Quieres ganar unas Gyosas?</p><span>Respondiendo 5 preguntas simples</span> <i class=\"icon-arrow_ins_left\"></i></a></div></form></div></div><footer-cart></footer-cart>");
$templateCache.put("app/profile/mobile/profile.html","<header-cart back-state=\"main\"></header-cart><div class=\"container_site\"><div class=\"container-bonus\"><div class=\"container-per-user\"><p>{{profile.info.name}} :)</p><small ng-if=\"false\">Niu Bronze</small></div><div class=\"sushi-icon\"><img src=\"assets/images/medal.png\" alt=\"sushi\"></div><div class=\"container-comp-user\"><p ng-if=\"false\">Completa Tu Perfil y gana 1 despacho GRATIS<br>(Valor Ref $ 1.500)</p></div></div><div ng-if=\"false\" class=\"mensajes_agregados\"><a href=\"javascript:;\"><p>¡Felicitaciones!</p><span>ya tienes 2 Regalos NIU!</span> <i class=\"icon-arrow_ins_left position-arrow2\"></i></a></div><div ng-if=\"false\" class=\"connecting title_faceboook\"><p>Conectate con Facebook, hazlo más rápido y fácil</p><img src=\"assets/images/conectarme.png\" alt=\"\" class=\"connecting-facebook\"></div><form name=\"form\" ng-submit=\"profile.saveProfile(profile.info)\" class=\"profile-form\"><div class=\"form-user-connecting\"><p><span class=\"must\">*</span>Mi Nombre</p><input name=\"name\" required=\"\" type=\"text\" ng-model=\"profile.info.name\"></div><div class=\"form-user-connecting\"><p>Mi Género</p><div class=\"container_botones_select\"><input id=\"gender-{{gender}}\" name=\"gender\" type=\"radio\" ng-model=\"profile.info.gender\" ng-repeat-start=\"gender in profile.genders\" ng-value=\"gender\"> <label class=\"btn__select button-select-items btn-disabled\" for=\"gender-{{gender}}\" ng-class=\"\'col-xs-\'+12/profile.genders.length\" ng-repeat-end=\"\">{{gender}}</label></div></div><div class=\"form-user-connecting\"><p>Mi Cumpleaños ;)</p><input name=\"birthdate\" type=\"date\" placeholder=\"Ej: \'24/07/1985\'\" ng-model=\"profile.info.birthdate\"></div><div class=\"form-user-connecting\"><p><span class=\"must\">*</span>Mi Email</p><input name=\"email\" required=\"\" type=\"email\" ng-model=\"profile.info.email\"></div><div class=\"form-user-connecting\"><p><span class=\"must\">*</span>Mi Celular</p><div class=\"row\"><div class=\"col-xs-3\"><input disabled=\"\" ng-model=\"profile.phones[0].prefix\" style=\"padding:0;\"></div><div class=\"col-xs-9\"><input name=\"phones-0\" placeholder=\"Por ej \'8765 4321\'\" required=\"\" title=\"Ingresa un número de 8 dígitos\" type=\"tel\" ng-model=\"profile.phones[0].number\" ng-pattern=\"profile.phoneRegex\"></div></div></div><div class=\"form-user-connecting welcome-checkout\"><p><span class=\"must\">*</span>Mis Direcciones</p><div class=\"container-button-radio\" style=\"margin-bottom:0;\"><p></p><input id=\"address-{{$index}}\" name=\"address\" type=\"radio\" ng-model=\"profile.selectedAddress\" ng-repeat-start=\"address in profile.addresses\" ng-value=\"address\"> <label class=\"buttonselect button-direction\" for=\"address-{{$index}}\" ng-repeat-end=\"\"><span ng-show=\"address.address\">{{address.address.split(\',\')[0]}}</span> <small>{{address.address.split(\',\')[address.address.split(\',\').length - 1]}}</small> <i ng-click=\"profile.deactivateAddress(address)\" class=\"icon-cerrar\"></i></label> <a class=\"buttonselect button-direction\" ng-click=\"profile.newAddressModal(true)\"><p>Nueva dirección</p></a></div></div><div class=\"container__agregados\"><div class=\"mensajes_agregados_profile agregados_dos\"><a ui-sref=\"newPassword\"><p>Cambiar Clave de Acceso</p><span></span> <i class=\"icon-arrow_ins_left position-arrow\"></i></a></div><div class=\"mensajes_agregados_profile agregados_dos\"><a ng-click=\"profile.signOut()\"><p>Cerrar Sesión</p><span></span> <i class=\"icon-arrow_ins_left position-arrow\"></i></a></div><div ng-if=\"0\" class=\"mensajes_agregados_profile\"><a href=\"javascript:;\"><p>¿Quieres ganar unas Gyosas?</p><span>Respondiendo 5 preguntas simples</span> <i class=\"icon-arrow_ins_left position-arrow\"></i></a></div></div><button class=\"siguiente\" type=\"submit\" ng-disabled=\"!form.$valid\"><p>Guardar Perfil</p></button></form><div class=\"text-center\"></div></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurants/desktop/restaurants.html","<header-cart></header-cart><div class=\"maps-address\"><ui-gmap-google-map class=\"map\" center=\"restaurants.selected.lonlat\" draggable=\"true\" options=\"restaurants.mapOptions\" pan=\"true\" zoom=\"restaurants.mapOptions.zoom\"><ui-gmap-markers click=\"restaurants.onMarkerClick\" coords=\"\'lonlat\'\" icon=\"\'icon\'\" models=\"restaurants.restaurants\"></ui-gmap-markers><ui-gmap-polygons models=\"restaurants.polygons\" idkey=\"\'id\'\" path=\"\'path\'\" stroke=\"{color: \'#e92629\', weight: 0, opacity: 0.8}\" visible=\"true\" static=\"true\" geodesic=\"true\" fill=\"{color: \'#e92629\', opacity: 0.2}\" fit=\"true\" editable=\"false\" draggable=\"false\"></ui-gmap-polygons></ui-gmap-google-map><div class=\"locales__cont\"><h2>Nuestros Locales</h2><div class=\"locales\" ng-class=\"{\'active\': restaurant == restaurants.selected}\" ng-repeat=\"restaurant in restaurants.restaurants\"><a ng-click=\"restaurants.onMarkerClick(\'\', \'\', restaurant)\"><div><h3><strong>{{restaurant.name}}</strong></h3><p>{{restaurant.address}}<br>{{restaurant.comune_name}}<br></p><p>Fono: <strong>{{restaurant.phones[0] | phone}}</strong></p></div></a></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/restaurants/mobile/restaurants.html","<div class=\"container_maps__galery\"><div class=\"container-fluid border_head header__app\"><div class=\"contianer\"><a class=\"col-xs-2 retroceder\" ui-sref=\"main\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-10 frace_local\"></div></div></div><ui-gmap-google-map class=\"restaurants-map\" center=\"restaurants.selected.lonlat\" draggable=\"true\" options=\"restaurants.mapOptions\" pan=\"true\" zoom=\"restaurants.mapOptions.zoom\" ng-if=\"restaurants.showMap\"><ui-gmap-markers click=\"restaurants.onMarkerClick\" coords=\"\'lonlat\'\" icon=\"\'icon\'\" models=\"restaurants.restaurants\"></ui-gmap-markers><ui-gmap-polygons models=\"restaurants.polygons\" idkey=\"\'id\'\" path=\"\'path\'\" stroke=\"{color: \'#e92629\', weight: 0, opacity: 0.8}\" visible=\"true\" static=\"true\" geodesic=\"true\" fill=\"{color: \'#e92629\', opacity: 0.2}\" fit=\"true\" editable=\"false\" draggable=\"false\"></ui-gmap-polygons></ui-gmap-google-map><div class=\"galeria\" ng-if=\"restaurants.showMap\"><div><div class=\"container__list item\"><div class=\"col-xs-6\"><h3>{{restaurants.selected.name}}</h3><p>{{restaurants.selected.address}}, {{restaurants.selected.comune_name}}</p></div><div class=\"cont_option\"><div class=\"icono__ruta\"><a ng-href=\"https://google.com/maps/?q={{restaurants.selected.lonlat[1] + \',\' + restaurants.selected.lonlat[0]}}\"><div class=\"ruta\"><i class=\"icon-cosmo\"></i> <span>Ver ruta</span></div></a> <a ng-href=\"tel:{{restaurants.selected.phones[0]}}\"><div class=\"llamada\"><i class=\"icon-telefono\"></i> <span>Llamar</span></div></a></div></div></div></div></div><div class=\"container_listado\" ng-if=\"!restaurants.showMap\"><div class=\"container_listado__title\"><p>Nuestros Locales</p></div><p class=\"horario-atencion\">Horario de atención: de lunes a sábado,<br>de 12:00 a 17:00, y 18:00 a 23:00 hrs</p><div class=\"container__list\" ng-repeat=\"restaurant in restaurants.restaurants\"><div class=\"col-xs-6\"><h3>{{restaurant.name}}</h3><p>{{restaurant.address}}, {{restaurant.comune_name}}</p></div><div class=\"cont_option\"><div class=\"icono__ruta\"><a ng-href=\"https://google.com/maps/?q={{restaurant.lonlat[1] + \',\' + restaurant.lonlat[0]}}\"><div class=\"ruta\"><i class=\"icon-cosmo\"></i> <span>Ver ruta</span></div></a> <a ng-href=\"tel:{{restaurant.phones[0]}}\"><div class=\"llamada\"><i class=\"icon-telefono\"></i> <span>Llamar</span></div></a></div></div></div></div><div class=\"container_mapa\"><div class=\"container_controllers\"><button ng-class=\"{\'maps\': true, \'active\': restaurants.showMap}\" ng-click=\"restaurants.showMap = true\"><i class=\"icon-mapa\"></i></button> <button ng-class=\"{\'listado\': true, \'active\': !restaurants.showMap}\" ng-click=\"restaurants.showMap = false\"><i class=\"icon-menu\"></i></button></div></div></div><footer-cart></footer-cart>");
$templateCache.put("app/seleable/desktop/seleable.html","<div class=\"modal-product\"><div class=\"modal-header\"><button class=\"close-modal\" ng-click=\"seleable.cancel()\"><i class=\"icon-cruz\"></i></button></div><div class=\"modal-body\" stop-event=\"touchend\"><div class=\"prod-img\"><div class=\"prod-img-content\"><div class=\"fav\"><div class=\"like_btn\" ng-if=\"seleable.customer && !seleable.makeSelection\"><a class=\"me_gusta1\" ng-click=\"seleable.toggleLike()\"><img ng-src=\"assets/images/like_{{seleable.pref > 0 ? \'on\' : \'off\'}}.png\" alt=\"\" width=\"35\"></a></div></div><img ng-src=\"{{seleable.currentImage.src}}\"></div></div><div class=\"prod-description\"><div class=\"prod-name\" ng-hide=\"seleable.promotion\"><h2>{{seleable.product.name}}</h2><p ng-show=\"(seleable.promotion || seleable.product).servings !== 0\">( {{(seleable.promotion || seleable.product).servings}} porciones )</p><p class=\"description\">{{seleable.product.description}}</p></div><div class=\"prod-name\" ng-show=\"seleable.promotion\"><h2>{{seleable.promotion.name}}</h2><p class=\"description\"><span ng-show=\"seleable.product.name\" ng-repeat=\"product in seleable.promotion.products\" ng-class=\"{\'product-options-title\' : $index == seleable.currentIndex}\">{{product.name}} <small ng-repeat=\"(name, options) in product.product_options\">*</small> <span ng-show=\"(seleable.promotion || seleable.product).servings !== 0\">( {{(seleable.promotion || seleable.product).servings}} porciones )</span></span></p><p class=\"description\"><span ng-hide=\"seleable.product\" ng-repeat=\"product in seleable.promotion.products\">{{product.name}} <small ng-repeat=\"(name, options) in product.product_options\">*</small></span></p></div><div class=\"prod-price\"><p class=\"discount\" ng-show=\"(seleable.promotion || seleable.product).discount\">{{seleable.price(seleable.promotion || seleable.product, false) | currency:\"$ \":0}}</p><h2>{{seleable.price(seleable.promotion || seleable.product, true) | currency:\"$ \":0}}</h2></div><div class=\"clearfix\"></div><div class=\"prod-option\"><div class=\"container_botones_select\" ng-repeat=\"(name, options) in seleable.product.product_options\"><p>{{name}}:</p><input id=\"option_{{name}}_{{option}}\" name=\"{{name}}\" type=\"radio\" ng-change=\"seleable.onSelectionChange()\" ng-model=\"seleable.productSelections[name]\" ng-repeat-start=\"option in options\" ng-value=\"option\"> <label for=\"option_{{name}}_{{option}}\" ng-class=\"\'btn__select button-select-items btn-disabled col-xs-\'+12/options.length\" ng-repeat-end=\"\">{{option}}</label></div></div><div class=\"prod-tooltip\"><div class=\"tooltip_recuerda\" ng-class=\"{\'hide\' : !(seleable.reminder && !seleable.makeSelection)}\"><img src=\"assets/images/arrow_tooltip.png\" alt=\"\" class=\"arrow-yellow a-top giro\"> <a class=\"icon-cruz cerrar_tooltip\" ng-click=\"seleable.reminder = null\"></a><div class=\"icon_recordar\"><i class=\"icon-ampolleta\"></i></div><div class=\"mensaje\"><p>Recuerda,</p><span>haz tu selección de <strong>{{seleable.reminder}}</strong></span></div></div><div class=\"tooltip_recuerda\" ng-class=\"{\'hide\' : !(seleable.makeSelection)}\"><img src=\"assets/images/arrow_tooltip.png\" alt=\"\" class=\"arrow-yellow a-top giro\"><div class=\"icon_recordar\"><i class=\"icon-ampolleta\"></i></div><div class=\"mensaje\"><span style=\"margin-top: 10px;\">Elige tu {{seleable.reminder}}</span></div></div></div></div><div class=\"clearfix\"></div><div><div class=\"container_detalle__rolls\" ng-show=\"seleable.product.promotionProducts\"><p>{{seleable.product.name}}</p><span ng-repeat=\"promotionProduct in seleable.product.promotionProducts\">{{promotionProduct.name}} <small ng-show=\"promotionProduct.product_options\">(opciones)</small></span></div><div ng-if=\"seleable.product.upselling && !seleable.makeSelection\" class=\"footer_detalle checkbox_detalle\"><input type=\"checkbox\" id=\"add-upselling\" ng-model=\"seleable.addedUpselling\"> <label for=\"add-upselling\"><p>Agrega: <strong>{{seleable.getUpselling().name}} por {{seleable.price(seleable.getUpselling(), true) | currency:\"$ \":0}}</strong></p></label></div></div></div><div class=\"modal-footer\" ng-hide=\"seleable.makeSelection\"><div class=\"highlight\" ng-hide=\"seleable.product\"><span>*</span> deberás elegir una opción</div><button class=\"boton_red--agregarPedido\" ng-click=\"seleable.addToCart()\" ng-hide=\"seleable.makeSelection\">Agregar a Mi Pedido</button></div></div>");
$templateCache.put("app/seleable/mobile/seleable.html","<div class=\"modal-product\"><div class=\"modal-header\"><button type=\"button\" class=\"close-modal\" ng-click=\"seleable.cancel()\"><span aria-hidden=\"true\"><i class=\"icon-cruz\"></i></span></button></div><div class=\"modal-body modal__detalle_galeria\" stop-event=\"touchend\"><div class=\"prod-img\"><div class=\"prod-img-content\"><div class=\"fav\"><div class=\"like_btn\" ng-if=\"seleable.customer && !seleable.makeSelection\"><a class=\"me_gusta1\" ng-click=\"seleable.toggleLike()\"><img ng-src=\"assets/images/like_{{seleable.pref > 0 ? \'on\' : \'off\'}}.png\" alt=\"\" width=\"35\"></a></div></div><img ng-src=\"{{seleable.currentImage.src}}\"></div></div><div class=\"prod-description\"><div class=\"prod-name\" ng-hide=\"seleable.promotion\"><h2>{{seleable.product.name}}</h2><p ng-show=\"(seleable.promotion || seleable.product).servings !== 0\">( {{(seleable.promotion || seleable.product).servings}} porciones )</p><p class=\"description\">{{seleable.product.description}}</p></div><div class=\"prod-name\" ng-show=\"seleable.promotion\"><h2>{{seleable.promotion.name}}</h2><p class=\"description\"><span ng-show=\"seleable.product.name\" ng-repeat=\"product in seleable.promotion.products\" ng-class=\"{\'product-options-title\' : $index == seleable.currentIndex}\">{{product.name}} <small ng-repeat=\"(name, options) in product.product_options\" ng-show=\"options.length > 1\">*</small> <span ng-show=\"(seleable.promotion || seleable.product).servings !== 0\">( {{(seleable.promotion || seleable.product).servings}} porciones )</span></span></p><p class=\"description\"><span ng-hide=\"seleable.product\" ng-repeat=\"product in seleable.promotion.products\">{{product.name}} <small ng-repeat=\"(name, options) in product.product_options\" ng-show=\"options.length > 1\">*</small></span></p></div><div class=\"prod-price\"><p class=\"discount\" ng-show=\"(seleable.promotion || seleable.product).discount\">{{seleable.price(seleable.promotion || seleable.product, false) | currency:\"$ \":0}}</p><h2>{{seleable.price(seleable.promotion || seleable.product, true) | currency:\"$ \":0}}</h2></div><div class=\"clearfix\"></div></div><div class=\"prod-option\"><div class=\"container_botones_select\" ng-hide=\"options.length == 1\" ng-repeat=\"(name, options) in seleable.product.product_options\"><p>{{name}}:</p><input id=\"option_{{name}}_{{option}}\" name=\"{{name}}\" type=\"radio\" ng-change=\"seleable.onSelectionChange()\" ng-model=\"seleable.productSelections[name]\" ng-repeat-start=\"option in options\" ng-value=\"option\"> <label for=\"option_{{name}}_{{option}}\" ng-class=\"\'btn__select button-select-items btn-disabled col-xs-\'+12/options.length\" ng-repeat-end=\"\">{{option}}</label></div></div><div class=\"prod-tooltip\"><div ng-show=\"seleable.reminder && !seleable.makeSelection\" class=\"tooltip_recuerda hi\"><img src=\"assets/images/arrow_tooltip.png\" alt=\"\" class=\"arrow_recuerda2 giro\"> <a class=\"icon-cruz cerrar_tooltip\" ng-click=\"seleable.reminder = null\"></a><div class=\"icon_recordar\"><i class=\"icon-ampolleta\"></i></div><div class=\"mensaje\" style=\"margin-top:0;\"><p>Recuerda,</p><span>haz tu selección de <strong>{{seleable.reminder}}</strong></span></div><div class=\"clearfix\"></div></div><div ng-show=\"seleable.makeSelection\" class=\"tooltip_recuerda hi\"><img src=\"assets/images/arrow_tooltip.png\" alt=\"\" class=\"arrow_recuerda2 giro\"><div class=\"icon_recordar\"><i class=\"icon-ampolleta\"></i></div><div class=\"mensaje\"><span>Elige tu <strong>{{seleable.reminder}}</strong></span></div><div class=\"clearfix\"></div></div></div><div><div class=\"container_detalle__rolls\" ng-show=\"seleable.product.promotionProducts\"><p>{{seleable.product.name}}</p><span ng-repeat=\"promotionProduct in seleable.product.promotionProducts\">{{promotionProduct.name}} <small ng-show=\"promotionProduct.product_options\">(opciones)</small></span></div><div ng-if=\"seleable.product.upselling && !seleable.makeSelection\" class=\"footer_detalle checkbox_detalle\"><input type=\"checkbox\" id=\"add-upselling\" ng-model=\"seleable.addedUpselling\"> <label for=\"add-upselling\"><p>Agrega: <strong>{{seleable.getUpselling().name}} por {{seleable.price(seleable.getUpselling(), true) | currency:\"$ \":0}}</strong></p></label></div></div></div><div class=\"modal-footer modal_footer_perdidos\" ng-hide=\"seleable.makeSelection\"><div class=\"roll-wrapper\" ng-hide=\"seleable.product\"><span>*</span> deberás elegir una opción</div><button class=\"agregar_mas_pedidos\" ng-click=\"seleable.addToCart()\">Agregar a Mi Pedido <i class=\"icon-arrow_ins_left\"></i></button></div></div>");
$templateCache.put("app/components/footer-cart/desktop/footer-cart.html","<div class=\"all-footer\"><div class=\"container-fluid footer\"><div class=\"container\"><div class=\"col-md-4 col-sm-4 col-xs-4 redes-footer\"><span>Comparte con tus amigos</span><ul><li><a href=\"https://twitter.com/NIUsushi\" target=\"_blank\" class=\"twitter\"><img src=\"assets/images/desktop/twitter.png\" alt=\"twitter\"></a></li><li><a href=\"https://www.facebook.com/niusushi/\" target=\"_blank\" class=\"facebook\"><img src=\"assets/images/desktop/facebook.png\" alt=\"facebook\"></a></li></ul></div><div class=\"col-md-4 col-sm-4 col-xs-4 redes-footer text-center\"><span>¿Contacto? Escríbenos a<br><a href=\"mailto:niusushi@niusushi.cl\">niusushi@niusushi.cl</a></span><br><span>¿Quieres trabajar con nosotros? Escríbenos a<br><a href=\"mailto:CV@niusushi.cl\">CV@niusushi.cl</a></span></div><div class=\"col-md-4 col-sm-4 col-xs-4 redes-footer text-right\"><span>Medios de pago</span><br><br><img src=\"assets/images/desktop/medios-de-pago.png\" alt=\"redcompra\" class=\"img-responsive\"></div></div></div><div class=\"container-fluid end-footer\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><p>Horario de atención: Lunes a sábado en locales de 12:00 a 17:00 y 18:00 a 24:00 hrs y online de 12:00 a 17:00 y 18:00 a 23:00 hrs.</p><span>&copy; NIU Sushi. Todos los derechos reservados.</span><br><a ui-sref=\"tos\">Términos y condiciones</a></div></div></div></div></div>");
$templateCache.put("app/components/footer-cart/mobile/footer-cart.html","<div class=\"container-fluid container-footer footer_ingreso\"><div class=\"col-xs-4 maps\" ui-sref-active=\"active_menu\"><div class=\"container_carta\"><i class=\"icon-libro\"></i> <a ui-sref=\"menu\">Carta</a></div></div><div class=\"col-xs-4 maps\" ui-sref-active=\"active_menu\"><div class=\"container_carta\"><i class=\"icon-maps\"></i> <a ui-sref=\"restaurants\">Locales</a></div></div><div class=\"col-xs-4 maps\" ui-sref-active=\"active_menu\"><div class=\"container_carta\"><i class=\"icon-persona\"></i> <a ui-sref=\"profile\">Mi perfil</a></div></div></div>");
$templateCache.put("app/components/header-cart/desktop/header-cart.html","<div ng-controller=\"MainController as main\" class=\"header-desktop\"><div class=\"container-fluid container-menu header\"><div class=\"container\"><div class=\"col-lg-4 col-lg-offset-0 col-md-2 col-md-offset-0 col-sm-4 col-sm-offset-4 logo\"><div class=\"container-menu-mobile-m\"><button class=\"nav-toggle btn btn-link\" ng-class=\"{\'active\': main.showMenu}\" ng-click=\"main.showMenu = !main.showMenu\"><span></span></button></div><img ui-sref=\"main\" src=\"assets/images/desktop/logo_tr.png\" alt=\"NIU Sushi logo\" height=\"40\"></div><div class=\"col-lg-8 col-md-10 hidden-sm menu-responsive\"><ul class=\"group navbar-menu\"><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"menu\">Carta</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"restaurants\">Locales</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"faq\">Preguntas Frecuentes</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"latestOrders\">Repetir pedidos</a></li></ul><div class=\"registrarse\" ng-if=\"!main.customer\"><a ui-sref=\"signin\" class=\"boton_red\">Ingresar</a></div><div class=\"container-login-user\" ng-click=\"cart.logoutModal()\" ng-if=\"main.customer\"><p>{{main.customer.name.split(\' \')[0].substring(0, 10)}} <i class=\"glyphicon glyphicon-triangle-bottom\"></i></p></div><div class=\"cart-header\" ui-sref=\"cart.whenhowwhere\"><i class=\"icon-comprar shopping-cart\"><input type=\"text\" class=\"prodMas\" ng-value=\"cart.count\" disabled=\"\"></i></div><img src=\"assets/images/dcto-nocache1.svg\" class=\"header-dscto\"></div></div></div><div class=\"container-menu-mobile\" ng-class=\"{\'is-visible\': main.showMenu}\"><div class=\"welcome-name\"><p>¡Bienvenido!</p><span>{{main.customer.name}}</span></div><div class=\"container-btn-perfiles\" ng-if=\"main.customer\"><a ui-sref=\"profile\"><i class=\"icon-persona\"></i><p>Mi Perfil</p></a> <a ui-sref=\"logout\"><img src=\"assets/images/desktop/cerrar.png\" alt=\"cerrar\"><p>Salir</p></a></div><ul><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"menu\">Carta</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"restaurants\">Locales</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"faq\">Preguntas Frecuentes</a></li><li ui-sref-active=\"navbar-selected\"><a ui-sref=\"latestOrders\" ng-click=\"main.showMenu = false\">Repetir pedidos</a></li></ul><a ui-sref=\"signin\" class=\"boton_red registrarse_btn\" ng-click=\"main.showMenu = false\" ng-if=\"!main.customer\">Ingresar</a></div></div>");
$templateCache.put("app/components/header-cart/mobile/header-cart.html","<div class=\"container-fluid header_app\"><div class=\"contianer\"><a class=\"col-xs-4\" ui-sref=\"main\" ng-hide=\"backState\"><img src=\"assets/images/desktop/logo_tr.png\" alt=\"\" width=\"70\"></a> <a class=\"col-xs-4 retroceder\" ui-sref=\"{{backState}}\" ng-if=\"backState\"><i class=\"icon-arrow_ins_right\"></i></a><div class=\"col-xs-8 mi pedido padding-right\"><a ng-show=\"cart.count\" ng-href=\"{{cart.href(cart.cartState())}}\"><span class=\"Pedido_cantidad\">Finalizar&nbsp;</span><span class=\"Pedido_cantidad\">Mi Pedido</span> <i class=\"icon-comprar\"><span ng-show=\"cart.count\" class=\"cantidad_pedido\">{{cart.count}}</span></i></a></div></div></div>");}]);